import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  emptyMapr06gerzljqtm as emptyMap,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  VOID7hggqo3abtya as VOID,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  contains1tccixv8iwdcq as contains,
  createThis2j2avj17cvnv2 as createThis,
  Unit_instanceat14thlj150z as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  toList3jhuyej2anx2q as toList,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  setOf45ia9pnfhe90 as setOf,
  Regexxgw0gjiagf4z as Regex,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toString14fd7g605f91p as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  contains2el4s70rdq4ld as contains_0,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  booleanArray2jdug9b51huk7 as booleanArray,
  numberToChar93r9buh19yek as numberToChar,
  decodeToString1x4faah2liw2p as decodeToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  startsWith1bgirhbedtv2y as startsWith,
  endsWith278181ii8uuo as endsWith,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  toString30pk9tzaqopn as toString_1,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  startsWith26w8qjqapeeq6 as startsWith_0,
  take9j4462mea726 as take,
  repeat2w4c6j8zoq09o as repeat,
  toCharArray32huqyw9tt7kx as toCharArray,
  Char__compareTo_impl_ypi4mb252jweqlvw9s as Char__compareTo_impl_ypi4mb,
  KtMap140uvy3s5zad8 as KtMap,
  isHighSurrogate11jfjw70ar0zf as isHighSurrogate,
  toString1h6jjoch8cjt8 as toString_2,
  concatToString2syawgu50khxi as concatToString,
  StringBuildermazzzhj6kkai as StringBuilder,
  first3kg261hmihapu as first,
  last2n4gf5az1lkn4 as last,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  until1jbpn0z3f8lbg as until,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  NullPointerException3mu0rhxjjitqq as NullPointerException,
  joinToString1cxrrlmo0chqs as joinToString,
  captureStack1fzi4aczwc4hg as captureStack,
  take3onnpy6q7ctcz as take_0,
  emptyList1g2z5xcrvp2zy as emptyList,
  drop3na99dw9feawf as drop,
  takeLast2r8kr8e6g6hi7 as takeLast,
  drop336950s126lmj as drop_0,
  dropLastlqc2oyv04br0 as dropLast,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  trimMarginhyd3fsmh8iev as trimMargin,
  trimIndent1qytc1wvt8suh as trimIndent,
  RuntimeException1r3t0zl97011n as RuntimeException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  get_indices38nlqzzvtaclf as get_indices,
  getOrNull1cdnsfrisdp41 as getOrNull,
  isLowSurrogateujxcv7hjn4ma as isLowSurrogate,
  checkBuilderCapacity1h6g02949wvv as checkBuilderCapacity,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  plus17rl43at52ays as plus,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  toMapcf6xfku344cz as toMap,
  listOfvhqybd2zx248 as listOf,
  distinct10qe1scfdvu5k as distinct,
  last1vo29oleiqj36 as last_0,
  addAll1k27qatfgp3k5 as addAll,
  first6e6strkelovp as first_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  isDigit3mimrri4wkzop as isDigit,
  toInt2q8uldh7sc951 as toInt,
  toInt5qdj874w69jh as toInt_0,
  NumberFormatException3bgsm2s9o4t55 as NumberFormatException,
  CharacterCodingException3mvgnmpleqbz9 as CharacterCodingException,
  filterNotNullhujglslymx1l as filterNotNull,
  getOrNullef5jbxih7r4f as getOrNull_0,
  asList2ho2pewtsfvv as asList,
  coerceAtMost322komnqp70ag as coerceAtMost,
  joinToStringo3uw31d7e8og as joinToString_0,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
} from './kotlin-kotlin-stdlib.mjs';
import { UrlEncoderUtil_getInstance1qxz1r0ptmfgt as UrlEncoderUtil_getInstance } from './urlencoder-urlencoder-lib.mjs';
import {
  Buffer3384y49aj0pxr as Buffer,
  IOException3fje1ukjwthwb as IOException,
  bufferbiiev5vr4b6f as buffer,
  BufferedSource3ezj4539oep1e as BufferedSource,
} from './okio-parent-okio.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  w11() {
    return new DumpSettingsBuilder();
  }
}
class DumpSettings {
  constructor(isExplicitStart, isExplicitEnd, explicitRootTag, anchorGenerator, yamlDirective, tagDirective, defaultFlowStyle, defaultScalarStyle, nonPrintableStyle, schema, isCanonical, isMultiLineFlow, isUseUnicodeEncoding, indent, indicatorIndent, width, bestLineBreak, isSplitLines, maxSimpleKeyLength, customProperties, indentWithIndicator, dumpComments) {
    this.ydf_1 = isExplicitStart;
    this.zdf_1 = isExplicitEnd;
    this.adg_1 = explicitRootTag;
    this.bdg_1 = anchorGenerator;
    this.cdg_1 = yamlDirective;
    this.ddg_1 = tagDirective;
    this.edg_1 = defaultFlowStyle;
    this.fdg_1 = defaultScalarStyle;
    this.gdg_1 = nonPrintableStyle;
    this.hdg_1 = schema;
    this.idg_1 = isCanonical;
    this.jdg_1 = isMultiLineFlow;
    this.kdg_1 = isUseUnicodeEncoding;
    this.ldg_1 = indent;
    this.mdg_1 = indicatorIndent;
    this.ndg_1 = width;
    this.odg_1 = bestLineBreak;
    this.pdg_1 = isSplitLines;
    this.qdg_1 = maxSimpleKeyLength;
    this.rdg_1 = customProperties;
    this.sdg_1 = indentWithIndicator;
    this.tdg_1 = dumpComments;
  }
}
class DumpSettingsBuilder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.udg_1 = LinkedHashMap.wc();
    this.vdg_1 = false;
    this.wdg_1 = false;
    this.xdg_1 = NonPrintableStyle_ESCAPE_getInstance();
    this.ydg_1 = null;
    this.zdg_1 = new NumberAnchorGenerator();
    this.adh_1 = null;
    this.bdh_1 = emptyMap();
    this.cdh_1 = FlowStyle_AUTO_getInstance();
    this.ddh_1 = ScalarStyle_PLAIN_getInstance();
    this.edh_1 = false;
    this.fdh_1 = false;
    this.gdh_1 = true;
    this.hdh_1 = 2;
    this.idh_1 = 0;
    this.jdh_1 = 80;
    this.kdh_1 = '\n';
    this.ldh_1 = true;
    this.mdh_1 = 128;
    this.ndh_1 = false;
    this.odh_1 = false;
    this.pdh_1 = new JsonSchema();
  }
  qdh(indent) {
    var progression = Companion_getInstance_4().tdh_1;
    var containsLower = progression.f2_1;
    if (!(indent <= progression.g2_1 ? containsLower <= indent : false)) {
      throw EmitterException.ddi('Indent must be at in range ' + Companion_getInstance_4().tdh_1.toString());
    }
    this.hdh_1 = indent;
    return this;
  }
  edi(indicatorIndent) {
    var progression = Companion_getInstance_4().udh_1;
    var containsLower = progression.f2_1;
    if (!(indicatorIndent <= progression.g2_1 ? containsLower <= indicatorIndent : false)) {
      throw EmitterException.ddi('Indicator indent must be in range ' + Companion_getInstance_4().udh_1.toString());
    }
    this.idh_1 = indicatorIndent;
    return this;
  }
  fdi(width) {
    this.jdh_1 = width;
    return this;
  }
  gdi(indentWithIndicator) {
    this.ndh_1 = indentWithIndicator;
    return this;
  }
  hdi(dumpComments) {
    this.odh_1 = dumpComments;
    return this;
  }
  idi() {
    return new DumpSettings(this.vdg_1, this.wdg_1, this.ydg_1, this.zdg_1, this.adh_1, this.bdh_1, this.cdh_1, this.ddh_1, this.xdg_1, this.pdh_1, this.edh_1, this.fdh_1, this.gdh_1, this.hdh_1, this.idh_1, this.jdh_1, this.kdh_1, this.ldh_1, this.mdh_1, this.udg_1, this.ndh_1, this.odh_1);
  }
}
class CollectionProvider {}
class SpecVersionMutator {}
class Companion_0 {
  w11() {
    return new LoadSettingsBuilder();
  }
}
class LoadSettings {
  constructor(label, tagConstructors, defaultList, defaultSet, defaultMap, versionFunction, bufferSize, allowDuplicateKeys, allowRecursiveKeys, maxAliasesForCollections, useMarks, customProperties, envConfig, parseComments, codePointLimit, schema) {
    this.kdi_1 = label;
    this.ldi_1 = tagConstructors;
    this.mdi_1 = defaultList;
    this.ndi_1 = defaultSet;
    this.odi_1 = defaultMap;
    this.pdi_1 = versionFunction;
    this.qdi_1 = bufferSize;
    this.rdi_1 = allowDuplicateKeys;
    this.sdi_1 = allowRecursiveKeys;
    this.tdi_1 = maxAliasesForCollections;
    this.udi_1 = useMarks;
    this.vdi_1 = customProperties;
    this.wdi_1 = envConfig;
    this.xdi_1 = parseComments;
    this.ydi_1 = codePointLimit;
    this.zdi_1 = schema;
  }
}
class sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0 {
  constructor(function_0) {
    this.adj_1 = function_0;
  }
  o4() {
    return this.adj_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, CollectionProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0_0 {
  constructor(function_0) {
    this.bdj_1 = function_0;
  }
  o4() {
    return this.bdj_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, CollectionProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0_1 {
  constructor(function_0) {
    this.cdj_1 = function_0;
  }
  o4() {
    return this.cdj_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, CollectionProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_SpecVersionMutator$0 {
  constructor(function_0) {
    this.ddj_1 = function_0;
  }
  jdi(version) {
    return this.ddj_1(version);
  }
  o4() {
    return this.ddj_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SpecVersionMutator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class LoadSettingsBuilder {
  constructor() {
    this.ldj_1 = HashMap.a9();
    this.mdj_1 = 'reader';
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.ndj_1 = LinkedHashMap.wc();
    var tmp_0 = this;
    var tmp_1 = LoadSettingsBuilder$defaultList$lambda;
    tmp_0.odj_1 = new sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0(tmp_1);
    var tmp_2 = this;
    var tmp_3 = LoadSettingsBuilder$defaultSet$lambda;
    tmp_2.pdj_1 = new sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0_0(tmp_3);
    var tmp_4 = this;
    var tmp_5 = LoadSettingsBuilder$defaultMap$lambda;
    tmp_4.qdj_1 = new sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0_1(tmp_5);
    var tmp_6 = this;
    var tmp_7 = LoadSettingsBuilder$versionFunction$lambda;
    tmp_6.rdj_1 = new sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_SpecVersionMutator$0(tmp_7);
    this.sdj_1 = 1024;
    this.tdj_1 = false;
    this.udj_1 = false;
    this.vdj_1 = false;
    this.wdj_1 = 50;
    this.xdj_1 = true;
    this.ydj_1 = null;
    this.zdj_1 = 3145728;
    this.adk_1 = new JsonSchema();
  }
  bdk(label) {
    this.mdj_1 = label;
    return this;
  }
  cdk(codePointLimit) {
    this.zdj_1 = codePointLimit;
    return this;
  }
  idi() {
    return new LoadSettings(this.mdj_1, this.ndj_1, this.odj_1, this.pdj_1, this.qdj_1, this.rdj_1, this.sdj_1, this.tdj_1, this.udj_1, this.wdj_1, this.xdj_1, this.ldj_1, this.ydj_1, this.vdj_1, this.zdj_1, this.adk_1);
  }
}
class StreamDataWriter {}
function flush() {
}
class CommentEventsCollector {
  static odk(eventSource, expectedCommentTypes) {
    var $this = createThis(this);
    $this.hdk_1 = eventSource;
    $this.idk_1 = expectedCommentTypes;
    var tmp = $this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.jdk_1 = ArrayList.z();
    return $this;
  }
  static pdk(eventSource, expectedCommentTypes) {
    return this.odk(EventQueue.sdk(eventSource), expectedCommentTypes);
  }
  tdk() {
    this.udk(null);
    return this;
  }
  udk(event) {
    if (!(event == null)) {
      if (isEventExpected(this, event)) {
        this.jdk_1.h(CommentLine.zdk(event instanceof CommentEvent ? event : THROW_CCE()));
      } else {
        return event;
      }
    }
    while (isEventExpected(this, this.hdk_1.adl())) {
      var e = this.hdk_1.bdl();
      this.jdk_1.h(CommentLine.zdk(e instanceof CommentEvent ? e : THROW_CCE()));
    }
    return null;
  }
  cdl(event) {
    var nextEvent = this.udk(event);
    return nextEvent == null ? this.hdk_1.bdl() : nextEvent;
  }
  ddl() {
    var tmp;
    try {
      tmp = toList(this.jdk_1);
    }finally {
      this.jdk_1.h3();
    }
    return tmp;
  }
  j1() {
    return this.jdk_1.j1();
  }
}
class EventQueue {
  static edl(pollFn, peekFn) {
    var $this = createThis(this);
    $this.qdk_1 = pollFn;
    $this.rdk_1 = peekFn;
    return $this;
  }
  static sdk(eventQueue) {
    var tmp = ArrayDeque$removeFirst$ref(eventQueue);
    return this.edl(tmp, ArrayDeque$firstOrNull$ref(eventQueue));
  }
  bdl() {
    return this.qdk_1();
  }
  adl() {
    return this.rdk_1();
  }
}
class CommentLine {
  static fdl(startMark, endMark, value, commentType) {
    var $this = createThis(this);
    $this.vdk_1 = startMark;
    $this.wdk_1 = endMark;
    $this.xdk_1 = value;
    $this.ydk_1 = commentType;
    return $this;
  }
  static zdk(event) {
    return this.fdl(event.edk_1, event.fdk_1, event.ndk_1, event.mdk_1);
  }
  toString() {
    return '<CommentLine (type=' + this.ydk_1.toString() + ', value=' + this.xdk_1 + ')>';
  }
}
class CommentType extends Enum {}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.gdl_1 = setOf([new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(123)), new Char(_Char___init__impl__6a9atx(125)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(38))]);
    this.hdl_1 = Regex.pi('\\s');
  }
}
class Anchor {
  constructor(value) {
    Companion_getInstance_1();
    this.idl_1 = value;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.idl_1;
    // Inline function 'kotlin.contracts.contract' call
    if (!(charSequenceLength(this_0) > 0)) {
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.common.Anchor.<anonymous>' call
      var message = 'Empty anchor.';
      throw IllegalArgumentException.l(toString(message));
    }
    var indexedObject = this.idl_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (Companion_getInstance_1().gdl_1.z2(new Char(element))) {
        throw EmitterException.ddi("Invalid character '" + toString_0(element) + "' in the anchor: " + this.idl_1);
      }
    }
    if (Companion_getInstance_1().hdl_1.ri(this.idl_1)) {
      throw EmitterException.ddi('Anchor may not contain spaces: ' + this.idl_1);
    }
  }
  toString() {
    return this.idl_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor))
      return false;
    return this.idl_1 === other.idl_1;
  }
  hashCode() {
    return getStringHashCode(this.idl_1);
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    this.jdl_1 = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-_';
    this.kdl_1 = '\n';
    this.ldl_1 = '\r\n';
    this.mdl_1 = '\x00\r\n';
    this.ndl_1 = ' \x00\r\n';
    this.odl_1 = '\t \x00\r\n';
    this.pdl_1 = '\x00 \t';
    this.qdl_1 = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-_-;/?:@&=+$_.!~*'()%";
    this.rdl_1 = new CharConstants('\n');
    this.sdl_1 = new CharConstants('\x00\r\n');
    this.tdl_1 = new CharConstants(' \x00\r\n');
    this.udl_1 = new CharConstants('\t \x00\r\n');
    this.vdl_1 = new CharConstants('\x00 \t');
    this.wdl_1 = new CharConstants("abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-_-;/?:@&=+$_.!~*'()%,[]");
    this.xdl_1 = new CharConstants("abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-_-;/?:@&=+$_.!~*'()%");
    this.ydl_1 = new CharConstants('abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-_');
    this.zdl_1 = 128;
    this.adm_1 = mapOf([to(new Char(_Char___init__impl__6a9atx(48)), '\x00'), to(new Char(_Char___init__impl__6a9atx(97)), '\x07'), to(new Char(_Char___init__impl__6a9atx(98)), '\b'), to(new Char(_Char___init__impl__6a9atx(116)), '\t'), to(new Char(_Char___init__impl__6a9atx(110)), '\n'), to(new Char(_Char___init__impl__6a9atx(118)), '\x0B'), to(new Char(_Char___init__impl__6a9atx(102)), '\f'), to(new Char(_Char___init__impl__6a9atx(114)), '\r'), to(new Char(_Char___init__impl__6a9atx(101)), '\x1B'), to(new Char(_Char___init__impl__6a9atx(32)), ' '), to(new Char(_Char___init__impl__6a9atx(34)), '"'), to(new Char(_Char___init__impl__6a9atx(47)), '/'), to(new Char(_Char___init__impl__6a9atx(92)), '\\'), to(new Char(_Char___init__impl__6a9atx(78)), '\x85'), to(new Char(_Char___init__impl__6a9atx(95)), '\xA0')]);
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.adm_1.u1();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.common.Companion.escapedReplacements.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.v1().n2_1;
      // Inline function 'kotlin.collections.component2' call
      var v = element.w1();
      var pair = to(v, new Char(k));
      destination.k3(pair.nm_1, pair.om_1);
    }
    tmp.bdm_1 = destination;
    this.cdm_1 = mapOf([to(new Char(_Char___init__impl__6a9atx(120)), 2), to(new Char(_Char___init__impl__6a9atx(117)), 4), to(new Char(_Char___init__impl__6a9atx(85)), 8)]);
  }
  ddm(char) {
    var charString = toString_0(char);
    if (contains_0(' /"', char))
      return charString;
    var tmp = this.bdm_1.e3(charString);
    var tmp0_elvis_lhs = tmp == null ? null : tmp.n2_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new Char(tmp_1)) == null) {
      return charString;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var escaped = tmp_0;
    return '\\' + toString_0(escaped);
  }
}
class CharConstants {
  constructor(content) {
    Companion_getInstance_2();
    // Inline function 'kotlin.text.map' call
    // Inline function 'kotlin.text.mapTo' call
    var destination = ArrayList.w(charSequenceLength(content));
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(content)) {
      var item = charSequenceGet(content, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.common.CharConstants.<anonymous>' call
      // Inline function 'kotlin.code' call
      var tmp$ret$1 = Char__toInt_impl_vasixd(item);
      destination.h(tmp$ret$1);
    }
    var contentCodes = destination;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = booleanArray(128);
    while (tmp_0 < 128) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = contentCodes.z2(tmp_2);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.edm_1 = tmp_1;
  }
  fdm(c) {
    return c < 128 && this.edm_1[c];
  }
  gdm(c) {
    return !this.fdm(c);
  }
  hdm(c, additional) {
    return this.fdm(c) || contains_0(additional, numberToChar(c));
  }
  idm(c, additional) {
    return !this.hdm(c, additional);
  }
}
class FlowStyle extends Enum {}
class NonPrintableStyle extends Enum {}
class ScalarStyle extends Enum {
  constructor(name, ordinal, styleOpt) {
    super(name, ordinal);
    this.ldm_1 = styleOpt;
  }
  toString() {
    var tmp0_elvis_lhs = this.ldm_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
      tmp = _Char___init__impl__6a9atx(58);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toString_0(tmp);
  }
}
class SpecVersion {
  constructor(major, minor) {
    this.jdj_1 = major;
    this.kdj_1 = minor;
  }
  mdm() {
    return '' + this.jdj_1 + '.' + this.kdj_1;
  }
  toString() {
    return 'Version{major=' + this.jdj_1 + ', minor=' + this.kdj_1 + '}';
  }
}
class UriEncoder {
  constructor() {
    this.ndm_1 = "-_.!~*'()@:$&,;=[]/";
  }
  k2b(uri) {
    return urlEncode(this, uri);
  }
  odm(buff) {
    var content = decodeToString(buff.sde());
    return this.d2b(content);
  }
  d2b(buff) {
    return urlDecode(this, buff);
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.pdm_1 = mapOf([to('true', true), to('false', false)]);
  }
}
class ConstructScalar {
  constructor() {
    Companion_getInstance_3();
  }
}
class ConstructYamlNull extends ConstructScalar {}
class ConstructYamlBinary extends ConstructScalar {}
class ConstructYamlJsonBool extends ConstructScalar {}
class ConstructYamlJsonFloat extends ConstructScalar {}
class ConstructYamlJsonInt extends ConstructScalar {}
class ExpectStreamStart {
  constructor($outer) {
    this.ldo_1 = $outer;
  }
  mdo() {
    var tmp19_safe_receiver = this.ldo_1.adn_1;
    if (equals(tmp19_safe_receiver == null ? null : tmp19_safe_receiver.gdk(), ID_StreamStart_getInstance())) {
      writeStreamStart(this.ldo_1);
      this.ldo_1.ydm_1 = new ExpectFirstDocumentStart(this.ldo_1);
    } else {
      throw EmitterException.ddi('expected StreamStartEvent, but got ' + toString_1(this.ldo_1.adn_1));
    }
  }
}
class ExpectNothing {
  constructor($outer) {
    this.ndo_1 = $outer;
  }
  mdo() {
    throw EmitterException.ddi('expecting nothing, but got ' + toString_1(this.ndo_1.adn_1));
  }
}
class ExpectFirstDocumentStart {
  constructor($outer) {
    this.odo_1 = $outer;
  }
  mdo() {
    return (new ExpectDocumentStart(this.odo_1, true)).mdo();
  }
}
class ExpectDocumentStart {
  constructor($outer, first) {
    this.ydn_1 = $outer;
    this.xdn_1 = first;
  }
  mdo() {
    var tmp20_safe_receiver = this.ydn_1.adn_1;
    if (equals(tmp20_safe_receiver == null ? null : tmp20_safe_receiver.gdk(), ID_DocumentStart_getInstance())) {
      var tmp = this.ydn_1.adn_1;
      var ev = tmp instanceof DocumentStartEvent ? tmp : THROW_CCE();
      handleDocumentStartEvent(this, ev);
      this.ydn_1.ydm_1 = new ExpectDocumentRoot(this.ydn_1);
    } else {
      var tmp21_safe_receiver = this.ydn_1.adn_1;
      if (equals(tmp21_safe_receiver == null ? null : tmp21_safe_receiver.gdk(), ID_StreamEnd_getInstance())) {
        writeStreamEnd(this.ydn_1);
        this.ydn_1.ydm_1 = new ExpectNothing(this.ydn_1);
      } else {
        var tmp_0 = this.ydn_1.adn_1;
        if (tmp_0 instanceof CommentEvent) {
          this.ydn_1.vdn_1.udk(this.ydn_1.adn_1);
          writeBlockComment(this.ydn_1);
        } else {
          throw EmitterException.ddi('expected DocumentStartEvent, but got ' + toString_1(this.ydn_1.adn_1));
        }
      }
    }
  }
}
class ExpectDocumentEnd {
  constructor($outer) {
    this.pdo_1 = $outer;
  }
  mdo() {
    this.pdo_1.adn_1 = this.pdo_1.vdn_1.cdl(this.pdo_1.adn_1);
    writeBlockComment(this.pdo_1);
    var tmp23_safe_receiver = this.pdo_1.adn_1;
    if (equals(tmp23_safe_receiver == null ? null : tmp23_safe_receiver.gdk(), ID_DocumentEnd_getInstance())) {
      writeIndent(this.pdo_1);
      var tmp = this.pdo_1.adn_1;
      if ((tmp instanceof DocumentEndEvent ? tmp : THROW_CCE()).sdo_1) {
        writeIndicator$default(this.pdo_1, '...', true);
        writeIndent(this.pdo_1);
      }
      flushStream(this.pdo_1);
      this.pdo_1.ydm_1 = new ExpectDocumentStart(this.pdo_1, false);
    } else {
      throw EmitterException.ddi('expected DocumentEndEvent, but got ' + toString_1(this.pdo_1.adn_1));
    }
  }
}
class ExpectDocumentRoot {
  constructor($outer) {
    this.tdo_1 = $outer;
  }
  mdo() {
    this.tdo_1.adn_1 = this.tdo_1.vdn_1.cdl(this.tdo_1.adn_1);
    if (!this.tdo_1.vdn_1.j1()) {
      writeBlockComment(this.tdo_1);
      var tmp = this.tdo_1.adn_1;
      if (tmp instanceof DocumentEndEvent) {
        (new ExpectDocumentEnd(this.tdo_1)).mdo();
        return Unit_instance;
      }
    }
    this.tdo_1.xdm_1.pl(new ExpectDocumentEnd(this.tdo_1));
    expectNode$default(this.tdo_1, true);
  }
}
class ExpectFirstFlowSequenceItem {
  constructor($outer) {
    this.bdp_1 = $outer;
  }
  mdo() {
    var tmp28_safe_receiver = this.bdp_1.adn_1;
    if (equals(tmp28_safe_receiver == null ? null : tmp28_safe_receiver.gdk(), ID_SequenceEnd_getInstance())) {
      this.bdp_1.cdn_1 = this.bdp_1.bdn_1.tl();
      var _unary__edvuaz = this.bdp_1.ddn_1;
      this.bdp_1.ddn_1 = _unary__edvuaz - 1 | 0;
      writeIndicator$default(this.bdp_1, ']');
      this.bdp_1.wdn_1.tdk();
      writeInlineComments(this.bdp_1);
      this.bdp_1.ydm_1 = this.bdp_1.xdm_1.sl();
    } else {
      var tmp = this.bdp_1.adn_1;
      if (tmp instanceof CommentEvent) {
        this.bdp_1.vdn_1.udk(this.bdp_1.adn_1);
        writeBlockComment(this.bdp_1);
      } else {
        if (this.bdp_1.ldn_1 || (this.bdp_1.hdn_1 > this.bdp_1.pdn_1 && _get_splitLines__1he196(this.bdp_1)) || this.bdp_1.mdn_1) {
          writeIndent(this.bdp_1);
        }
        this.bdp_1.xdm_1.pl(new ExpectFlowSequenceItem(this.bdp_1));
        expectNode$default(this.bdp_1);
        this.bdp_1.adn_1 = this.bdp_1.wdn_1.udk(this.bdp_1.adn_1);
        writeInlineComments(this.bdp_1);
      }
    }
  }
}
class ExpectFlowSequenceItem {
  constructor($outer) {
    this.cdp_1 = $outer;
  }
  mdo() {
    var tmp29_safe_receiver = this.cdp_1.adn_1;
    if (equals(tmp29_safe_receiver == null ? null : tmp29_safe_receiver.gdk(), ID_SequenceEnd_getInstance())) {
      this.cdp_1.cdn_1 = this.cdp_1.bdn_1.tl();
      var _unary__edvuaz = this.cdp_1.ddn_1;
      this.cdp_1.ddn_1 = _unary__edvuaz - 1 | 0;
      if (this.cdp_1.ldn_1) {
        writeIndicator$default(this.cdp_1, ',');
        writeIndent(this.cdp_1);
      } else if (this.cdp_1.mdn_1) {
        writeIndent(this.cdp_1);
      }
      writeIndicator$default(this.cdp_1, ']');
      this.cdp_1.wdn_1.tdk();
      writeInlineComments(this.cdp_1);
      if (this.cdp_1.mdn_1) {
        writeIndent(this.cdp_1);
      }
      this.cdp_1.ydm_1 = this.cdp_1.xdm_1.sl();
    } else {
      var tmp = this.cdp_1.adn_1;
      if (tmp instanceof CommentEvent) {
        this.cdp_1.adn_1 = this.cdp_1.vdn_1.udk(this.cdp_1.adn_1);
      } else {
        writeIndicator$default(this.cdp_1, ',');
        writeBlockComment(this.cdp_1);
        if (this.cdp_1.ldn_1 || (this.cdp_1.hdn_1 > this.cdp_1.pdn_1 && _get_splitLines__1he196(this.cdp_1)) || this.cdp_1.mdn_1) {
          writeIndent(this.cdp_1);
        }
        this.cdp_1.xdm_1.pl(new ExpectFlowSequenceItem(this.cdp_1));
        expectNode$default(this.cdp_1);
        this.cdp_1.adn_1 = this.cdp_1.wdn_1.udk(this.cdp_1.adn_1);
        writeInlineComments(this.cdp_1);
      }
    }
  }
}
class ExpectFirstFlowMappingKey {
  constructor($outer) {
    this.ddp_1 = $outer;
  }
  mdo() {
    this.ddp_1.adn_1 = this.ddp_1.vdn_1.cdl(this.ddp_1.adn_1);
    writeBlockComment(this.ddp_1);
    var tmp30_safe_receiver = this.ddp_1.adn_1;
    if (equals(tmp30_safe_receiver == null ? null : tmp30_safe_receiver.gdk(), ID_MappingEnd_getInstance())) {
      this.ddp_1.cdn_1 = this.ddp_1.bdn_1.tl();
      var _unary__edvuaz = this.ddp_1.ddn_1;
      this.ddp_1.ddn_1 = _unary__edvuaz - 1 | 0;
      writeIndicator$default(this.ddp_1, '}');
      this.ddp_1.wdn_1.tdk();
      writeInlineComments(this.ddp_1);
      this.ddp_1.ydm_1 = this.ddp_1.xdm_1.sl();
    } else {
      if (this.ddp_1.ldn_1 || (this.ddp_1.hdn_1 > this.ddp_1.pdn_1 && _get_splitLines__1he196(this.ddp_1)) || this.ddp_1.mdn_1) {
        writeIndent(this.ddp_1);
      }
      if (!this.ddp_1.ldn_1 && checkSimpleKey(this.ddp_1)) {
        this.ddp_1.xdm_1.pl(new ExpectFlowMappingSimpleValue(this.ddp_1));
        expectNode$default(this.ddp_1, VOID, true, true);
      } else {
        writeIndicator$default(this.ddp_1, '?', true);
        this.ddp_1.xdm_1.pl(new ExpectFlowMappingValue(this.ddp_1));
        expectNode$default(this.ddp_1, VOID, true);
      }
    }
  }
}
class ExpectFlowMappingKey {
  constructor($outer) {
    this.edp_1 = $outer;
  }
  mdo() {
    var tmp31_safe_receiver = this.edp_1.adn_1;
    if (equals(tmp31_safe_receiver == null ? null : tmp31_safe_receiver.gdk(), ID_MappingEnd_getInstance())) {
      this.edp_1.cdn_1 = this.edp_1.bdn_1.tl();
      var _unary__edvuaz = this.edp_1.ddn_1;
      this.edp_1.ddn_1 = _unary__edvuaz - 1 | 0;
      if (this.edp_1.ldn_1) {
        writeIndicator$default(this.edp_1, ',');
        writeIndent(this.edp_1);
      }
      if (this.edp_1.mdn_1) {
        writeIndent(this.edp_1);
      }
      writeIndicator$default(this.edp_1, '}');
      this.edp_1.wdn_1.tdk();
      writeInlineComments(this.edp_1);
      this.edp_1.ydm_1 = this.edp_1.xdm_1.sl();
    } else {
      writeIndicator$default(this.edp_1, ',');
      this.edp_1.adn_1 = this.edp_1.vdn_1.cdl(this.edp_1.adn_1);
      writeBlockComment(this.edp_1);
      if (this.edp_1.ldn_1 || (this.edp_1.hdn_1 > this.edp_1.pdn_1 && _get_splitLines__1he196(this.edp_1)) || this.edp_1.mdn_1) {
        writeIndent(this.edp_1);
      }
      if (!this.edp_1.ldn_1 && checkSimpleKey(this.edp_1)) {
        this.edp_1.xdm_1.pl(new ExpectFlowMappingSimpleValue(this.edp_1));
        expectNode$default(this.edp_1, VOID, true, true);
      } else {
        writeIndicator$default(this.edp_1, '?', true);
        this.edp_1.xdm_1.pl(new ExpectFlowMappingValue(this.edp_1));
        expectNode$default(this.edp_1, VOID, true);
      }
    }
  }
}
class ExpectFlowMappingSimpleValue {
  constructor($outer) {
    this.fdp_1 = $outer;
  }
  mdo() {
    writeIndicator$default(this.fdp_1, ':');
    this.fdp_1.adn_1 = this.fdp_1.wdn_1.cdl(this.fdp_1.adn_1);
    writeInlineComments(this.fdp_1);
    this.fdp_1.xdm_1.pl(new ExpectFlowMappingKey(this.fdp_1));
    expectNode$default(this.fdp_1, VOID, true);
    this.fdp_1.wdn_1.udk(this.fdp_1.adn_1);
    writeInlineComments(this.fdp_1);
  }
}
class ExpectFlowMappingValue {
  constructor($outer) {
    this.gdp_1 = $outer;
  }
  mdo() {
    if (this.gdp_1.ldn_1 || this.gdp_1.hdn_1 > this.gdp_1.pdn_1 || this.gdp_1.mdn_1) {
      writeIndent(this.gdp_1);
    }
    writeIndicator$default(this.gdp_1, ':', true);
    this.gdp_1.adn_1 = this.gdp_1.wdn_1.cdl(this.gdp_1.adn_1);
    writeInlineComments(this.gdp_1);
    this.gdp_1.xdm_1.pl(new ExpectFlowMappingKey(this.gdp_1));
    expectNode$default(this.gdp_1, VOID, true);
    this.gdp_1.wdn_1.udk(this.gdp_1.adn_1);
    writeInlineComments(this.gdp_1);
  }
}
class ExpectFirstBlockSequenceItem {
  constructor($outer) {
    this.hdp_1 = $outer;
  }
  mdo() {
    return (new ExpectBlockSequenceItem(this.hdp_1, true)).mdo();
  }
}
class ExpectBlockSequenceItem {
  constructor($outer, first) {
    this.jdp_1 = $outer;
    this.idp_1 = first;
  }
  mdo() {
    var tmp;
    if (!this.idp_1) {
      var tmp32_safe_receiver = this.jdp_1.adn_1;
      tmp = equals(tmp32_safe_receiver == null ? null : tmp32_safe_receiver.gdk(), ID_SequenceEnd_getInstance());
    } else {
      tmp = false;
    }
    if (tmp) {
      this.jdp_1.cdn_1 = this.jdp_1.bdn_1.tl();
      this.jdp_1.ydm_1 = this.jdp_1.xdm_1.sl();
    } else {
      var tmp_0 = this.jdp_1.adn_1;
      if (tmp_0 instanceof CommentEvent) {
        this.jdp_1.vdn_1.udk(this.jdp_1.adn_1);
      } else {
        writeIndent(this.jdp_1);
        if (!_get_indentWithIndicator__nfeqac(this.jdp_1) || this.idp_1) {
          writeWhitespace(this.jdp_1, _get_indicatorIndent__dy1exi(this.jdp_1));
        }
        writeIndicator$default(this.jdp_1, '-', true, VOID, true);
        if (_get_indentWithIndicator__nfeqac(this.jdp_1) && this.idp_1) {
          this.jdp_1.cdn_1 = ensureNotNull(this.jdp_1.cdn_1) + _get_indicatorIndent__dy1exi(this.jdp_1) | 0;
        }
        if (!this.jdp_1.vdn_1.j1()) {
          increaseIndent$default(this.jdp_1);
          writeBlockComment(this.jdp_1);
          var tmp_1 = this.jdp_1.adn_1;
          if (tmp_1 instanceof ScalarEvent) {
            var tmp_2 = this.jdp_1;
            var tmp_3 = this.jdp_1.adn_1;
            tmp_2.tdn_1 = analyzeScalar(this.jdp_1, (tmp_3 instanceof ScalarEvent ? tmp_3 : THROW_CCE()).gdo_1);
            if (!ensureNotNull(this.jdp_1.tdn_1).ldp_1) {
              writeIndent(this.jdp_1);
            }
          }
          this.jdp_1.cdn_1 = this.jdp_1.bdn_1.tl();
        }
        this.jdp_1.xdm_1.pl(new ExpectBlockSequenceItem(this.jdp_1, false));
        expectNode$default(this.jdp_1);
        this.jdp_1.wdn_1.tdk();
        writeInlineComments(this.jdp_1);
      }
    }
  }
}
class ExpectFirstBlockMappingKey {
  constructor($outer) {
    this.rdp_1 = $outer;
  }
  mdo() {
    (new ExpectBlockMappingKey(this.rdp_1, true)).mdo();
  }
}
class ExpectBlockMappingKey {
  constructor($outer, first) {
    this.tdp_1 = $outer;
    this.sdp_1 = first;
  }
  mdo() {
    this.tdp_1.adn_1 = this.tdp_1.vdn_1.cdl(this.tdp_1.adn_1);
    writeBlockComment(this.tdp_1);
    var tmp;
    if (!this.sdp_1) {
      var tmp33_safe_receiver = this.tdp_1.adn_1;
      tmp = equals(tmp33_safe_receiver == null ? null : tmp33_safe_receiver.gdk(), ID_MappingEnd_getInstance());
    } else {
      tmp = false;
    }
    if (tmp) {
      this.tdp_1.cdn_1 = this.tdp_1.bdn_1.tl();
      this.tdp_1.ydm_1 = this.tdp_1.xdm_1.sl();
    } else {
      writeIndent(this.tdp_1);
      if (checkSimpleKey(this.tdp_1)) {
        this.tdp_1.xdm_1.pl(new ExpectBlockMappingSimpleValue(this.tdp_1));
        expectNode$default(this.tdp_1, VOID, true, true);
      } else {
        writeIndicator$default(this.tdp_1, '?', true, VOID, true);
        this.tdp_1.xdm_1.pl(new ExpectBlockMappingValue(this.tdp_1));
        expectNode$default(this.tdp_1, VOID, true);
      }
    }
  }
}
class ExpectBlockMappingSimpleValue {
  constructor($outer) {
    this.udp_1 = $outer;
  }
  mdo() {
    writeIndicator$default(this.udp_1, ':');
    this.udp_1.adn_1 = this.udp_1.wdn_1.cdl(this.udp_1.adn_1);
    if (!isFoldedOrLiteral(this, ensureNotNull(this.udp_1.adn_1))) {
      if (writeInlineComments(this.udp_1)) {
        increaseIndent$default(this.udp_1, true);
        writeIndent(this.udp_1);
        this.udp_1.cdn_1 = this.udp_1.bdn_1.tl();
      }
    }
    this.udp_1.adn_1 = this.udp_1.vdn_1.cdl(this.udp_1.adn_1);
    if (!this.udp_1.vdn_1.j1()) {
      increaseIndent$default(this.udp_1, true);
      writeBlockComment(this.udp_1);
      writeIndent(this.udp_1);
      this.udp_1.cdn_1 = this.udp_1.bdn_1.tl();
    }
    this.udp_1.xdm_1.pl(new ExpectBlockMappingKey(this.udp_1, false));
    expectNode$default(this.udp_1, VOID, true);
    this.udp_1.wdn_1.tdk();
    writeInlineComments(this.udp_1);
  }
}
class ExpectBlockMappingValue {
  constructor($outer) {
    this.vdp_1 = $outer;
  }
  mdo() {
    writeIndent(this.vdp_1);
    writeIndicator$default(this.vdp_1, ':', true, VOID, true);
    this.vdp_1.adn_1 = this.vdp_1.wdn_1.cdl(this.vdp_1.adn_1);
    writeInlineComments(this.vdp_1);
    this.vdp_1.adn_1 = this.vdp_1.vdn_1.cdl(this.vdp_1.adn_1);
    writeBlockComment(this.vdp_1);
    this.vdp_1.xdm_1.pl(new ExpectBlockMappingKey(this.vdp_1, false));
    expectNode$default(this.vdp_1, VOID, true);
    this.vdp_1.wdn_1.udk(this.vdp_1.adn_1);
    writeInlineComments(this.vdp_1);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.rdh_1 = mapOf([to(new Char(_Char___init__impl__6a9atx(0)), '0'), to(new Char(_Char___init__impl__6a9atx(7)), 'a'), to(new Char(_Char___init__impl__6a9atx(8)), 'b'), to(new Char(_Char___init__impl__6a9atx(9)), 't'), to(new Char(_Char___init__impl__6a9atx(10)), 'n'), to(new Char(_Char___init__impl__6a9atx(11)), 'v'), to(new Char(_Char___init__impl__6a9atx(12)), 'f'), to(new Char(_Char___init__impl__6a9atx(13)), 'r'), to(new Char(_Char___init__impl__6a9atx(27)), 'e'), to(new Char(_Char___init__impl__6a9atx(34)), '"'), to(new Char(_Char___init__impl__6a9atx(92)), '\\'), to(new Char(_Char___init__impl__6a9atx(133)), 'N'), to(new Char(_Char___init__impl__6a9atx(160)), '_')]);
    this.sdh_1 = mapOf([to('!', '!'), to('tag:yaml.org,2002:', '!!')]);
    this.tdh_1 = numberRangeToNumber(1, 10);
    this.udh_1 = until(this.tdh_1.f2_1 - 1 | 0, this.tdh_1.g2_1);
    this.vdh_1 = 2;
    this.wdh_1 = 80;
    this.xdh_1 = ' ';
    this.ydh_1 = Regex.pi('^![-_\\w]*!$');
  }
}
class Emitter {
  constructor(opts, stream) {
    Companion_getInstance_4();
    this.vdm_1 = opts;
    this.wdm_1 = stream;
    this.xdm_1 = ArrayDeque.kl(100);
    this.ydm_1 = new ExpectStreamStart(this);
    this.zdm_1 = ArrayDeque.kl(100);
    this.adn_1 = null;
    this.bdn_1 = ArrayDeque.kl(100);
    this.cdn_1 = null;
    this.ddn_1 = 0;
    this.edn_1 = false;
    this.fdn_1 = false;
    this.gdn_1 = false;
    this.hdn_1 = 0;
    this.idn_1 = true;
    this.jdn_1 = true;
    this.kdn_1 = false;
    this.ldn_1 = this.vdm_1.idg_1;
    this.mdn_1 = this.vdm_1.jdg_1;
    this.ndn_1 = this.vdm_1.kdg_1;
    var tmp = this;
    var tmp_0;
    var progression = Companion_getInstance_4().tdh_1;
    var containsLower = progression.f2_1;
    var containsUpper = progression.g2_1;
    var containsArg = this.vdm_1.ldg_1;
    if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
      tmp_0 = this.vdm_1.ldg_1;
    } else {
      tmp_0 = 2;
    }
    tmp.odn_1 = tmp_0;
    this.pdn_1 = this.vdm_1.ndg_1 > imul(this.odn_1, 2) ? this.vdm_1.ndg_1 : 80;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.qdn_1 = LinkedHashMap.wc();
    this.rdn_1 = null;
    this.sdn_1 = null;
    this.tdn_1 = null;
    this.udn_1 = null;
    this.vdn_1 = CommentEventsCollector.pdk(this.zdm_1, [CommentType_BLANK_LINE_getInstance(), CommentType_BLOCK_getInstance()]);
    this.wdn_1 = CommentEventsCollector.pdk(this.zdm_1, [CommentType_IN_LINE_getInstance()]);
  }
  pdq(event) {
    this.zdm_1.h(event);
    while (!needMoreEvents(this)) {
      this.adn_1 = this.zdm_1.ql();
      this.ydm_1.mdo();
      this.adn_1 = null;
    }
  }
  zdn(versionText) {
    this.wdm_1.d1l('%YAML ' + versionText);
    writeLineBreak$default(this);
  }
  ado(handleText, prefixText) {
    this.wdm_1.d1l('%TAG ' + handleText + ' ' + prefixText);
    writeLineBreak$default(this);
  }
}
class ScalarAnalysis {
  constructor(scalar, empty, multiline, allowFlowPlain, allowBlockPlain, allowSingleQuoted, allowBlock) {
    this.kdp_1 = scalar;
    this.ldp_1 = empty;
    this.mdp_1 = multiline;
    this.ndp_1 = allowFlowPlain;
    this.odp_1 = allowBlockPlain;
    this.pdp_1 = allowSingleQuoted;
    this.qdp_1 = allowBlock;
  }
}
class Event {
  static zdq(startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    var $this = createThis(this);
    $this.edk_1 = startMark;
    $this.fdk_1 = endMark;
    if (!($this.edk_1 == null) && $this.fdk_1 == null || ($this.edk_1 == null && !($this.fdk_1 == null))) {
      throw NullPointerException.uf('Both marks must be either present or absent.');
    }
    return $this;
  }
}
class NodeEvent extends Event {
  static vdq(anchor, startMark, endMark) {
    var $this = this.zdq(startMark, endMark);
    $this.kdo_1 = anchor;
    return $this;
  }
}
class AliasEvent extends NodeEvent {
  static udq(anchor, startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    var $this = this.vdq(anchor, startMark, endMark);
    var tmp = $this;
    var tmp_0;
    if (anchor == null) {
      throw NullPointerException.uf('Anchor is required in AliasEvent');
    } else {
      tmp_0 = anchor;
    }
    tmp.tdq_1 = tmp_0;
    return $this;
  }
  gdk() {
    return ID_Alias_getInstance();
  }
  toString() {
    return '=ALI *' + this.tdq_1.toString();
  }
}
class CollectionEndEvent extends Event {
  static ydq(startMark, endMark) {
    var $this = this.zdq(startMark, endMark);
    init_it_krzeminski_snakeyaml_engine_kmp_events_CollectionEndEvent($this);
    return $this;
  }
  static adr() {
    var $this = this.zdq();
    init_it_krzeminski_snakeyaml_engine_kmp_events_CollectionEndEvent($this);
    return $this;
  }
}
class CollectionStartEvent extends NodeEvent {
  static bdr(anchor, tag, implicit, flowStyle, startMark, endMark) {
    var $this = this.vdq(anchor, startMark, endMark);
    $this.xdo_1 = tag;
    $this.ydo_1 = implicit;
    $this.zdo_1 = flowStyle;
    return $this;
  }
  adp() {
    return FlowStyle_FLOW_getInstance().equals(this.zdo_1);
  }
  wdp() {
    return this.ydo_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.CollectionStartEvent.toString.<anonymous>' call
    if (!(this.kdo_1 == null)) {
      this_0.gc(' &' + toString_1(this.kdo_1));
    }
    if (!this.ydo_1) {
      if (!(this.xdo_1 == null)) {
        this_0.gc(' <' + this.xdo_1 + '>');
      }
    }
    return this_0.toString();
  }
}
class CommentEvent extends Event {
  static cdr(commentType, value, startMark, endMark) {
    var $this = this.zdq(startMark, endMark);
    $this.mdk_1 = commentType;
    $this.ndk_1 = value;
    return $this;
  }
  gdk() {
    return ID_Comment_getInstance();
  }
  toString() {
    return '=COM ' + this.mdk_1.toString() + ' ' + this.ndk_1;
  }
}
class DocumentEndEvent extends Event {
  static ddr(isExplicit, startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    var $this = this.zdq(startMark, endMark);
    $this.sdo_1 = isExplicit;
    return $this;
  }
  gdk() {
    return ID_DocumentEnd_getInstance();
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.DocumentEndEvent.toString.<anonymous>' call
    this_0.gc('-DOC');
    if (this.sdo_1) {
      this_0.gc(' ...');
    }
    return this_0.toString();
  }
}
class DocumentStartEvent extends Event {
  static edr(explicit, specVersion, tags, startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    var $this = this.zdq(startMark, endMark);
    $this.sdm_1 = explicit;
    $this.tdm_1 = specVersion;
    $this.udm_1 = tags;
    return $this;
  }
  gdk() {
    return ID_DocumentStart_getInstance();
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.DocumentStartEvent.toString.<anonymous>' call
    this_0.gc('+DOC');
    if (this.sdm_1) {
      this_0.gc(' ---');
    }
    return this_0.toString();
  }
}
class ID extends Enum {}
class ImplicitTuple {
  constructor(plain, nonPlain) {
    this.xdp_1 = plain;
    this.ydp_1 = nonPlain;
  }
  zdp() {
    return this.xdp_1;
  }
  adq() {
    return this.ydp_1;
  }
  fdr() {
    return !this.xdp_1 && !this.ydp_1;
  }
  toString() {
    return 'implicit=[' + this.xdp_1 + ', ' + this.ydp_1 + ']';
  }
}
class MappingEndEvent extends CollectionEndEvent {
  static idr(startMark, endMark) {
    var $this = this.ydq(startMark, endMark);
    init_it_krzeminski_snakeyaml_engine_kmp_events_MappingEndEvent($this);
    return $this;
  }
  static jdr() {
    var $this = this.adr();
    init_it_krzeminski_snakeyaml_engine_kmp_events_MappingEndEvent($this);
    return $this;
  }
  gdk() {
    return ID_MappingEnd_getInstance();
  }
  toString() {
    return '-MAP';
  }
}
class MappingStartEvent extends CollectionStartEvent {
  static qdr(anchor, tag, implicit, flowStyle, startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    return this.bdr(anchor, tag, implicit, flowStyle, startMark, endMark);
  }
  gdk() {
    return ID_MappingStart_getInstance();
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.MappingStartEvent.toString.<anonymous>' call
    this_0.gc('+MAP');
    if (this.zdo_1.equals(FlowStyle_FLOW_getInstance())) {
      this_0.gc(' {}');
    }
    this_0.gc(super.toString());
    return this_0.toString();
  }
}
class ScalarEvent extends NodeEvent {
  static rdr(anchor, tag, implicit, value, scalarStyle, startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    var $this = this.vdq(anchor, startMark, endMark);
    $this.edo_1 = tag;
    $this.fdo_1 = implicit;
    $this.gdo_1 = value;
    $this.hdo_1 = scalarStyle;
    return $this;
  }
  gdk() {
    return ID_Scalar_getInstance();
  }
  bdq() {
    return this.hdo_1.equals(ScalarStyle_PLAIN_getInstance());
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.ScalarEvent.toString.<anonymous>' call
    this_0.gc('=VAL');
    if (!(this.kdo_1 == null)) {
      this_0.gc(' &' + toString_1(this.kdo_1));
    }
    if (this.fdo_1.fdr()) {
      if (!(this.edo_1 == null)) {
        this_0.gc(' <' + this.edo_1 + '>');
      }
    }
    this_0.gc(' ');
    this_0.gc(this.hdo_1.toString());
    this_0.gc(this.sdr());
    return this_0.toString();
  }
  sdr() {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = toCodePoints(this.gdo_1);
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.ScalarEvent.escapedValue.<anonymous>' call
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(65535);
      if (element < Char__toInt_impl_vasixd(this_1)) {
        destination.h(element);
      }
    }
    var tmp = destination;
    return joinToString(tmp, '', VOID, VOID, VOID, VOID, ScalarEvent$escapedValue$lambda);
  }
}
class SequenceEndEvent extends CollectionEndEvent {
  static vdr(startMark, endMark) {
    var $this = this.ydq(startMark, endMark);
    init_it_krzeminski_snakeyaml_engine_kmp_events_SequenceEndEvent($this);
    return $this;
  }
  static wdr() {
    var $this = this.adr();
    init_it_krzeminski_snakeyaml_engine_kmp_events_SequenceEndEvent($this);
    return $this;
  }
  gdk() {
    return ID_SequenceEnd_getInstance();
  }
  toString() {
    return '-SEQ';
  }
}
class SequenceStartEvent extends CollectionStartEvent {
  static dds(anchor, tag, implicit, flowStyle, startMark, endMark) {
    startMark = startMark === VOID ? null : startMark;
    endMark = endMark === VOID ? null : endMark;
    return this.bdr(anchor, tag, implicit, flowStyle, startMark, endMark);
  }
  gdk() {
    return ID_SequenceStart_getInstance();
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.events.SequenceStartEvent.toString.<anonymous>' call
    this_0.gc('+SEQ');
    if (this.zdo_1.equals(FlowStyle_FLOW_getInstance())) {
      this_0.gc(' []');
    }
    this_0.gc(super.toString());
    return this_0.toString();
  }
}
class StreamEndEvent extends Event {
  static gds(startMark, endMark) {
    var $this = this.zdq(startMark, endMark);
    init_it_krzeminski_snakeyaml_engine_kmp_events_StreamEndEvent($this);
    return $this;
  }
  static hds() {
    var $this = this.zdq();
    init_it_krzeminski_snakeyaml_engine_kmp_events_StreamEndEvent($this);
    return $this;
  }
  gdk() {
    return ID_StreamEnd_getInstance();
  }
  toString() {
    return '-STR';
  }
}
class StreamStartEvent extends Event {
  static kds(startMark, endMark) {
    var $this = this.zdq(startMark, endMark);
    init_it_krzeminski_snakeyaml_engine_kmp_events_StreamStartEvent($this);
    return $this;
  }
  static lds() {
    var $this = this.zdq();
    init_it_krzeminski_snakeyaml_engine_kmp_events_StreamStartEvent($this);
    return $this;
  }
  gdk() {
    return ID_StreamStart_getInstance();
  }
  toString() {
    return '+STR';
  }
}
class YamlEngineException extends RuntimeException {
  static fdq(message) {
    var $this = this.bb(message);
    init_it_krzeminski_snakeyaml_engine_kmp_exceptions_YamlEngineException($this);
    return $this;
  }
  static hdu(cause) {
    var $this = this.af(cause);
    init_it_krzeminski_snakeyaml_engine_kmp_exceptions_YamlEngineException($this);
    return $this;
  }
  static edt(message, cause) {
    var $this = this.ue(message, cause);
    init_it_krzeminski_snakeyaml_engine_kmp_exceptions_YamlEngineException($this);
    return $this;
  }
}
class EmitterException extends YamlEngineException {
  static ddi(msg) {
    var $this = this.fdq(msg);
    captureStack($this, $this.cdi_1);
    return $this;
  }
}
class Companion_5 {
  constructor() {
    this.mds_1 = ' ... ';
  }
}
class Mark {
  constructor(name, index, line, column, codepoints, pointer) {
    pointer = pointer === VOID ? 0 : pointer;
    this.nds_1 = name;
    this.ods_1 = index;
    this.pds_1 = line;
    this.qds_1 = column;
    this.rds_1 = codepoints;
    this.sds_1 = pointer;
  }
  tds(indentSize, maxLength) {
    var halfMaxLength = maxLength / 2 | 0;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlin.collections.takeLastWhile' call
      var this_0 = take_0(this.rds_1, this.sds_1);
      if (this_0.j1()) {
        tmp$ret$0 = emptyList();
        break $l$block_1;
      }
      var iterator = this_0.k1(this_0.g1());
      while (iterator.e7()) {
        // Inline function 'it.krzeminski.snakeyaml.engine.kmp.exceptions.Mark.createSnippet.<anonymous>' call
        var it = iterator.g7();
        if (!!isLineBreak(this, it)) {
          iterator.d1();
          var expectedSize = this_0.g1() - iterator.f7() | 0;
          if (expectedSize === 0) {
            tmp$ret$0 = emptyList();
            break $l$block_1;
          }
          // Inline function 'kotlin.apply' call
          var this_1 = ArrayList.w(expectedSize);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.takeLastWhile.<anonymous>' call
          while (iterator.c1()) {
            this_1.h(iterator.d1());
          }
          tmp$ret$0 = this_1;
          break $l$block_1;
        }
      }
      tmp$ret$0 = toList(this_0);
    }
    var lineBeforePointer = joinCodepointsToString(tmp$ret$0);
    // Inline function 'kotlin.collections.takeWhile' call
    var this_2 = drop(this.rds_1, this.sds_1);
    var list = ArrayList.z();
    var tmp0_iterator = this_2.b1();
    $l$loop: while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.exceptions.Mark.createSnippet.<anonymous>' call
      if (!!isLineBreak(this, item))
        break $l$loop;
      list.h(item);
    }
    var lineAfterPointer = joinCodepointsToString(list);
    var tmp;
    if (lineBeforePointer.length > halfMaxLength) {
      tmp = ' ... ' + drop_0(takeLast(lineBeforePointer, halfMaxLength), 5);
    } else {
      tmp = lineBeforePointer;
    }
    var head = tmp;
    var tmp_0;
    if (lineAfterPointer.length > halfMaxLength) {
      tmp_0 = dropLast(take(lineAfterPointer, halfMaxLength), 5) + ' ... ';
    } else {
      tmp_0 = lineAfterPointer;
    }
    var tail = tmp_0;
    var indent = repeat(' ', indentSize);
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_3 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.exceptions.Mark.createSnippet.<anonymous>' call
    this_3.gc(indent);
    this_3.gc(head);
    this_3.gc(tail);
    // Inline function 'kotlin.text.appendLine' call
    this_3.hc(_Char___init__impl__6a9atx(10));
    this_3.gc(indent);
    this_3.gc(repeat(' ', head.length));
    this_3.gc('^');
    return this_3.toString();
  }
  uds(indentSize, maxLength, $super) {
    indentSize = indentSize === VOID ? 4 : indentSize;
    maxLength = maxLength === VOID ? 75 : maxLength;
    return $super === VOID ? this.tds(indentSize, maxLength) : $super.tds.call(this, indentSize, maxLength);
  }
  toString() {
    var snippet = this.uds();
    // Inline function 'kotlin.text.trim' call
    var this_0 = this.nds_1;
    var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    return trimMargin('\n            | in ' + tmp$ret$0 + ', line ' + (this.pds_1 + 1 | 0) + ', column ' + (this.qds_1 + 1 | 0) + ':\n            |' + snippet + '\n        ');
  }
}
class Companion_6 {}
class MarkedYamlEngineException extends YamlEngineException {
  static ddt(context, contextMark, problem, problemMark, cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.edt(buildReadableError(Companion_instance_6, context, contextMark, problem, problemMark), cause);
    captureStack($this, $this.cdt_1);
    $this.yds_1 = context;
    $this.zds_1 = contextMark;
    $this.adt_1 = problem;
    $this.bdt_1 = problemMark;
    return $this;
  }
}
class ParserException extends MarkedYamlEngineException {
  static odt(problem, contextMark, context, problemMark, cause) {
    context = context === VOID ? null : context;
    problemMark = problemMark === VOID ? null : problemMark;
    cause = cause === VOID ? null : cause;
    var $this = this.ddt(context, contextMark, problem, problemMark, cause);
    captureStack($this, $this.ndt_1);
    return $this;
  }
}
class ReaderException extends YamlEngineException {
  static wdt(name, position, codePoint, message) {
    var $this = this.fdq(message);
    captureStack($this, $this.vdt_1);
    $this.sdt_1 = name;
    $this.tdt_1 = position;
    $this.udt_1 = codePoint;
    return $this;
  }
  toString() {
    var s = concatToString(Character_getInstance().ndq(this.udt_1));
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var charHex = toString_2(this.udt_1, 16).toUpperCase();
    return trimIndent("\n             unacceptable code point '" + s + "' (0x" + charHex + ') ' + this.message + '\n             in "' + this.sdt_1 + '", position ' + this.tdt_1 + '\n             ');
  }
}
class ScannerException extends MarkedYamlEngineException {
  static gdu(problem, problemMark, context, contextMark, cause) {
    context = context === VOID ? null : context;
    contextMark = contextMark === VOID ? null : contextMark;
    cause = cause === VOID ? null : cause;
    var $this = this.ddt(context, contextMark, problem, problemMark, cause);
    captureStack($this, $this.fdu_1);
    return $this;
  }
}
class YamlVersionException extends YamlEngineException {
  static idj(specVersion) {
    var $this = this.fdq(specVersion.toString());
    captureStack($this, $this.hdj_1);
    return $this;
  }
}
class Character {
  constructor() {
    Character_instance = this;
    this.gdq_1 = 0;
    this.hdq_1 = 1114111;
    this.idq_1 = 65536;
    this.jdq_1 = -56613888;
    this.kdq_1 = _Char___init__impl__6a9atx(55232);
  }
  ldu(codePoint) {
    return 65536 <= codePoint ? codePoint <= 1114111 : false;
  }
  ldq(codePoint) {
    return codePoint <= 65536 ? 1 : 2;
  }
  mdu(highSurrogate, lowSurrogate) {
    return isHighSurrogate(highSurrogate) && isLowSurrogate(lowSurrogate);
  }
  mdq(highSurrogate, lowSurrogate) {
    // Inline function 'kotlin.code' call
    var tmp = Char__toInt_impl_vasixd(highSurrogate) << 10;
    // Inline function 'kotlin.code' call
    return (tmp + Char__toInt_impl_vasixd(lowSurrogate) | 0) + -56613888 | 0;
  }
  ndq(codePoint) {
    var tmp;
    if (this.kdu(codePoint)) {
      // Inline function 'kotlin.charArrayOf' call
      tmp = charArrayOf([numberToChar(codePoint)]);
    } else {
      var hi = this.idu(codePoint);
      var lo = this.jdu(codePoint);
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.mdu(hi, lo)) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException.l(toString(message));
      }
      // Inline function 'kotlin.charArrayOf' call
      tmp = charArrayOf([hi, lo]);
    }
    return tmp;
  }
  kdu(codePoint) {
    return (codePoint >>> 16 | 0) === 0;
  }
  idu(codePoint) {
    var tmp = codePoint >>> 10 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(55232);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    return numberToChar(tmp + tmp$ret$0 | 0);
  }
  jdu(codePoint) {
    var tmp = codePoint & 1023;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(56320);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    return numberToChar(tmp + tmp$ret$0 | 0);
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.ndu_1 = 'tag:yaml.org,2002:';
    this.odu_1 = new Tag('tag:yaml.org,2002:set');
    this.pdu_1 = new Tag('tag:yaml.org,2002:binary');
    this.qdu_1 = new Tag('tag:yaml.org,2002:int');
    this.rdu_1 = new Tag('tag:yaml.org,2002:float');
    this.sdu_1 = new Tag('tag:yaml.org,2002:bool');
    this.tdu_1 = new Tag('tag:yaml.org,2002:null');
    this.udu_1 = new Tag('tag:yaml.org,2002:str');
    this.vdu_1 = new Tag('tag:yaml.org,2002:seq');
    this.wdu_1 = new Tag('tag:yaml.org,2002:map');
    this.xdu_1 = new Tag('tag:yaml.org,2002:comment');
    this.ydu_1 = new Tag('!ENV_VARIABLE');
  }
}
class Tag {
  constructor(tag) {
    Companion_getInstance_7();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(charSequenceLength(tag) > 0)) {
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.nodes.Tag.<anonymous>' call
      var message = 'Tag must not be empty.';
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.trim' call
    var this_0 = isCharSequence(tag) ? tag : THROW_CCE();
    var startIndex = 0;
    var endIndex = charSequenceLength(this_0) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.nodes.Tag.<anonymous>' call
      var it = charSequenceGet(this_0, index);
      var match = Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(32)) <= 0;
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    var tmp$ret$3 = charSequenceSubSequence(this_0, startIndex, endIndex + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    if (!(toString(tmp$ret$3).length === tag.length)) {
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.nodes.Tag.<anonymous>' call
      var message_0 = 'Tag must not contain leading or trailing spaces.';
      throw IllegalArgumentException.l(toString(message_0));
    }
    this.zdu_1 = UriEncoder_instance.k2b(tag);
  }
  toString() {
    return this.zdu_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Tag) {
      tmp = this.zdu_1 === other.zdu_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return getStringHashCode(this.zdu_1);
  }
}
class ParseStreamStart {
  constructor($outer) {
    this.pdw_1 = $outer;
  }
  hdv() {
    var tmp = this.pdw_1.bdv_1.d1();
    var token = tmp instanceof StreamStartToken ? tmp : THROW_CCE();
    var event = StreamStartEvent.kds(token.mdv_1, token.ndv_1);
    this.pdw_1.fdv_1 = new ParseImplicitDocumentStart(this.pdw_1);
    return event;
  }
}
class ParseImplicitDocumentStart {
  constructor($outer) {
    this.qdw_1 = $outer;
  }
  hdv() {
    if (this.qdw_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.qdw_1.fdv_1 = new ParseImplicitDocumentStart(this.qdw_1);
      var tmp = this.qdw_1.bdv_1.d1();
      return produceCommentEvent(this.qdw_1, tmp instanceof CommentToken ? tmp : THROW_CCE());
    }
    var tmp_0;
    if (!this.qdw_1.bdv_1.odv([ID_Directive_getInstance(), ID_DocumentStart_getInstance_0(), ID_StreamEnd_getInstance_0()])) {
      var token = this.qdw_1.bdv_1.fdw();
      var startMark = token.mdv_1;
      this.qdw_1.cdv_1.pl(new ParseDocumentEnd(this.qdw_1));
      this.qdw_1.fdv_1 = new ParseBlockNode(this.qdw_1);
      tmp_0 = DocumentStartEvent.edr(false, null, emptyMap(), startMark, startMark);
    } else {
      tmp_0 = (new ParseDocumentStart(this.qdw_1)).hdv();
    }
    return tmp_0;
  }
}
class ParseDocumentStart {
  constructor($outer) {
    this.rdw_1 = $outer;
  }
  hdv() {
    if (this.rdw_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.rdw_1.fdv_1 = new ParseDocumentStart(this.rdw_1);
      var tmp = this.rdw_1.bdv_1.d1();
      return produceCommentEvent(this.rdw_1, tmp instanceof CommentToken ? tmp : THROW_CCE());
    }
    while (this.rdw_1.bdv_1.odv([ID_DocumentEnd_getInstance_0()])) {
      this.rdw_1.bdv_1.d1();
    }
    if (this.rdw_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.rdw_1.fdv_1 = new ParseDocumentStart(this.rdw_1);
      var tmp_0 = this.rdw_1.bdv_1.d1();
      return produceCommentEvent(this.rdw_1, tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
    }
    if (!this.rdw_1.bdv_1.odv([ID_StreamEnd_getInstance_0()])) {
      this.rdw_1.bdv_1.sdw();
      var tuple = processDirectives(this.rdw_1);
      while (this.rdw_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
        this.rdw_1.bdv_1.d1();
      }
      var tmp_1;
      if (!this.rdw_1.bdv_1.odv([ID_StreamEnd_getInstance_0()])) {
        if (!this.rdw_1.bdv_1.odv([ID_DocumentStart_getInstance_0()])) {
          throw ParserException.odt("expected '<document start>', but found '" + this.rdw_1.bdv_1.fdw().gdw().toString() + "'", this.rdw_1.bdv_1.fdw().mdv_1);
        }
        var token = this.rdw_1.bdv_1.d1();
        var startMark = token.mdv_1;
        var endMark = token.ndv_1;
        this.rdw_1.cdv_1.pl(new ParseDocumentEnd(this.rdw_1));
        this.rdw_1.fdv_1 = new ParseDocumentContent(this.rdw_1);
        tmp_1 = DocumentStartEvent.edr(true, tuple.tdw_1, tuple.udw_1, startMark, endMark);
      } else {
        throw ParserException.odt("expected '<document start>', but found '" + this.rdw_1.bdv_1.fdw().gdw().toString() + "'", this.rdw_1.bdv_1.fdw().mdv_1);
      }
      return tmp_1;
    }
    var tmp_2 = this.rdw_1.bdv_1.d1();
    var token_0 = tmp_2 instanceof StreamEndToken ? tmp_2 : THROW_CCE();
    if (!this.rdw_1.cdv_1.j1()) {
      throw YamlEngineException.fdq('Unexpected end of stream. States left: ' + this.rdw_1.cdv_1.toString());
    }
    if (!this.rdw_1.ddv_1.j1()) {
      throw YamlEngineException.fdq('Unexpected end of stream. Marks left: ' + this.rdw_1.ddv_1.toString());
    }
    this.rdw_1.fdv_1 = null;
    return StreamEndEvent.gds(token_0.mdv_1, token_0.ndv_1);
  }
}
class ParseDocumentEnd {
  constructor($outer) {
    this.vdw_1 = $outer;
  }
  hdv() {
    var token = this.vdw_1.bdv_1.fdw();
    var startMark = token.mdv_1;
    var endMark;
    var explicit;
    if (this.vdw_1.bdv_1.odv([ID_DocumentEnd_getInstance_0()])) {
      token = this.vdw_1.bdv_1.d1();
      endMark = token.ndv_1;
      explicit = true;
    } else if (this.vdw_1.bdv_1.odv([ID_Directive_getInstance()])) {
      throw ParserException.odt("expected '<document end>' before directives, but found '" + this.vdw_1.bdv_1.fdw().gdw().toString() + "'", this.vdw_1.bdv_1.fdw().mdv_1);
    } else {
      endMark = token.mdv_1;
      explicit = false;
    }
    this.vdw_1.gdv_1.h3();
    this.vdw_1.fdv_1 = new ParseDocumentStart(this.vdw_1);
    return DocumentEndEvent.ddr(explicit, startMark, endMark);
  }
}
class ParseDocumentContent {
  constructor($outer) {
    this.wdw_1 = $outer;
  }
  hdv() {
    var tmp;
    if (this.wdw_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.wdw_1.fdv_1 = new ParseDocumentContent(this.wdw_1);
      var tmp_0 = this.wdw_1.bdv_1.d1();
      return produceCommentEvent(this.wdw_1, tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
    } else if (this.wdw_1.bdv_1.odv([ID_Directive_getInstance(), ID_DocumentStart_getInstance_0(), ID_DocumentEnd_getInstance_0(), ID_StreamEnd_getInstance_0()])) {
      this.wdw_1.fdv_1 = this.wdw_1.cdv_1.sl();
      var event = processEmptyScalar(this.wdw_1, this.wdw_1.bdv_1.fdw().mdv_1);
      tmp = event;
    } else {
      tmp = (new ParseBlockNode(this.wdw_1)).hdv();
    }
    return tmp;
  }
}
class ParseBlockNode {
  constructor($outer) {
    this.xdw_1 = $outer;
  }
  hdv() {
    return parseNode(this.xdw_1, true, false);
  }
}
class ParseBlockSequenceFirstEntry {
  constructor($outer) {
    this.ydw_1 = $outer;
  }
  hdv() {
    var token = this.ydw_1.bdv_1.d1();
    markPush(this.ydw_1, token.mdv_1);
    return (new ParseBlockSequenceEntryKey(this.ydw_1)).hdv();
  }
}
class ParseBlockSequenceEntryKey {
  constructor($outer) {
    this.zdw_1 = $outer;
  }
  hdv() {
    var tmp;
    if (this.zdw_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.zdw_1.fdv_1 = new ParseBlockSequenceEntryKey(this.zdw_1);
      var tmp_0 = this.zdw_1.bdv_1.d1();
      tmp = produceCommentEvent(this.zdw_1, tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
    } else if (this.zdw_1.bdv_1.odv([ID_BlockEntry_getInstance()])) {
      var tmp_1 = this.zdw_1.bdv_1.d1();
      var token = tmp_1 instanceof BlockEntryToken ? tmp_1 : THROW_CCE();
      tmp = (new ParseBlockSequenceEntryValue(this.zdw_1, token)).hdv();
    } else if (!this.zdw_1.bdv_1.odv([ID_BlockEnd_getInstance()])) {
      var token_0 = this.zdw_1.bdv_1.fdw();
      throw ParserException.odt("expected <block end>, but found '" + token_0.gdw().toString() + "'", markPop(this.zdw_1), 'while parsing a block collection', token_0.mdv_1);
    } else {
      var token_1 = this.zdw_1.bdv_1.d1();
      this.zdw_1.fdv_1 = this.zdw_1.cdv_1.sl();
      markPop(this.zdw_1);
      tmp = SequenceEndEvent.vdr(token_1.mdv_1, token_1.ndv_1);
    }
    return tmp;
  }
}
class ParseBlockSequenceEntryValue {
  constructor($outer, token) {
    this.bdx_1 = $outer;
    this.adx_1 = token;
  }
  hdv() {
    if (this.bdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.bdx_1.fdv_1 = new ParseBlockSequenceEntryValue(this.bdx_1, this.adx_1);
      var tmp = this.bdx_1.bdv_1.d1();
      return produceCommentEvent(this.bdx_1, tmp instanceof CommentToken ? tmp : THROW_CCE());
    }
    var tmp_0;
    if (!this.bdx_1.bdv_1.odv([ID_BlockEntry_getInstance(), ID_BlockEnd_getInstance()])) {
      this.bdx_1.cdv_1.pl(new ParseBlockSequenceEntryKey(this.bdx_1));
      tmp_0 = (new ParseBlockNode(this.bdx_1)).hdv();
    } else {
      this.bdx_1.fdv_1 = new ParseBlockSequenceEntryKey(this.bdx_1);
      tmp_0 = processEmptyScalar(this.bdx_1, this.adx_1.ndv_1);
    }
    return tmp_0;
  }
}
class ParseIndentlessSequenceEntryKey {
  constructor($outer) {
    this.cdx_1 = $outer;
  }
  hdv() {
    if (this.cdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.cdx_1.fdv_1 = new ParseIndentlessSequenceEntryKey(this.cdx_1);
      var tmp = this.cdx_1.bdv_1.d1();
      return produceCommentEvent(this.cdx_1, tmp instanceof CommentToken ? tmp : THROW_CCE());
    }
    if (this.cdx_1.bdv_1.odv([ID_BlockEntry_getInstance()])) {
      var tmp_0 = this.cdx_1.bdv_1.d1();
      var token = tmp_0 instanceof BlockEntryToken ? tmp_0 : THROW_CCE();
      return (new ParseIndentlessSequenceEntryValue(this.cdx_1, token)).hdv();
    }
    var token_0 = this.cdx_1.bdv_1.fdw();
    this.cdx_1.fdv_1 = this.cdx_1.cdv_1.sl();
    return SequenceEndEvent.vdr(token_0.mdv_1, token_0.ndv_1);
  }
}
class ParseIndentlessSequenceEntryValue {
  constructor($outer, token) {
    this.edx_1 = $outer;
    this.ddx_1 = token;
  }
  hdv() {
    var tmp;
    if (this.edx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.edx_1.fdv_1 = new ParseIndentlessSequenceEntryValue(this.edx_1, this.ddx_1);
      var tmp_0 = this.edx_1.bdv_1.d1();
      tmp = produceCommentEvent(this.edx_1, tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
    } else if (!this.edx_1.bdv_1.odv([ID_BlockEntry_getInstance(), ID_Key_getInstance(), ID_Value_getInstance(), ID_BlockEnd_getInstance()])) {
      this.edx_1.cdv_1.pl(new ParseIndentlessSequenceEntryKey(this.edx_1));
      tmp = (new ParseBlockNode(this.edx_1)).hdv();
    } else {
      this.edx_1.fdv_1 = new ParseIndentlessSequenceEntryKey(this.edx_1);
      tmp = processEmptyScalar(this.edx_1, this.ddx_1.ndv_1);
    }
    return tmp;
  }
}
class ParseBlockMappingFirstKey {
  constructor($outer) {
    this.fdx_1 = $outer;
  }
  hdv() {
    var token = this.fdx_1.bdv_1.d1();
    markPush(this.fdx_1, token.mdv_1);
    return (new ParseBlockMappingKey(this.fdx_1)).hdv();
  }
}
class ParseBlockMappingKey {
  constructor($outer) {
    this.gdx_1 = $outer;
  }
  hdv() {
    var tmp;
    if (this.gdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.gdx_1.fdv_1 = new ParseBlockMappingKey(this.gdx_1);
      var tmp_0 = this.gdx_1.bdv_1.d1();
      tmp = produceCommentEvent(this.gdx_1, tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
    } else if (this.gdx_1.bdv_1.odv([ID_Key_getInstance()])) {
      var token = this.gdx_1.bdv_1.d1();
      var tmp_1;
      if (!this.gdx_1.bdv_1.odv([ID_Key_getInstance(), ID_Value_getInstance(), ID_BlockEnd_getInstance()])) {
        this.gdx_1.cdv_1.pl(new ParseBlockMappingValue(this.gdx_1));
        tmp_1 = parseBlockNodeOrIndentlessSequence(this.gdx_1);
      } else {
        this.gdx_1.fdv_1 = new ParseBlockMappingValue(this.gdx_1);
        tmp_1 = processEmptyScalar(this.gdx_1, token.ndv_1);
      }
      tmp = tmp_1;
    } else if (!this.gdx_1.bdv_1.odv([ID_BlockEnd_getInstance()])) {
      var token_0 = this.gdx_1.bdv_1.fdw();
      throw ParserException.odt("expected <block end>, but found '" + token_0.gdw().toString() + "'", markPop(this.gdx_1), 'while parsing a block mapping', token_0.mdv_1);
    } else {
      var token_1 = this.gdx_1.bdv_1.d1();
      this.gdx_1.fdv_1 = this.gdx_1.cdv_1.sl();
      markPop(this.gdx_1);
      tmp = MappingEndEvent.idr(token_1.mdv_1, token_1.ndv_1);
    }
    return tmp;
  }
}
class ParseBlockMappingValue {
  constructor($outer) {
    this.hdx_1 = $outer;
  }
  hdv() {
    if (this.hdx_1.bdv_1.odv([ID_Value_getInstance()])) {
      var token = this.hdx_1.bdv_1.d1();
      var tmp;
      if (this.hdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
        var p = new ParseBlockMappingValueComment(this.hdx_1);
        this.hdx_1.fdv_1 = p;
        tmp = p.hdv();
      } else if (!this.hdx_1.bdv_1.odv([ID_Key_getInstance(), ID_Value_getInstance(), ID_BlockEnd_getInstance()])) {
        this.hdx_1.cdv_1.pl(new ParseBlockMappingKey(this.hdx_1));
        tmp = parseBlockNodeOrIndentlessSequence(this.hdx_1);
      } else {
        this.hdx_1.fdv_1 = new ParseBlockMappingKey(this.hdx_1);
        tmp = processEmptyScalar(this.hdx_1, token.ndv_1);
      }
      return tmp;
    } else if (this.hdx_1.bdv_1.odv([ID_Scalar_getInstance_0()])) {
      this.hdx_1.cdv_1.pl(new ParseBlockMappingKey(this.hdx_1));
      return parseBlockNodeOrIndentlessSequence(this.hdx_1);
    }
    this.hdx_1.fdv_1 = new ParseBlockMappingKey(this.hdx_1);
    var token_0 = this.hdx_1.bdv_1.fdw();
    return processEmptyScalar(this.hdx_1, token_0.mdv_1);
  }
}
class ParseBlockMappingValueComment {
  constructor($outer) {
    this.jdx_1 = $outer;
    this.idx_1 = ArrayDeque.ll();
  }
  hdv() {
    var tmp;
    if (this.jdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      var tmp_0 = this.jdx_1.bdv_1.d1();
      this.idx_1.h(tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
      tmp = this.hdv();
    } else if (!this.jdx_1.bdv_1.odv([ID_Key_getInstance(), ID_Value_getInstance(), ID_BlockEnd_getInstance()])) {
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.idx_1.j1()) {
        tmp_1 = produceCommentEvent(this.jdx_1, this.idx_1.ql());
      } else {
        this.jdx_1.cdv_1.pl(new ParseBlockMappingKey(this.jdx_1));
        tmp_1 = parseBlockNodeOrIndentlessSequence(this.jdx_1);
      }
      tmp = tmp_1;
    } else {
      this.jdx_1.fdv_1 = new ParseBlockMappingValueCommentList(this.jdx_1, this.idx_1);
      tmp = processEmptyScalar(this.jdx_1, this.jdx_1.bdv_1.fdw().mdv_1);
    }
    return tmp;
  }
}
class ParseBlockMappingValueCommentList {
  constructor($outer, tokens) {
    this.ldx_1 = $outer;
    this.kdx_1 = tokens;
  }
  hdv() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.kdx_1.j1()) {
      tmp = produceCommentEvent(this.ldx_1, this.kdx_1.ql());
    } else {
      tmp = (new ParseBlockMappingKey(this.ldx_1)).hdv();
    }
    return tmp;
  }
}
class ParseFlowSequenceFirstEntry {
  constructor($outer) {
    this.mdx_1 = $outer;
  }
  hdv() {
    var token = this.mdx_1.bdv_1.d1();
    markPush(this.mdx_1, token.mdv_1);
    return (new ParseFlowSequenceEntry(this.mdx_1, true)).hdv();
  }
}
class ParseFlowSequenceEntry {
  constructor($outer, first) {
    this.odx_1 = $outer;
    this.ndx_1 = first;
  }
  hdv() {
    if (this.odx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.odx_1.fdv_1 = new ParseFlowSequenceEntry(this.odx_1, this.ndx_1);
      var tmp = this.odx_1.bdv_1.d1();
      return produceCommentEvent(this.odx_1, tmp instanceof CommentToken ? tmp : THROW_CCE());
    }
    if (!this.odx_1.bdv_1.odv([ID_FlowSequenceEnd_getInstance()])) {
      if (!this.ndx_1) {
        if (this.odx_1.bdv_1.odv([ID_FlowEntry_getInstance()])) {
          this.odx_1.bdv_1.d1();
          if (this.odx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
            this.odx_1.fdv_1 = new ParseFlowSequenceEntry(this.odx_1, true);
            var tmp_0 = this.odx_1.bdv_1.d1();
            return produceCommentEvent(this.odx_1, tmp_0 instanceof CommentToken ? tmp_0 : THROW_CCE());
          }
        } else {
          var token = this.odx_1.bdv_1.fdw();
          throw ParserException.odt("expected ',' or ']', but got " + token.gdw().toString(), markPop(this.odx_1), 'while parsing a flow sequence', token.mdv_1);
        }
      }
      if (this.odx_1.bdv_1.odv([ID_Key_getInstance()])) {
        var token_0 = this.odx_1.bdv_1.fdw();
        this.odx_1.fdv_1 = new ParseFlowSequenceEntryMappingKey(this.odx_1);
        return MappingStartEvent.qdr(null, null, true, FlowStyle_FLOW_getInstance(), token_0.mdv_1, token_0.ndv_1);
      } else if (!this.odx_1.bdv_1.odv([ID_FlowSequenceEnd_getInstance()])) {
        this.odx_1.cdv_1.pl(new ParseFlowSequenceEntry(this.odx_1, false));
        return parseFlowNode(this.odx_1);
      }
    }
    var token_1 = this.odx_1.bdv_1.d1();
    var tmp_1 = this.odx_1;
    var tmp_2;
    if (!this.odx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      tmp_2 = this.odx_1.cdv_1.sl();
    } else {
      tmp_2 = new ParseFlowEndComment(this.odx_1);
    }
    tmp_1.fdv_1 = tmp_2;
    markPop(this.odx_1);
    return SequenceEndEvent.vdr(token_1.mdv_1, token_1.ndv_1);
  }
}
class ParseFlowEndComment {
  constructor($outer) {
    this.pdx_1 = $outer;
  }
  hdv() {
    var tmp = this.pdx_1.bdv_1.d1();
    var event = produceCommentEvent(this.pdx_1, tmp instanceof CommentToken ? tmp : THROW_CCE());
    if (!this.pdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      this.pdx_1.fdv_1 = this.pdx_1.cdv_1.sl();
    }
    return event;
  }
}
class ParseFlowSequenceEntryMappingKey {
  constructor($outer) {
    this.qdx_1 = $outer;
  }
  hdv() {
    var token = this.qdx_1.bdv_1.d1();
    var tmp;
    if (!this.qdx_1.bdv_1.odv([ID_Value_getInstance(), ID_FlowEntry_getInstance(), ID_FlowSequenceEnd_getInstance()])) {
      this.qdx_1.cdv_1.pl(new ParseFlowSequenceEntryMappingValue(this.qdx_1));
      tmp = parseFlowNode(this.qdx_1);
    } else {
      this.qdx_1.fdv_1 = new ParseFlowSequenceEntryMappingValue(this.qdx_1);
      tmp = processEmptyScalar(this.qdx_1, token.ndv_1);
    }
    return tmp;
  }
}
class ParseFlowSequenceEntryMappingValue {
  constructor($outer) {
    this.rdx_1 = $outer;
  }
  hdv() {
    var tmp;
    if (this.rdx_1.bdv_1.odv([ID_Value_getInstance()])) {
      var token = this.rdx_1.bdv_1.d1();
      var tmp_0;
      if (!this.rdx_1.bdv_1.odv([ID_FlowEntry_getInstance(), ID_FlowSequenceEnd_getInstance()])) {
        this.rdx_1.cdv_1.pl(new ParseFlowSequenceEntryMappingEnd(this.rdx_1));
        tmp_0 = parseFlowNode(this.rdx_1);
      } else {
        this.rdx_1.fdv_1 = new ParseFlowSequenceEntryMappingEnd(this.rdx_1);
        tmp_0 = processEmptyScalar(this.rdx_1, token.ndv_1);
      }
      tmp = tmp_0;
    } else {
      this.rdx_1.fdv_1 = new ParseFlowSequenceEntryMappingEnd(this.rdx_1);
      var token_0 = this.rdx_1.bdv_1.fdw();
      tmp = processEmptyScalar(this.rdx_1, token_0.mdv_1);
    }
    return tmp;
  }
}
class ParseFlowSequenceEntryMappingEnd {
  constructor($outer) {
    this.sdx_1 = $outer;
  }
  hdv() {
    this.sdx_1.fdv_1 = new ParseFlowSequenceEntry(this.sdx_1, false);
    var token = this.sdx_1.bdv_1.fdw();
    return MappingEndEvent.idr(token.mdv_1, token.ndv_1);
  }
}
class ParseFlowMappingFirstKey {
  constructor($outer) {
    this.tdx_1 = $outer;
  }
  hdv() {
    var token = this.tdx_1.bdv_1.d1();
    markPush(this.tdx_1, token.mdv_1);
    return (new ParseFlowMappingKey(this.tdx_1, true)).hdv();
  }
}
class ParseFlowMappingKey {
  constructor($outer, first) {
    this.vdx_1 = $outer;
    this.udx_1 = first;
  }
  hdv() {
    if (!this.vdx_1.bdv_1.odv([ID_FlowMappingEnd_getInstance()])) {
      if (!this.udx_1) {
        if (this.vdx_1.bdv_1.odv([ID_FlowEntry_getInstance()])) {
          this.vdx_1.bdv_1.d1();
        } else {
          var token = this.vdx_1.bdv_1.fdw();
          throw ParserException.odt("expected ',' or '}', but got " + token.gdw().toString(), markPop(this.vdx_1), 'while parsing a flow mapping', token.mdv_1);
        }
      }
      if (this.vdx_1.bdv_1.odv([ID_Key_getInstance()])) {
        var token_0 = this.vdx_1.bdv_1.d1();
        var tmp;
        if (!this.vdx_1.bdv_1.odv([ID_Value_getInstance(), ID_FlowEntry_getInstance(), ID_FlowMappingEnd_getInstance()])) {
          this.vdx_1.cdv_1.pl(new ParseFlowMappingValue(this.vdx_1));
          tmp = parseFlowNode(this.vdx_1);
        } else {
          this.vdx_1.fdv_1 = new ParseFlowMappingValue(this.vdx_1);
          tmp = processEmptyScalar(this.vdx_1, token_0.ndv_1);
        }
        return tmp;
      } else if (!this.vdx_1.bdv_1.odv([ID_FlowMappingEnd_getInstance()])) {
        this.vdx_1.cdv_1.pl(new ParseFlowMappingEmptyValue(this.vdx_1));
        return parseFlowNode(this.vdx_1);
      }
    }
    var token_1 = this.vdx_1.bdv_1.d1();
    markPop(this.vdx_1);
    var tmp_0 = this.vdx_1;
    var tmp_1;
    if (!this.vdx_1.bdv_1.odv([ID_Comment_getInstance_0()])) {
      tmp_1 = this.vdx_1.cdv_1.sl();
    } else {
      tmp_1 = new ParseFlowEndComment(this.vdx_1);
    }
    tmp_0.fdv_1 = tmp_1;
    return MappingEndEvent.idr(token_1.mdv_1, token_1.ndv_1);
  }
}
class ParseFlowMappingValue {
  constructor($outer) {
    this.wdx_1 = $outer;
  }
  hdv() {
    var tmp;
    if (this.wdx_1.bdv_1.odv([ID_Value_getInstance()])) {
      var token = this.wdx_1.bdv_1.d1();
      var tmp_0;
      if (!this.wdx_1.bdv_1.odv([ID_FlowEntry_getInstance(), ID_FlowMappingEnd_getInstance()])) {
        this.wdx_1.cdv_1.pl(new ParseFlowMappingKey(this.wdx_1, false));
        tmp_0 = parseFlowNode(this.wdx_1);
      } else {
        this.wdx_1.fdv_1 = new ParseFlowMappingKey(this.wdx_1, false);
        tmp_0 = processEmptyScalar(this.wdx_1, token.ndv_1);
      }
      tmp = tmp_0;
    } else {
      this.wdx_1.fdv_1 = new ParseFlowMappingKey(this.wdx_1, false);
      var token_0 = this.wdx_1.bdv_1.fdw();
      tmp = processEmptyScalar(this.wdx_1, token_0.mdv_1);
    }
    return tmp;
  }
}
class ParseFlowMappingEmptyValue {
  constructor($outer) {
    this.xdx_1 = $outer;
  }
  hdv() {
    this.xdx_1.fdv_1 = new ParseFlowMappingKey(this.xdx_1, false);
    return processEmptyScalar(this.xdx_1, this.xdx_1.bdv_1.fdw().mdv_1);
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.wdv_1 = mapOf([to('!', '!'), to('!!', 'tag:yaml.org,2002:')]);
  }
}
class ParserImpl {
  static ydx(settings, scanner) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.adv_1 = settings;
    $this.bdv_1 = scanner;
    $this.cdv_1 = ArrayDeque.kl(100);
    $this.ddv_1 = ArrayDeque.kl(100);
    $this.edv_1 = null;
    $this.fdv_1 = new ParseStreamStart($this);
    $this.gdv_1 = toMutableMap(Companion_getInstance_8().wdv_1);
    return $this;
  }
  static zdx(settings, reader) {
    Companion_getInstance_8();
    return this.ydx(settings, new ScannerImpl(settings, reader));
  }
  ady() {
    produce(this);
    var tmp0_elvis_lhs = this.edv_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException.p('No more Events found.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  d1() {
    var value = this.ady();
    this.edv_1 = null;
    return value;
  }
  c1() {
    produce(this);
    return !(this.edv_1 == null);
  }
}
class VersionTagsTuple {
  constructor(specVersion, tags) {
    this.tdw_1 = specVersion;
    this.udw_1 = tags;
  }
  toString() {
    return 'VersionTagsTuple<' + toString_1(this.tdw_1) + ', ' + toString(this.udw_1) + '>';
  }
  hashCode() {
    var result = this.tdw_1 == null ? 0 : hashCode(this.tdw_1);
    result = imul(result, 31) + hashCode(this.udw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VersionTagsTuple))
      return false;
    var tmp0_other_with_cast = other instanceof VersionTagsTuple ? other : THROW_CCE();
    if (!equals(this.tdw_1, tmp0_other_with_cast.tdw_1))
      return false;
    if (!equals(this.udw_1, tmp0_other_with_cast.udw_1))
      return false;
    return true;
  }
}
class ImplicitResolversBuilder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.bdy_1 = LinkedHashMap.wc();
  }
  cdy() {
    return toMap(this.bdy_1);
  }
  ddy(tag, regexp, first) {
    var tmp59_safe_receiver = first == null ? null : toCharArray(first);
    var tmp;
    if (tmp59_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp59_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp59_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp59_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'it.krzeminski.snakeyaml.engine.kmp.resolver.ImplicitResolversBuilder.addImplicitResolver.<anonymous>' call
        var tmp_0;
        // Inline function 'kotlin.code' call
        if (Char__toInt_impl_vasixd(item) === 0) {
          tmp_0 = null;
        } else {
          tmp_0 = item;
        }
        var tmp_1 = tmp_0;
        var tmp$ret$1 = tmp_1 == null ? null : new Char(tmp_1);
        destination.h(tmp$ret$1);
      }
      tmp = destination;
    }
    var tmp0_elvis_lhs = tmp;
    var keys = tmp0_elvis_lhs == null ? listOf(null) : tmp0_elvis_lhs;
    var _iterator__ex2g4s = distinct(keys).b1();
    while (_iterator__ex2g4s.c1()) {
      var tmp_2 = _iterator__ex2g4s.d1();
      var key = tmp_2 == null ? null : tmp_2.n2_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var this_0 = this.bdy_1;
      var tmp_3 = key;
      var key_0 = tmp_3 == null ? null : new Char(tmp_3);
      var value = this_0.e3(key_0);
      var tmp_4;
      if (value == null) {
        // Inline function 'it.krzeminski.snakeyaml.engine.kmp.resolver.ImplicitResolversBuilder.addImplicitResolver.<anonymous>' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var answer = ArrayList.z();
        this_0.k3(key_0, answer);
        tmp_4 = answer;
      } else {
        tmp_4 = value;
      }
      var curr = tmp_4;
      curr.h(new ResolverTuple(tag, regexp));
    }
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    this.edy_1 = Regex.pi('^$');
    this.fdy_1 = Regex.pi('^\\$\\{\\s*(\\w+)(?:(:?[-?])(\\w+)?)?\\s*\\}$');
  }
}
class BaseScalarResolver {
  constructor(buildImplicitResolvers) {
    Companion_getInstance_9();
    var tmp;
    if (buildImplicitResolvers === VOID) {
      tmp = BaseScalarResolver$_init_$lambda_ep9miw;
    } else {
      tmp = buildImplicitResolvers;
    }
    buildImplicitResolvers = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new ImplicitResolversBuilder();
    // Inline function 'kotlin.contracts.contract' call
    buildImplicitResolvers(this_0);
    tmp_0.gdy_1 = this_0.cdy();
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    this.hdy_1 = Regex.pi('^(?:true|false)$');
    this.idy_1 = Regex.pi('^(-?(0|[1-9][0-9]*)(\\.[0-9]*)?([eE][-+]?[0-9]+)?)|(-?\\.inf)|(\\.nan)$');
    this.jdy_1 = Regex.pi('^-?(0|[1-9][0-9]*)$');
    this.kdy_1 = Regex.pi('^null$');
  }
}
class JsonScalarResolver extends BaseScalarResolver {
  constructor() {
    Companion_getInstance_10();
    super(JsonScalarResolver$_init_$lambda_2rw3ox);
  }
}
class ResolverTuple {
  constructor(tag, regexp) {
    this.ldy_1 = tag;
    this.mdy_1 = regexp;
  }
  toString() {
    return 'Tuple tag=' + this.ldy_1.toString() + ' regexp=' + this.mdy_1.toString();
  }
  hashCode() {
    var result = this.ldy_1.hashCode();
    result = imul(result, 31) + hashCode(this.mdy_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ResolverTuple))
      return false;
    var tmp0_other_with_cast = other instanceof ResolverTuple ? other : THROW_CCE();
    if (!this.ldy_1.equals(tmp0_other_with_cast.ldy_1))
      return false;
    if (!equals(this.mdy_1, tmp0_other_with_cast.mdy_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    this.ae0_1 = 'while scanning a directive';
    this.be0_1 = 'expected alphabetic or numeric character, but found ';
    this.ce0_1 = 'while scanning a block scalar';
    this.de0_1 = 'while scanning a ';
    this.ee0_1 = Regex.pi('[^0-9A-Fa-f]');
  }
}
class ScannerImpl {
  constructor(settings, reader) {
    Companion_getInstance_11();
    this.ndy_1 = settings;
    this.ody_1 = reader;
    this.pdy_1 = ArrayDeque.kl(100);
    this.qdy_1 = ArrayDeque.kl(10);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.rdy_1 = LinkedHashMap.wc();
    this.sdy_1 = false;
    this.tdy_1 = 0;
    this.udy_1 = null;
    this.vdy_1 = 0;
    this.wdy_1 = -1;
    this.xdy_1 = true;
    fetchStreamStart(this);
  }
  odv(choices) {
    while (needMoreTokens(this)) {
      fetchMoreTokens(this);
    }
    var tmp60_safe_receiver = this.pdy_1.nl();
    var firstTokenId = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.gdw();
    var tmp;
    if (!(firstTokenId == null)) {
      var tmp_0;
      // Inline function 'kotlin.collections.isEmpty' call
      if (choices.length === 0) {
        tmp_0 = true;
      } else {
        tmp_0 = contains(choices, firstTokenId);
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  fdw() {
    while (needMoreTokens(this)) {
      fetchMoreTokens(this);
    }
    return this.pdy_1.ml();
  }
  c1() {
    return this.odv([]);
  }
  d1() {
    this.vdy_1 = this.vdy_1 + 1 | 0;
    var tmp0_elvis_lhs = this.pdy_1.rl();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException.p('No more Tokens found.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  sdw() {
    return this.ody_1.sdw();
  }
}
class Clip {
  constructor(increment) {
    this.fe0_1 = increment;
  }
  udz() {
    return _Clip___get_increment__impl__6zmssn(this.fe0_1);
  }
  ydz() {
    return _Clip___get_addExistingFinalLineBreak__impl__v4gbjp(this.fe0_1);
  }
  zdz() {
    return _Clip___get_retainTrailingEmptyLines__impl__5r5ek5(this.fe0_1);
  }
  toString() {
    return Clip__toString_impl_8zbb0x(this.fe0_1);
  }
  hashCode() {
    return Clip__hashCode_impl_crulry(this.fe0_1);
  }
  equals(other) {
    return Clip__equals_impl_7672fy(this.fe0_1, other);
  }
}
class Strip {
  constructor(increment) {
    this.ge0_1 = increment;
  }
  udz() {
    return _Strip___get_increment__impl__ultjnb(this.ge0_1);
  }
  ydz() {
    return _Strip___get_addExistingFinalLineBreak__impl__hh5hph(this.ge0_1);
  }
  zdz() {
    return _Strip___get_retainTrailingEmptyLines__impl__5bav0l(this.ge0_1);
  }
  toString() {
    return Strip__toString_impl_e44ikp(this.ge0_1);
  }
  hashCode() {
    return Strip__hashCode_impl_7n1e86(this.ge0_1);
  }
  equals(other) {
    return Strip__equals_impl_vbxlyi(this.ge0_1, other);
  }
}
class Keep {
  constructor(increment) {
    this.he0_1 = increment;
  }
  udz() {
    return _Keep___get_increment__impl__g32ff2(this.he0_1);
  }
  ydz() {
    return _Keep___get_addExistingFinalLineBreak__impl__eevoo0(this.he0_1);
  }
  zdz() {
    return _Keep___get_retainTrailingEmptyLines__impl__7i8cq2(this.he0_1);
  }
  toString() {
    return Keep__toString_impl_5t9sg4(this.he0_1);
  }
  hashCode() {
    return Keep__hashCode_impl_rkfp8z(this.he0_1);
  }
  equals(other) {
    return Keep__equals_impl_3j9b7t(this.he0_1, other);
  }
}
class BreakIntentHolder {
  constructor(breaks, maxIndent, endMark) {
    this.vdz_1 = breaks;
    this.wdz_1 = maxIndent;
    this.xdz_1 = endMark;
  }
}
class SimpleKey {
  constructor(tokenNumber, isRequired, index, line, column, mark) {
    this.kdz_1 = tokenNumber;
    this.ldz_1 = isRequired;
    this.mdz_1 = index;
    this.ndz_1 = line;
    this.odz_1 = column;
    this.pdz_1 = mark;
  }
  toString() {
    return 'SimpleKey - tokenNumber=' + this.kdz_1 + ' required=' + this.ldz_1 + ' index=' + this.mdz_1 + ' line=' + this.ndz_1 + ' column=' + this.odz_1;
  }
}
class Companion_12 {
  odq(c) {
    return (32 <= c ? c <= 126 : false) || c === 9 || c === 10 || c === 13 || c === 133 || (160 <= c ? c <= 55295 : false) || (57344 <= c ? c <= 65533 : false) || (65536 <= c ? c <= 1114111 : false);
  }
}
class StreamReader {
  constructor(loadSettings, stream) {
    var tmp = this;
    var tmp_0;
    if (isInterface(stream, BufferedSource)) {
      tmp_0 = stream;
    } else {
      tmp_0 = buffer(stream);
    }
    tmp.ydy_1 = tmp_0;
    this.zdy_1 = loadSettings.kdi_1;
    this.adz_1 = loadSettings.udi_1;
    this.bdz_1 = new Int32Array(0);
    this.cdz_1 = 0;
    this.ddz_1 = 0;
    this.edz_1 = false;
    this.fdz_1 = 0;
    this.gdz_1 = 0;
    this.hdz_1 = 0;
    this.idz_1 = 0;
  }
  jdz() {
    if (!this.adz_1)
      return null;
    var tmp = this.fdz_1;
    var tmp_0 = this.hdz_1;
    var tmp_1 = this.idz_1;
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.bdz_1;
    var tmp$ret$2 = asList(tmp$ret$1);
    return new Mark(this.zdy_1, tmp, tmp_0, tmp_1, tmp$ret$2, this.ddz_1);
  }
  qdz(length) {
    // Inline function 'kotlin.repeat' call
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $l$block: {
          // Inline function 'it.krzeminski.snakeyaml.engine.kmp.scanner.StreamReader.forward.<anonymous>' call
          if (!ensureEnoughData$default(this)) {
            break $l$block;
          }
          var tmp = this.bdz_1;
          var _unary__edvuaz = this.ddz_1;
          this.ddz_1 = _unary__edvuaz + 1 | 0;
          var c = tmp[_unary__edvuaz];
          moveIndices(this, 1);
          var tmp_0;
          if (Companion_getInstance_2().rdl_1.fdm(c)) {
            tmp_0 = true;
          } else {
            var tmp_1;
            var tmp_2;
            // Inline function 'kotlin.code' call
            var this_0 = _Char___init__impl__6a9atx(13);
            if (c === Char__toInt_impl_vasixd(this_0)) {
              tmp_2 = ensureEnoughData$default(this);
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              var tmp_3 = this.bdz_1[this.ddz_1];
              // Inline function 'kotlin.code' call
              var this_1 = _Char___init__impl__6a9atx(10);
              tmp_1 = !(tmp_3 === Char__toInt_impl_vasixd(this_1));
            } else {
              tmp_1 = false;
            }
            tmp_0 = tmp_1;
          }
          if (tmp_0) {
            this.hdz_1 = this.hdz_1 + 1 | 0;
            this.idz_1 = 0;
          } else {
            if (!(c === 65279)) {
              this.idz_1 = this.idz_1 + 1 | 0;
            }
          }
        }
      }
       while (inductionVariable < length);
  }
  rdz(length, $super) {
    length = length === VOID ? 1 : length;
    var tmp;
    if ($super === VOID) {
      this.qdz(length);
      tmp = Unit_instance;
    } else {
      tmp = $super.qdz.call(this, length);
    }
    return tmp;
  }
  adl() {
    return ensureEnoughData$default(this) ? this.bdz_1[this.ddz_1] : 0;
  }
  m2e(index) {
    return ensureEnoughData(this, index) ? this.bdz_1[this.ddz_1 + index | 0] : 0;
  }
  sdz(length) {
    if (length === 0)
      return '';
    var stringLength = ensureEnoughData(this, length) ? length : coerceAtMost(length, this.cdz_1 - this.ddz_1 | 0);
    var tmp = copyOfRangeSafe(this.bdz_1, Companion_instance_12, this.ddz_1, this.ddz_1 + stringLength | 0);
    return joinToString_0(tmp, '', VOID, VOID, VOID, VOID, StreamReader$prefix$lambda);
  }
  tdz(length) {
    var prefix = this.sdz(length);
    this.ddz_1 = this.ddz_1 + length | 0;
    moveIndices(this, length);
    this.idz_1 = this.idz_1 + length | 0;
    return prefix;
  }
  sdw() {
    this.gdz_1 = 0;
  }
}
class JsonSchema {
  constructor(scalarResolver, schemaTagConstructors) {
    scalarResolver = scalarResolver === VOID ? new JsonScalarResolver() : scalarResolver;
    schemaTagConstructors = schemaTagConstructors === VOID ? defaultSchemaTagConstructors(scalarResolver) : schemaTagConstructors;
    this.ie0_1 = scalarResolver;
    this.je0_1 = schemaTagConstructors;
  }
}
class NumberAnchorGenerator {
  constructor(lastAnchorId) {
    lastAnchorId = lastAnchorId === VOID ? _UInt___init__impl__l7qpdl(0) : lastAnchorId;
    this.ke0_1 = lastAnchorId;
  }
}
class Token {
  constructor(startMark, endMark) {
    this.mdv_1 = startMark;
    this.ndv_1 = endMark;
  }
  toString() {
    return this.gdw().toString();
  }
}
class AliasToken extends Token {
  constructor(value, startMark, endMark) {
    super(startMark, endMark);
    this.odw_1 = value;
  }
  gdw() {
    return ID_Alias_getInstance_0();
  }
}
class AnchorToken extends Token {
  constructor(value, startMark, endMark) {
    super(startMark, endMark);
    this.cdw_1 = value;
  }
  gdw() {
    return ID_Anchor_getInstance();
  }
}
class BlockEndToken extends Token {
  gdw() {
    return ID_BlockEnd_getInstance();
  }
}
class BlockEntryToken extends Token {
  gdw() {
    return ID_BlockEntry_getInstance();
  }
}
class BlockMappingStartToken extends Token {
  gdw() {
    return ID_BlockMappingStart_getInstance();
  }
}
class BlockSequenceStartToken extends Token {
  gdw() {
    return ID_BlockSequenceStart_getInstance();
  }
}
class CommentToken extends Token {
  constructor(commentType, value, startMark, endMark) {
    super(startMark, endMark);
    this.kdv_1 = commentType;
    this.ldv_1 = value;
  }
  gdw() {
    return ID_Comment_getInstance_0();
  }
}
class YamlDirective {
  constructor(major, minor) {
    this.sdv_1 = major;
    this.tdv_1 = minor;
  }
  em() {
    return this.sdv_1;
  }
  fm() {
    return this.tdv_1;
  }
  toString() {
    return 'YamlDirective(major=' + this.sdv_1 + ', minor=' + this.tdv_1 + ')';
  }
  hashCode() {
    var result = this.sdv_1;
    result = imul(result, 31) + this.tdv_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlDirective))
      return false;
    var tmp0_other_with_cast = other instanceof YamlDirective ? other : THROW_CCE();
    if (!(this.sdv_1 === tmp0_other_with_cast.sdv_1))
      return false;
    if (!(this.tdv_1 === tmp0_other_with_cast.tdv_1))
      return false;
    return true;
  }
}
class TagDirective {
  constructor(handle, prefix) {
    this.udv_1 = handle;
    this.vdv_1 = prefix;
  }
  em() {
    return this.udv_1;
  }
  fm() {
    return this.vdv_1;
  }
  toString() {
    return 'TagDirective(handle=' + this.udv_1 + ', prefix=' + this.vdv_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.udv_1);
    result = imul(result, 31) + getStringHashCode(this.vdv_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TagDirective))
      return false;
    var tmp0_other_with_cast = other instanceof TagDirective ? other : THROW_CCE();
    if (!(this.udv_1 === tmp0_other_with_cast.udv_1))
      return false;
    if (!(this.vdv_1 === tmp0_other_with_cast.vdv_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    this.te0_1 = 'YAML';
    this.ue0_1 = 'TAG';
  }
}
class DirectiveToken extends Token {
  constructor(value, startMark, endMark) {
    super(startMark, endMark);
    this.rdv_1 = value;
  }
  gdw() {
    return ID_Directive_getInstance();
  }
}
class DocumentEndToken extends Token {
  gdw() {
    return ID_DocumentEnd_getInstance_0();
  }
}
class DocumentStartToken extends Token {
  gdw() {
    return ID_DocumentStart_getInstance_0();
  }
}
class FlowEntryToken extends Token {
  gdw() {
    return ID_FlowEntry_getInstance();
  }
}
class FlowMappingEndToken extends Token {
  gdw() {
    return ID_FlowMappingEnd_getInstance();
  }
}
class FlowMappingStartToken extends Token {
  gdw() {
    return ID_FlowMappingStart_getInstance();
  }
}
class FlowSequenceEndToken extends Token {
  gdw() {
    return ID_FlowSequenceEnd_getInstance();
  }
}
class FlowSequenceStartToken extends Token {
  gdw() {
    return ID_FlowSequenceStart_getInstance();
  }
}
class KeyToken extends Token {
  gdw() {
    return ID_Key_getInstance();
  }
}
class ScalarToken extends Token {
  constructor(value, plain, startMark, endMark, style) {
    style = style === VOID ? ScalarStyle_PLAIN_getInstance() : style;
    super(startMark, endMark);
    this.jdw_1 = value;
    this.kdw_1 = plain;
    this.ldw_1 = style;
  }
  gdw() {
    return ID_Scalar_getInstance_0();
  }
  toString() {
    return this.gdw().toString() + ' plain=' + this.kdw_1 + ' style=' + this.ldw_1.toString() + ' value=' + this.jdw_1;
  }
}
class StreamEndToken extends Token {
  gdw() {
    return ID_StreamEnd_getInstance_0();
  }
}
class StreamStartToken extends Token {
  gdw() {
    return ID_StreamStart_getInstance_0();
  }
}
class TagToken extends Token {
  constructor(value, startMark, endMark) {
    super(startMark, endMark);
    this.zdv_1 = value;
  }
  gdw() {
    return ID_Tag_getInstance();
  }
}
class TagTuple {
  constructor(handle, suffix) {
    this.ddw_1 = handle;
    this.edw_1 = suffix;
  }
}
class ID_0 extends Enum {
  constructor(name, ordinal, description) {
    super(name, ordinal);
    this.re1_1 = description;
  }
  toString() {
    return this.re1_1;
  }
}
class ValueToken extends Token {
  gdw() {
    return ID_Value_getInstance();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function LoadSettingsBuilder$defaultList$lambda(initialCapacity) {
  return ArrayList.w(initialCapacity);
}
function LoadSettingsBuilder$defaultSet$lambda(initialCapacity) {
  return LinkedHashSet.r(initialCapacity);
}
function LoadSettingsBuilder$defaultMap$lambda(initialCapacity) {
  return LinkedHashMap.xc(initialCapacity);
}
function LoadSettingsBuilder$versionFunction$lambda(version) {
  if (!(version.jdj_1 === 1))
    throw YamlVersionException.idj(version);
  return version;
}
function isEventExpected($this, event) {
  var tmp;
  var tmp_0;
  if (!(event == null) && event.gdk().equals(ID_Comment_getInstance())) {
    tmp_0 = event instanceof CommentEvent;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = contains($this.idk_1, event.mdk_1);
  } else {
    tmp = false;
  }
  return tmp;
}
function ArrayDeque$removeFirst$ref($boundThis) {
  var l = function () {
    return $boundThis.ql();
  };
  l.callableName = 'removeFirst';
  return l;
}
function ArrayDeque$firstOrNull$ref($boundThis) {
  var l = function () {
    return $boundThis.nl();
  };
  l.callableName = 'firstOrNull';
  return l;
}
var CommentType_BLANK_LINE_instance;
var CommentType_BLOCK_instance;
var CommentType_IN_LINE_instance;
var CommentType_entriesInitialized;
function CommentType_initEntries() {
  if (CommentType_entriesInitialized)
    return Unit_instance;
  CommentType_entriesInitialized = true;
  CommentType_BLANK_LINE_instance = new CommentType('BLANK_LINE', 0);
  CommentType_BLOCK_instance = new CommentType('BLOCK', 1);
  CommentType_IN_LINE_instance = new CommentType('IN_LINE', 2);
}
function CommentType_BLANK_LINE_getInstance() {
  CommentType_initEntries();
  return CommentType_BLANK_LINE_instance;
}
function CommentType_BLOCK_getInstance() {
  CommentType_initEntries();
  return CommentType_BLOCK_instance;
}
function CommentType_IN_LINE_getInstance() {
  CommentType_initEntries();
  return CommentType_IN_LINE_instance;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var FlowStyle_FLOW_instance;
var FlowStyle_BLOCK_instance;
var FlowStyle_AUTO_instance;
var FlowStyle_entriesInitialized;
function FlowStyle_initEntries() {
  if (FlowStyle_entriesInitialized)
    return Unit_instance;
  FlowStyle_entriesInitialized = true;
  FlowStyle_FLOW_instance = new FlowStyle('FLOW', 0);
  FlowStyle_BLOCK_instance = new FlowStyle('BLOCK', 1);
  FlowStyle_AUTO_instance = new FlowStyle('AUTO', 2);
}
function FlowStyle_FLOW_getInstance() {
  FlowStyle_initEntries();
  return FlowStyle_FLOW_instance;
}
function FlowStyle_BLOCK_getInstance() {
  FlowStyle_initEntries();
  return FlowStyle_BLOCK_instance;
}
function FlowStyle_AUTO_getInstance() {
  FlowStyle_initEntries();
  return FlowStyle_AUTO_instance;
}
var NonPrintableStyle_BINARY_instance;
var NonPrintableStyle_ESCAPE_instance;
var NonPrintableStyle_entriesInitialized;
function NonPrintableStyle_initEntries() {
  if (NonPrintableStyle_entriesInitialized)
    return Unit_instance;
  NonPrintableStyle_entriesInitialized = true;
  NonPrintableStyle_BINARY_instance = new NonPrintableStyle('BINARY', 0);
  NonPrintableStyle_ESCAPE_instance = new NonPrintableStyle('ESCAPE', 1);
}
function NonPrintableStyle_ESCAPE_getInstance() {
  NonPrintableStyle_initEntries();
  return NonPrintableStyle_ESCAPE_instance;
}
var ScalarStyle_DOUBLE_QUOTED_instance;
var ScalarStyle_SINGLE_QUOTED_instance;
var ScalarStyle_LITERAL_instance;
var ScalarStyle_FOLDED_instance;
var ScalarStyle_PLAIN_instance;
var ScalarStyle_entriesInitialized;
function ScalarStyle_initEntries() {
  if (ScalarStyle_entriesInitialized)
    return Unit_instance;
  ScalarStyle_entriesInitialized = true;
  ScalarStyle_DOUBLE_QUOTED_instance = new ScalarStyle('DOUBLE_QUOTED', 0, _Char___init__impl__6a9atx(34));
  ScalarStyle_SINGLE_QUOTED_instance = new ScalarStyle('SINGLE_QUOTED', 1, _Char___init__impl__6a9atx(39));
  ScalarStyle_LITERAL_instance = new ScalarStyle('LITERAL', 2, _Char___init__impl__6a9atx(124));
  ScalarStyle_FOLDED_instance = new ScalarStyle('FOLDED', 3, _Char___init__impl__6a9atx(62));
  ScalarStyle_PLAIN_instance = new ScalarStyle('PLAIN', 4, null);
}
function ScalarStyle_DOUBLE_QUOTED_getInstance() {
  ScalarStyle_initEntries();
  return ScalarStyle_DOUBLE_QUOTED_instance;
}
function ScalarStyle_SINGLE_QUOTED_getInstance() {
  ScalarStyle_initEntries();
  return ScalarStyle_SINGLE_QUOTED_instance;
}
function ScalarStyle_LITERAL_getInstance() {
  ScalarStyle_initEntries();
  return ScalarStyle_LITERAL_instance;
}
function ScalarStyle_FOLDED_getInstance() {
  ScalarStyle_initEntries();
  return ScalarStyle_FOLDED_instance;
}
function ScalarStyle_PLAIN_getInstance() {
  ScalarStyle_initEntries();
  return ScalarStyle_PLAIN_instance;
}
function urlDecode($this, content) {
  return UrlEncoderUtil_getInstance().y49(content, false);
}
function urlEncode($this, content) {
  return UrlEncoderUtil_getInstance().xdf(content, "-_.!~*'()@:$&,;=[]/", false);
}
var UriEncoder_instance;
function UriEncoder_getInstance() {
  return UriEncoder_instance;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function handleDocumentStartEvent($this, ev) {
  var tmp;
  var tmp_0;
  if (!(ev.tdm_1 == null)) {
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_0 = !ev.udm_1.j1();
  }
  if (tmp_0) {
    tmp = $this.ydn_1.kdn_1;
  } else {
    tmp = false;
  }
  if (tmp) {
    writeIndicator$default($this.ydn_1, '...', true);
    writeIndent($this.ydn_1);
  }
  if (!(ev.tdm_1 == null)) {
    $this.ydn_1.zdn(prepareVersion($this.ydn_1, ev.tdm_1));
  }
  $this.ydn_1.qdn_1 = toMutableMap(Companion_getInstance_4().sdh_1);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!ev.udm_1.j1()) {
    handleTagDirectives($this, ev.udm_1);
  }
  var implicit = $this.xdn_1 && !ev.sdm_1 && !$this.ydn_1.ldn_1 && ev.tdm_1 == null && ev.udm_1.j1() && !checkEmptyDocument($this);
  if (!implicit) {
    writeIndent($this.ydn_1);
    writeIndicator$default($this.ydn_1, '---', true);
    if ($this.ydn_1.ldn_1) {
      writeIndent($this.ydn_1);
    }
  }
}
function handleTagDirectives($this, tags) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tags.u1().b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.component1' call
    var handle = _destruct__k2r9zo.v1();
    // Inline function 'kotlin.collections.component2' call
    var prefix = _destruct__k2r9zo.w1();
    // Inline function 'kotlin.collections.set' call
    $this.ydn_1.qdn_1.k3(prefix, handle);
    checkTagHandle($this, handle);
    checkTagPrefix($this, prefix);
    $this.ydn_1.ado(handle, prefix);
  }
}
function checkTagHandle($this, handle) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(handle) === 0)
    throw EmitterException.ddi('tag handle must not be empty');
  else {
    if (!(startsWith(handle, _Char___init__impl__6a9atx(33)) && endsWith(handle, _Char___init__impl__6a9atx(33))))
      throw EmitterException.ddi("tag handle must start and end with '!': " + handle);
    else {
      if (!(handle === '!') && !Companion_getInstance_4().ydh_1.qi(handle))
        throw EmitterException.ddi('invalid character in the tag handle: ' + handle);
    }
  }
}
function checkTagPrefix($this, prefix) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(prefix) === 0) {
    throw EmitterException.ddi('tag prefix must not be empty');
  }
}
function checkEmptyDocument($this) {
  var tmp;
  var tmp22_safe_receiver = $this.ydn_1.adn_1;
  if (!equals(tmp22_safe_receiver == null ? null : tmp22_safe_receiver.gdk(), ID_DocumentStart_getInstance())) {
    tmp = true;
  } else {
    tmp = $this.ydn_1.zdm_1.j1();
  }
  if (tmp) {
    return false;
  }
  var nextEvent = $this.ydn_1.zdm_1.ml();
  if (nextEvent.gdk().equals(ID_Scalar_getInstance())) {
    var e = nextEvent instanceof ScalarEvent ? nextEvent : THROW_CCE();
    var tmp_0;
    if (e.kdo_1 == null && e.edo_1 == null) {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = e.gdo_1;
      tmp_0 = charSequenceLength(this_0) === 0;
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  }
  return false;
}
function isFoldedOrLiteral($this, event) {
  var tmp;
  if (event instanceof ScalarEvent) {
    tmp = event.hdo_1.equals(ScalarStyle_FOLDED_getInstance()) || event.hdo_1.equals(ScalarStyle_LITERAL_getInstance());
  } else {
    tmp = false;
  }
  return tmp;
}
function _get_indicatorIndent__dy1exi($this) {
  return $this.vdm_1.mdg_1;
}
function _get_indentWithIndicator__nfeqac($this) {
  return $this.vdm_1.sdg_1;
}
function _get_bestLineBreak__5uxc8m($this) {
  return $this.vdm_1.odg_1;
}
function _get_splitLines__1he196($this) {
  return $this.vdm_1.pdg_1;
}
function _get_maxSimpleKeyLength__nyy5lo($this) {
  return $this.vdm_1.qdg_1;
}
function _get_emitComments__dxus78($this) {
  return $this.vdm_1.tdg_1;
}
function needMoreEvents($this) {
  if ($this.zdm_1.j1()) {
    return true;
  }
  var iter = $this.zdm_1.b1();
  var event = iter.d1();
  $l$loop: while (event instanceof CommentEvent) {
    if (!iter.c1()) {
      return true;
    }
    event = iter.d1();
  }
  var tmp17_subject = event;
  var tmp;
  if (tmp17_subject instanceof DocumentStartEvent) {
    tmp = needEvents($this, iter, 1);
  } else {
    if (tmp17_subject instanceof SequenceStartEvent) {
      tmp = needEvents($this, iter, 2);
    } else {
      if (tmp17_subject instanceof MappingStartEvent) {
        tmp = needEvents($this, iter, 3);
      } else {
        if (tmp17_subject instanceof StreamStartEvent) {
          tmp = needEvents($this, iter, 2);
        } else {
          if (tmp17_subject instanceof StreamEndEvent) {
            tmp = false;
          } else {
            tmp = _get_emitComments__dxus78($this) ? needEvents($this, iter, 1) : false;
          }
        }
      }
    }
  }
  return tmp;
}
function needEvents($this, iter, count) {
  var level = 0;
  var actualCount = 0;
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = iter;
  $l$loop: while (_iterator__ex2g4s.c1()) {
    var event = _iterator__ex2g4s.d1();
    if (event instanceof CommentEvent) {
      continue $l$loop;
    }
    actualCount = actualCount + 1 | 0;
    var tmp;
    if (event instanceof DocumentStartEvent) {
      tmp = true;
    } else {
      tmp = event instanceof CollectionStartEvent;
    }
    if (tmp) {
      level = level + 1 | 0;
    } else {
      var tmp_0;
      if (event instanceof DocumentEndEvent) {
        tmp_0 = true;
      } else {
        tmp_0 = event instanceof CollectionEndEvent;
      }
      if (tmp_0) {
        level = level - 1 | 0;
      } else {
        if (event instanceof StreamEndEvent)
          level = -1;
      }
    }
    if (level < 0) {
      return false;
    }
  }
  return actualCount < count;
}
function increaseIndent($this, isFlow, indentless) {
  $this.bdn_1.pl($this.cdn_1);
  if ($this.cdn_1 == null) {
    $this.cdn_1 = isFlow ? $this.odn_1 : 0;
  } else if (!indentless) {
    $this.cdn_1 = ensureNotNull($this.cdn_1) + $this.odn_1 | 0;
  }
}
function increaseIndent$default($this, isFlow, indentless, $super) {
  isFlow = isFlow === VOID ? false : isFlow;
  indentless = indentless === VOID ? false : indentless;
  return increaseIndent($this, isFlow, indentless);
}
function expectNode($this, root, mapping, simpleKey) {
  $this.edn_1 = root;
  $this.fdn_1 = mapping;
  $this.gdn_1 = simpleKey;
  var tmp24_safe_receiver = $this.adn_1;
  var tmp25_subject = tmp24_safe_receiver == null ? null : tmp24_safe_receiver.gdk();
  switch (tmp25_subject == null ? -1 : tmp25_subject.p3_1) {
    case 0:
      expectAlias($this);
      break;
    case 6:
    case 8:
    case 5:
      processAnchor($this, '&');
      processTag($this);
      handleNodeEvent($this, ensureNotNull($this.adn_1).gdk());
      break;
    default:
      var tmp26_safe_receiver = $this.adn_1;
      throw EmitterException.ddi('expected NodeEvent, but got ' + toString_1(tmp26_safe_receiver == null ? null : tmp26_safe_receiver.gdk()));
  }
}
function expectNode$default($this, root, mapping, simpleKey, $super) {
  root = root === VOID ? false : root;
  mapping = mapping === VOID ? false : mapping;
  simpleKey = simpleKey === VOID ? false : simpleKey;
  return expectNode($this, root, mapping, simpleKey);
}
function handleNodeEvent($this, id) {
  switch (id.p3_1) {
    case 6:
      expectScalar($this);
      break;
    case 8:
      var tmp;
      var tmp_0;
      if (!($this.ddn_1 === 0) || $this.ldn_1) {
        tmp_0 = true;
      } else {
        var tmp_1 = $this.adn_1;
        tmp_0 = (tmp_1 instanceof SequenceStartEvent ? tmp_1 : THROW_CCE()).adp();
      }

      if (tmp_0) {
        tmp = true;
      } else {
        tmp = checkEmptySequence($this);
      }

      if (tmp) {
        expectFlowSequence($this);
      } else {
        expectBlockSequence($this);
      }

      break;
    case 5:
      var tmp_2;
      var tmp_3;
      if (!($this.ddn_1 === 0) || $this.ldn_1) {
        tmp_3 = true;
      } else {
        var tmp_4 = $this.adn_1;
        tmp_3 = (tmp_4 instanceof MappingStartEvent ? tmp_4 : THROW_CCE()).adp();
      }

      if (tmp_3) {
        tmp_2 = true;
      } else {
        tmp_2 = checkEmptyMapping($this);
      }

      if (tmp_2) {
        expectFlowMapping($this);
      } else {
        expectBlockMapping($this);
      }

      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Unexpected Event.ID ' + id.toString();
      throw IllegalStateException.h5(toString(message));
  }
}
function expectAlias($this) {
  var tmp = $this;
  var tmp_0;
  var tmp_1 = $this.adn_1;
  if (tmp_1 instanceof AliasEvent) {
    processAnchor($this, '*');
    tmp_0 = $this.xdm_1.sl();
  } else {
    throw EmitterException.ddi('Expecting Alias.');
  }
  tmp.ydm_1 = tmp_0;
}
function expectScalar($this) {
  increaseIndent$default($this, true);
  var tmp = $this.adn_1;
  processScalar($this, tmp instanceof ScalarEvent ? tmp : THROW_CCE());
  $this.cdn_1 = $this.bdn_1.tl();
  $this.ydm_1 = $this.xdm_1.sl();
}
function expectFlowSequence($this) {
  writeIndicator$default($this, '[', true, true);
  $this.ddn_1 = $this.ddn_1 + 1 | 0;
  increaseIndent$default($this, true);
  if ($this.mdn_1) {
    writeIndent($this);
  }
  $this.ydm_1 = new ExpectFirstFlowSequenceItem($this);
}
function expectFlowMapping($this) {
  writeIndicator$default($this, '{', true, true);
  $this.ddn_1 = $this.ddn_1 + 1 | 0;
  increaseIndent$default($this, true);
  if ($this.mdn_1) {
    writeIndent($this);
  }
  $this.ydm_1 = new ExpectFirstFlowMappingKey($this);
}
function expectBlockSequence($this) {
  var indentless = $this.fdn_1 && !$this.jdn_1;
  increaseIndent$default($this, VOID, indentless);
  $this.ydm_1 = new ExpectFirstBlockSequenceItem($this);
}
function expectBlockMapping($this) {
  increaseIndent$default($this);
  $this.ydm_1 = new ExpectFirstBlockMappingKey($this);
}
function checkEmptySequence($this) {
  var tmp;
  var tmp_0;
  var tmp34_safe_receiver = $this.adn_1;
  if (equals(tmp34_safe_receiver == null ? null : tmp34_safe_receiver.gdk(), ID_SequenceStart_getInstance())) {
    tmp_0 = !$this.zdm_1.j1();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = $this.zdm_1.ml().gdk().equals(ID_SequenceEnd_getInstance());
  } else {
    tmp = false;
  }
  return tmp;
}
function checkEmptyMapping($this) {
  var tmp;
  var tmp_0;
  var tmp35_safe_receiver = $this.adn_1;
  if (equals(tmp35_safe_receiver == null ? null : tmp35_safe_receiver.gdk(), ID_MappingStart_getInstance())) {
    tmp_0 = !$this.zdm_1.j1();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = $this.zdm_1.ml().gdk().equals(ID_MappingEnd_getInstance());
  } else {
    tmp = false;
  }
  return tmp;
}
function checkSimpleKey($this) {
  var length = 0;
  var tmp = $this.adn_1;
  if (tmp instanceof NodeEvent) {
    var tmp_0 = $this.adn_1;
    var anchor = (tmp_0 instanceof NodeEvent ? tmp_0 : THROW_CCE()).kdo_1;
    if (!(anchor == null)) {
      if ($this.rdn_1 == null) {
        $this.rdn_1 = anchor;
      }
      length = length + anchor.idl_1.length | 0;
    }
  }
  var tmp_1;
  var tmp36_safe_receiver = $this.adn_1;
  if (equals(tmp36_safe_receiver == null ? null : tmp36_safe_receiver.gdk(), ID_Scalar_getInstance())) {
    var tmp_2 = $this.adn_1;
    tmp_1 = (tmp_2 instanceof ScalarEvent ? tmp_2 : THROW_CCE()).edo_1;
  } else {
    var tmp_3 = $this.adn_1;
    if (tmp_3 instanceof CollectionStartEvent) {
      var tmp_4 = $this.adn_1;
      tmp_1 = (tmp_4 instanceof CollectionStartEvent ? tmp_4 : THROW_CCE()).xdo_1;
    } else {
      tmp_1 = null;
    }
  }
  var tag = tmp_1;
  if (!(tag == null)) {
    if ($this.sdn_1 == null) {
      $this.sdn_1 = prepareTag($this, tag);
    }
    length = length + ensureNotNull($this.sdn_1).length | 0;
  }
  var tmp37_safe_receiver = $this.adn_1;
  if (equals(tmp37_safe_receiver == null ? null : tmp37_safe_receiver.gdk(), ID_Scalar_getInstance())) {
    if ($this.tdn_1 == null) {
      var tmp_5 = $this;
      var tmp_6 = $this.adn_1;
      tmp_5.tdn_1 = analyzeScalar($this, (tmp_6 instanceof ScalarEvent ? tmp_6 : THROW_CCE()).gdo_1);
    }
    length = length + ensureNotNull($this.tdn_1).kdp_1.length | 0;
  }
  var tmp_7;
  if (length < _get_maxSimpleKeyLength__nyy5lo($this)) {
    var tmp_8;
    var tmp_9;
    var tmp_10;
    var tmp38_safe_receiver = $this.adn_1;
    if (equals(tmp38_safe_receiver == null ? null : tmp38_safe_receiver.gdk(), ID_Alias_getInstance())) {
      tmp_10 = true;
    } else {
      var tmp_11;
      var tmp_12;
      var tmp39_safe_receiver = $this.adn_1;
      if (equals(tmp39_safe_receiver == null ? null : tmp39_safe_receiver.gdk(), ID_Scalar_getInstance())) {
        tmp_12 = !ensureNotNull($this.tdn_1).ldp_1;
      } else {
        tmp_12 = false;
      }
      if (tmp_12) {
        tmp_11 = !ensureNotNull($this.tdn_1).mdp_1;
      } else {
        tmp_11 = false;
      }
      tmp_10 = tmp_11;
    }
    if (tmp_10) {
      tmp_9 = true;
    } else {
      tmp_9 = checkEmptySequence($this);
    }
    if (tmp_9) {
      tmp_8 = true;
    } else {
      tmp_8 = checkEmptyMapping($this);
    }
    tmp_7 = tmp_8;
  } else {
    tmp_7 = false;
  }
  return tmp_7;
}
function processAnchor($this, indicator) {
  var tmp = $this.adn_1;
  var ev = tmp instanceof NodeEvent ? tmp : THROW_CCE();
  var anchor = ev.kdo_1;
  if (!(anchor == null)) {
    if ($this.rdn_1 == null) {
      $this.rdn_1 = anchor;
    }
    writeIndicator$default($this, indicator + toString_1(anchor), true);
  }
  $this.rdn_1 = null;
}
function processTag($this) {
  var tag;
  var tmp40_safe_receiver = $this.adn_1;
  if (equals(tmp40_safe_receiver == null ? null : tmp40_safe_receiver.gdk(), ID_Scalar_getInstance())) {
    var tmp = $this.adn_1;
    var ev = tmp instanceof ScalarEvent ? tmp : THROW_CCE();
    tag = ev.edo_1;
    if ($this.udn_1 == null) {
      $this.udn_1 = chooseScalarStyle($this, ev);
    }
    if ((!$this.ldn_1 || tag == null) && ($this.udn_1 == null && ev.fdo_1.zdp() || (!($this.udn_1 == null) && ev.fdo_1.adq()))) {
      $this.sdn_1 = null;
      return Unit_instance;
    } else if (ev.fdo_1.zdp() && tag == null) {
      tag = '!';
      $this.sdn_1 = null;
    }
  } else {
    var tmp_0 = $this.adn_1;
    var ev_0 = tmp_0 instanceof CollectionStartEvent ? tmp_0 : THROW_CCE();
    tag = ev_0.xdo_1;
    if ((!$this.ldn_1 || tag == null) && ev_0.wdp()) {
      $this.sdn_1 = null;
      return Unit_instance;
    }
  }
  if (tag == null) {
    throw EmitterException.ddi('tag is not specified');
  }
  var tmp0_elvis_lhs = $this.sdn_1;
  var indicator = tmp0_elvis_lhs == null ? prepareTag($this, tag) : tmp0_elvis_lhs;
  writeIndicator$default($this, indicator, true);
}
function chooseScalarStyle($this, ev) {
  if ($this.tdn_1 == null) {
    $this.tdn_1 = analyzeScalar($this, ev.gdo_1);
  }
  if (!ev.bdq() && ev.hdo_1.equals(ScalarStyle_DOUBLE_QUOTED_getInstance()) || $this.ldn_1) {
    return ScalarStyle_DOUBLE_QUOTED_getInstance();
  }
  if (ev.bdq() && ev.fdo_1.zdp()) {
    if (!($this.gdn_1 && (ensureNotNull($this.tdn_1).ldp_1 || ensureNotNull($this.tdn_1).mdp_1)) && (!($this.ddn_1 === 0) && ensureNotNull($this.tdn_1).ndp_1 || ($this.ddn_1 === 0 && ensureNotNull($this.tdn_1).odp_1))) {
      return null;
    }
  }
  if (!ev.bdq() && (ev.hdo_1.equals(ScalarStyle_LITERAL_getInstance()) || ev.hdo_1.equals(ScalarStyle_FOLDED_getInstance()))) {
    if ($this.ddn_1 === 0 && !$this.gdn_1 && ensureNotNull($this.tdn_1).qdp_1) {
      return ev.hdo_1;
    }
  }
  if (ev.bdq() || ev.hdo_1.equals(ScalarStyle_SINGLE_QUOTED_getInstance())) {
    if (ensureNotNull($this.tdn_1).pdp_1 && !($this.gdn_1 && ensureNotNull($this.tdn_1).mdp_1)) {
      return ScalarStyle_SINGLE_QUOTED_getInstance();
    }
  }
  return ScalarStyle_DOUBLE_QUOTED_getInstance();
}
function processScalar($this, ev) {
  if ($this.tdn_1 == null) {
    $this.tdn_1 = analyzeScalar($this, ev.gdo_1);
  }
  if ($this.udn_1 == null) {
    $this.udn_1 = chooseScalarStyle($this, ev);
  }
  var split = !$this.gdn_1 && _get_splitLines__1he196($this);
  if ($this.udn_1 == null) {
    writePlain($this, ensureNotNull($this.tdn_1).kdp_1, split);
  } else {
    var tmp41_subject = $this.udn_1;
    switch (tmp41_subject == null ? -1 : tmp41_subject.p3_1) {
      case 0:
        writeDoubleQuoted($this, ensureNotNull($this.tdn_1).kdp_1, split);
        break;
      case 1:
        writeSingleQuoted($this, ensureNotNull($this.tdn_1).kdp_1, split);
        break;
      case 3:
        writeFolded($this, ensureNotNull($this.tdn_1).kdp_1, split);
        break;
      case 2:
        writeLiteral($this, ensureNotNull($this.tdn_1).kdp_1);
        break;
      default:
        throw YamlEngineException.fdq('Unexpected scalarStyle: ' + toString_1($this.udn_1));
    }
  }
  $this.tdn_1 = null;
  $this.udn_1 = null;
}
function prepareVersion($this, version) {
  if (!(version.jdj_1 === 1)) {
    throw EmitterException.ddi('unsupported YAML version: ' + version.toString());
  }
  return version.mdm();
}
function prepareTag($this, tag) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(tag) === 0) {
    throw EmitterException.ddi('tag must not be empty');
  } else {
    if ('!' === tag) {
      return tag;
    }
  }
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = $this.qdn_1.f3().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.emitter.Emitter.prepareTag.<anonymous>' call
      if (!(element == null) && startsWith_0(tag, element) && ('!' === element || element.length < tag.length)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var matchedPrefix = tmp$ret$2;
  var handle;
  var suffix;
  if (!(matchedPrefix == null)) {
    handle = $this.qdn_1.e3(matchedPrefix);
    // Inline function 'kotlin.text.substring' call
    var startIndex = matchedPrefix.length;
    // Inline function 'kotlin.js.asDynamic' call
    suffix = tag.substring(startIndex);
  } else {
    handle = null;
    suffix = tag;
  }
  var suffixText = take(suffix, suffix.length);
  return !(handle == null) ? handle + suffixText : '!<' + suffixText + '>';
}
function analyzeScalar($this, scalar) {
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(scalar) === 0) {
    return new ScalarAnalysis(scalar, true, false, false, true, true, false);
  }
  var blockIndicators = false;
  var flowIndicators = false;
  var lineBreaks = false;
  var specialCharacters = false;
  var leadingSpace = false;
  var leadingBreak = false;
  var trailingSpace = false;
  var trailingBreak = false;
  var breakSpace = false;
  var spaceBreak = false;
  if (startsWith_0(scalar, '---') || startsWith_0(scalar, '...')) {
    blockIndicators = true;
    flowIndicators = true;
  }
  var precededByWhitespace = true;
  var followedByWhitespace = scalar.length === 1 || Companion_getInstance_2().udl_1.fdm(codePointAt(scalar, 1));
  var previousSpace = false;
  var previousBreak = false;
  var index = 0;
  while (index < scalar.length) {
    var c = codePointAt(scalar, index);
    if (index === 0) {
      if (contains_0('#,[]{}&*!|>\'"%@`', numberToChar(c))) {
        flowIndicators = true;
        blockIndicators = true;
      }
      var tmp;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(63);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        tmp = true;
      } else {
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(58);
        tmp = c === Char__toInt_impl_vasixd(this_1);
      }
      if (tmp) {
        flowIndicators = true;
        if (followedByWhitespace) {
          blockIndicators = true;
        }
      }
      var tmp_0;
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(45);
      if (c === Char__toInt_impl_vasixd(this_2)) {
        tmp_0 = followedByWhitespace;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        flowIndicators = true;
        blockIndicators = true;
      }
    } else {
      if (contains_0(',?[]{}', numberToChar(c))) {
        flowIndicators = true;
      }
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(58);
      if (c === Char__toInt_impl_vasixd(this_3)) {
        flowIndicators = true;
        if (followedByWhitespace) {
          blockIndicators = true;
        }
      }
      var tmp_1;
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(35);
      if (c === Char__toInt_impl_vasixd(this_4)) {
        tmp_1 = precededByWhitespace;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        flowIndicators = true;
        blockIndicators = true;
      }
    }
    var isLineBreak = Companion_getInstance_2().rdl_1.fdm(c);
    if (isLineBreak) {
      lineBreaks = true;
    }
    var tmp_2;
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    if (c === Char__toInt_impl_vasixd(this_5)) {
      tmp_2 = true;
    } else {
      tmp_2 = 32 <= c ? c <= 126 : false;
    }
    if (!tmp_2) {
      if (c === 133 || (160 <= c ? c <= 55295 : false) || (57344 <= c ? c <= 65533 : false) || (65536 <= c ? c <= 1114111 : false)) {
        if (!$this.ndn_1) {
          specialCharacters = true;
        }
      } else {
        specialCharacters = true;
      }
    }
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(32);
    if (c === Char__toInt_impl_vasixd(this_6)) {
      if (index === 0) {
        leadingSpace = true;
      }
      if (index === (scalar.length - 1 | 0)) {
        trailingSpace = true;
      }
      if (previousBreak) {
        breakSpace = true;
      }
      previousSpace = true;
      previousBreak = false;
    } else {
      if (isLineBreak) {
        if (index === 0) {
          leadingBreak = true;
        }
        if (index === (scalar.length - 1 | 0)) {
          trailingBreak = true;
        }
        if (previousSpace) {
          spaceBreak = true;
        }
        previousSpace = false;
        previousBreak = true;
      } else {
        previousSpace = false;
        previousBreak = false;
      }
    }
    index = index + Character_getInstance().ldq(c) | 0;
    precededByWhitespace = Companion_getInstance_2().vdl_1.fdm(c) || isLineBreak;
    followedByWhitespace = true;
    if ((index + 1 | 0) < scalar.length) {
      var nextIndex = index + Character_getInstance().ldq(codePointAt(scalar, index)) | 0;
      if (nextIndex < scalar.length) {
        followedByWhitespace = Companion_getInstance_2().vdl_1.fdm(codePointAt(scalar, nextIndex)) || isLineBreak;
      }
    }
  }
  var allowFlowPlain = true;
  var allowBlockPlain = true;
  var allowSingleQuoted = true;
  var allowBlock = true;
  if (leadingSpace || leadingBreak || trailingSpace || trailingBreak) {
    allowBlockPlain = false;
    allowFlowPlain = false;
  }
  if (trailingSpace) {
    allowBlock = false;
  }
  if (breakSpace) {
    allowSingleQuoted = false;
    allowBlockPlain = false;
    allowFlowPlain = false;
  }
  if (spaceBreak || specialCharacters) {
    allowBlock = false;
    allowSingleQuoted = false;
    allowBlockPlain = false;
    allowFlowPlain = false;
  }
  if (lineBreaks) {
    allowFlowPlain = false;
  }
  if (flowIndicators) {
    allowFlowPlain = false;
  }
  if (blockIndicators) {
    allowBlockPlain = false;
  }
  return new ScalarAnalysis(scalar, false, lineBreaks, allowFlowPlain, allowBlockPlain, allowSingleQuoted, allowBlock);
}
function flushStream($this) {
  return $this.wdm_1.gd();
}
function writeStreamStart($this) {
  return Unit_instance;
}
function writeStreamEnd($this) {
  return flushStream($this);
}
function writeIndicator($this, indicator, needWhitespace, whitespace, indentation) {
  if (!$this.idn_1 && needWhitespace) {
    $this.hdn_1 = $this.hdn_1 + 1 | 0;
    $this.wdm_1.d1l(' ');
  }
  $this.idn_1 = whitespace;
  $this.jdn_1 = ($this.jdn_1 && indentation);
  $this.hdn_1 = $this.hdn_1 + indicator.length | 0;
  $this.kdn_1 = false;
  $this.wdm_1.d1l(indicator);
}
function writeIndicator$default($this, indicator, needWhitespace, whitespace, indentation, $super) {
  needWhitespace = needWhitespace === VOID ? false : needWhitespace;
  whitespace = whitespace === VOID ? false : whitespace;
  indentation = indentation === VOID ? false : indentation;
  return writeIndicator($this, indicator, needWhitespace, whitespace, indentation);
}
function writeIndent($this) {
  var tmp0_elvis_lhs = $this.cdn_1;
  var indentToWrite = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  if (!$this.jdn_1 || $this.hdn_1 > indentToWrite || ($this.hdn_1 === indentToWrite && !$this.idn_1)) {
    writeLineBreak$default($this);
  }
  writeWhitespace($this, indentToWrite - $this.hdn_1 | 0);
}
function writeWhitespace($this, length) {
  if (length <= 0)
    return Unit_instance;
  $this.idn_1 = true;
  $this.wdm_1.d1l(repeat(' ', length));
  $this.hdn_1 = $this.hdn_1 + length | 0;
}
function writeLineBreak($this, data) {
  $this.idn_1 = true;
  $this.jdn_1 = true;
  $this.hdn_1 = 0;
  $this.wdm_1.d1l(data == null ? _get_bestLineBreak__5uxc8m($this) : data);
}
function writeLineBreak$default($this, data, $super) {
  data = data === VOID ? null : data;
  return writeLineBreak($this, data);
}
function writeSingleQuoted($this, text, split) {
  writeIndicator$default($this, "'", true);
  var spaces = false;
  var breaks = false;
  var start = 0;
  var end = 0;
  var ch;
  while (end <= text.length) {
    ch = _Char___init__impl__6a9atx(0);
    if (end < text.length) {
      ch = charSequenceGet(text, end);
    }
    if (spaces) {
      if (!(ch === _Char___init__impl__6a9atx(32))) {
        if ((start + 1 | 0) === end && $this.hdn_1 > $this.pdn_1 && split && !(start === 0) && !(end === text.length)) {
          writeIndent($this);
        } else {
          var len = end - start | 0;
          $this.hdn_1 = $this.hdn_1 + len | 0;
          $this.wdm_1.ddk(text, start, len);
        }
        start = end;
      }
    } else if (breaks) {
      var tmp;
      // Inline function 'kotlin.code' call
      var this_0 = ch;
      if (Char__toInt_impl_vasixd(this_0) === 0) {
        tmp = true;
      } else {
        var tmp_0 = Companion_getInstance_2().rdl_1;
        // Inline function 'kotlin.code' call
        var this_1 = ch;
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        tmp = tmp_0.gdm(tmp$ret$1);
      }
      if (tmp) {
        if (charSequenceGet(text, start) === _Char___init__impl__6a9atx(10)) {
          writeLineBreak$default($this);
        }
        // Inline function 'kotlin.text.substring' call
        var startIndex = start;
        var endIndex = end;
        // Inline function 'kotlin.js.asDynamic' call
        var data = text.substring(startIndex, endIndex);
        var indexedObject = toCharArray(data);
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var br = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (br === _Char___init__impl__6a9atx(10)) {
            writeLineBreak$default($this);
          } else {
            writeLineBreak($this, toString_0(br));
          }
        }
        writeIndent($this);
        start = end;
      }
    } else {
      var tmp_1 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_2 = ch;
      var tmp$ret$4 = Char__toInt_impl_vasixd(this_2);
      if (tmp_1.hdm(tmp$ret$4, "\x00 '")) {
        if (start < end) {
          var len_0 = end - start | 0;
          $this.hdn_1 = $this.hdn_1 + len_0 | 0;
          $this.wdm_1.ddk(text, start, len_0);
          start = end;
        }
      }
    }
    if (ch === _Char___init__impl__6a9atx(39)) {
      $this.hdn_1 = $this.hdn_1 + 2 | 0;
      $this.wdm_1.d1l("''");
      start = end + 1 | 0;
    }
    // Inline function 'kotlin.code' call
    var this_3 = ch;
    if (!(Char__toInt_impl_vasixd(this_3) === 0)) {
      spaces = ch === _Char___init__impl__6a9atx(32);
      var tmp_2 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_4 = ch;
      var tmp$ret$6 = Char__toInt_impl_vasixd(this_4);
      breaks = tmp_2.fdm(tmp$ret$6);
    }
    end = end + 1 | 0;
  }
  writeIndicator$default($this, "'");
}
function writeDoubleQuoted($this, text, split) {
  writeIndicator$default($this, '"', true);
  var start = 0;
  var end = 0;
  while (end <= text.length) {
    var ch = null;
    if (end < text.length) {
      ch = charSequenceGet(text, end);
    }
    var tmp;
    var tmp_0;
    var tmp_1 = ch;
    if ((tmp_1 == null ? null : new Char(tmp_1)) == null) {
      tmp_0 = true;
    } else {
      tmp_0 = contains_0('"\\\x85\u2028\u2029\uFEFF', ch);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(Char__compareTo_impl_ypi4mb(_Char___init__impl__6a9atx(32), ch) <= 0 && Char__compareTo_impl_ypi4mb(ch, _Char___init__impl__6a9atx(126)) <= 0);
    }
    if (tmp) {
      if (start < end) {
        var len = end - start | 0;
        $this.hdn_1 = $this.hdn_1 + len | 0;
        $this.wdm_1.ddk(text, start, len);
        start = end;
      }
      var tmp_2 = ch;
      if (!((tmp_2 == null ? null : new Char(tmp_2)) == null)) {
        var data;
        // Inline function 'kotlin.collections.contains' call
        var this_0 = Companion_getInstance_4().rdh_1;
        var tmp_3 = ch;
        // Inline function 'kotlin.collections.containsKey' call
        var key = tmp_3 == null ? null : new Char(tmp_3);
        if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(key)) {
          var tmp_4 = Companion_getInstance_4().rdh_1;
          var tmp_5 = ch;
          data = '\\' + tmp_4.e3(tmp_5 == null ? null : new Char(tmp_5));
        } else {
          var tmp_6;
          if (isHighSurrogate(ch) && (end + 1 | 0) < text.length) {
            var ch2 = charSequenceGet(text, end + 1 | 0);
            tmp_6 = Character_getInstance().mdq(ch, ch2);
          } else {
            // Inline function 'kotlin.code' call
            var this_1 = ch;
            tmp_6 = Char__toInt_impl_vasixd(this_1);
          }
          var codePoint = tmp_6;
          if ($this.ndn_1 && Companion_instance_12.odq(codePoint)) {
            data = concatToString(Character_getInstance().ndq(codePoint));
            if (Character_getInstance().ldq(codePoint) === 2) {
              end = end + 1 | 0;
            }
          } else {
            var tmp_7;
            if (Char__compareTo_impl_ypi4mb(ch, _Char___init__impl__6a9atx(255)) <= 0) {
              // Inline function 'kotlin.code' call
              var this_2 = ch;
              var tmp$ret$3 = Char__toInt_impl_vasixd(this_2);
              var s = '0' + toString_2(tmp$ret$3, 16);
              // Inline function 'kotlin.text.substring' call
              var startIndex = s.length - 2 | 0;
              // Inline function 'kotlin.js.asDynamic' call
              tmp_7 = '\\x' + s.substring(startIndex);
            } else if (Character_getInstance().ldq(codePoint) === 2) {
              end = end + 1 | 0;
              var s_0 = '000' + toString_2(codePoint, 16);
              // Inline function 'kotlin.text.substring' call
              var startIndex_0 = s_0.length - 8 | 0;
              // Inline function 'kotlin.js.asDynamic' call
              tmp_7 = '\\U' + s_0.substring(startIndex_0);
            } else {
              // Inline function 'kotlin.code' call
              var this_3 = ch;
              var tmp$ret$8 = Char__toInt_impl_vasixd(this_3);
              var s_1 = '000' + toString_2(tmp$ret$8, 16);
              // Inline function 'kotlin.text.substring' call
              var startIndex_1 = s_1.length - 4 | 0;
              // Inline function 'kotlin.js.asDynamic' call
              tmp_7 = '\\u' + s_1.substring(startIndex_1);
            }
            data = tmp_7;
          }
        }
        $this.hdn_1 = $this.hdn_1 + data.length | 0;
        $this.wdm_1.d1l(data);
        start = end + 1 | 0;
      }
    }
    var tmp_8;
    var tmp_9;
    var tmp_10;
    if (0 < end && end < (text.length - 1 | 0)) {
      var tmp_11;
      var tmp_12 = ch;
      if (equals(tmp_12 == null ? null : new Char(tmp_12), new Char(_Char___init__impl__6a9atx(32)))) {
        tmp_11 = true;
      } else {
        tmp_11 = start >= end;
      }
      tmp_10 = tmp_11;
    } else {
      tmp_10 = false;
    }
    if (tmp_10) {
      tmp_9 = ($this.hdn_1 + (end - start | 0) | 0) > $this.pdn_1;
    } else {
      tmp_9 = false;
    }
    if (tmp_9) {
      tmp_8 = split;
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      var data_0;
      var tmp_13;
      if (start >= end) {
        tmp_13 = '\\';
      } else {
        // Inline function 'kotlin.text.substring' call
        var startIndex_2 = start;
        var endIndex = end;
        // Inline function 'kotlin.js.asDynamic' call
        tmp_13 = text.substring(startIndex_2, endIndex) + '\\';
      }
      data_0 = tmp_13;
      if (start < end) {
        start = end;
      }
      $this.hdn_1 = $this.hdn_1 + data_0.length | 0;
      $this.wdm_1.d1l(data_0);
      writeIndent($this);
      $this.idn_1 = false;
      $this.jdn_1 = false;
      if (charSequenceGet(text, start) === _Char___init__impl__6a9atx(32)) {
        data_0 = '\\';
        $this.hdn_1 = $this.hdn_1 + data_0.length | 0;
        $this.wdm_1.d1l(data_0);
      }
    }
    end = end + 1 | 0;
  }
  writeIndicator$default($this, '"');
}
function writeCommentLines($this, commentLines) {
  var wroteComment = false;
  if (_get_emitComments__dxus78($this)) {
    var indentColumns = 0;
    var firstComment = true;
    var _iterator__ex2g4s = commentLines.b1();
    while (_iterator__ex2g4s.c1()) {
      var commentLine = _iterator__ex2g4s.d1();
      if (!commentLine.ydk_1.equals(CommentType_BLANK_LINE_getInstance())) {
        if (firstComment) {
          firstComment = false;
          writeIndicator$default($this, '#', commentLine.ydk_1.equals(CommentType_IN_LINE_getInstance()));
          indentColumns = $this.hdn_1 > 0 ? $this.hdn_1 - 1 | 0 : 0;
        } else {
          writeWhitespace($this, indentColumns);
          writeIndicator$default($this, '#');
        }
        $this.wdm_1.d1l(commentLine.xdk_1);
        writeLineBreak$default($this);
      } else {
        writeLineBreak$default($this);
        writeIndent($this);
      }
      wroteComment = true;
    }
  }
  return wroteComment;
}
function writeBlockComment($this) {
  if (!$this.vdn_1.j1()) {
    writeIndent($this);
    writeCommentLines($this, $this.vdn_1.ddl());
  }
}
function writeInlineComments($this) {
  return writeCommentLines($this, $this.wdn_1.ddl());
}
function determineBlockHints($this, text) {
  var hints = StringBuilder.f();
  var tmp = Companion_getInstance_2().rdl_1;
  // Inline function 'kotlin.code' call
  var this_0 = first(text);
  var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
  if (tmp.hdm(tmp$ret$0, ' ')) {
    hints.rh($this.odn_1);
  }
  var ch1 = last(text);
  var tmp_0 = Companion_getInstance_2().rdl_1;
  // Inline function 'kotlin.code' call
  var tmp$ret$1 = Char__toInt_impl_vasixd(ch1);
  if (tmp_0.gdm(tmp$ret$1)) {
    hints.gc('-');
  } else {
    var tmp_1;
    if (text.length === 1) {
      tmp_1 = true;
    } else {
      var tmp_2 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_1 = charSequenceGet(text, text.length - 2 | 0);
      var tmp$ret$2 = Char__toInt_impl_vasixd(this_1);
      tmp_1 = tmp_2.fdm(tmp$ret$2);
    }
    if (tmp_1) {
      hints.gc('+');
    }
  }
  return hints.toString();
}
function writeFolded($this, text, split) {
  var hints = determineBlockHints($this, text);
  writeIndicator$default($this, '>' + hints, true);
  if (endsWith(hints, _Char___init__impl__6a9atx(43))) {
    $this.kdn_1 = true;
  }
  if (!writeInlineComments($this)) {
    writeLineBreak$default($this);
  }
  var leadingSpace = true;
  var spaces = false;
  var breaks = true;
  var start = 0;
  var end = 0;
  while (end <= text.length) {
    var ch = _Char___init__impl__6a9atx(0);
    if (end < text.length) {
      ch = charSequenceGet(text, end);
    }
    if (breaks) {
      var tmp;
      // Inline function 'kotlin.code' call
      var this_0 = ch;
      if (Char__toInt_impl_vasixd(this_0) === 0) {
        tmp = true;
      } else {
        var tmp_0 = Companion_getInstance_2().rdl_1;
        // Inline function 'kotlin.code' call
        var this_1 = ch;
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        tmp = tmp_0.gdm(tmp$ret$1);
      }
      if (tmp) {
        var tmp_1;
        var tmp_2;
        var tmp_3;
        if (!leadingSpace) {
          // Inline function 'kotlin.code' call
          var this_2 = ch;
          tmp_3 = !(Char__toInt_impl_vasixd(this_2) === 0);
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp_2 = !(ch === _Char___init__impl__6a9atx(32));
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = charSequenceGet(text, start) === _Char___init__impl__6a9atx(10);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          writeLineBreak$default($this);
        }
        leadingSpace = ch === _Char___init__impl__6a9atx(32);
        // Inline function 'kotlin.text.substring' call
        var startIndex = start;
        var endIndex = end;
        // Inline function 'kotlin.js.asDynamic' call
        var data = text.substring(startIndex, endIndex);
        var indexedObject = toCharArray(data);
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var br = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          writeLineBreak($this, br === _Char___init__impl__6a9atx(10) ? null : toString_0(br));
        }
        // Inline function 'kotlin.code' call
        var this_3 = ch;
        if (!(Char__toInt_impl_vasixd(this_3) === 0)) {
          writeIndent($this);
        }
        start = end;
      }
    } else if (spaces) {
      if (!(ch === _Char___init__impl__6a9atx(32))) {
        if ((start + 1 | 0) === end && $this.hdn_1 > $this.pdn_1 && split) {
          writeIndent($this);
        } else {
          var len = end - start | 0;
          $this.hdn_1 = $this.hdn_1 + len | 0;
          $this.wdm_1.ddk(text, start, len);
        }
        start = end;
      }
    } else {
      var tmp_4 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_4 = ch;
      var tmp$ret$6 = Char__toInt_impl_vasixd(this_4);
      if (tmp_4.hdm(tmp$ret$6, '\x00 ')) {
        var len_0 = end - start | 0;
        $this.hdn_1 = $this.hdn_1 + len_0 | 0;
        $this.wdm_1.ddk(text, start, len_0);
        // Inline function 'kotlin.code' call
        var this_5 = ch;
        if (Char__toInt_impl_vasixd(this_5) === 0) {
          writeLineBreak$default($this);
        }
        start = end;
      }
    }
    // Inline function 'kotlin.code' call
    var this_6 = ch;
    if (!(Char__toInt_impl_vasixd(this_6) === 0)) {
      var tmp_5 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_7 = ch;
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_7);
      breaks = tmp_5.fdm(tmp$ret$9);
      spaces = ch === _Char___init__impl__6a9atx(32);
    }
    end = end + 1 | 0;
  }
}
function writeLiteral($this, text) {
  var hints = determineBlockHints($this, text);
  writeIndicator$default($this, '|' + hints, true);
  if (endsWith(hints, _Char___init__impl__6a9atx(43))) {
    $this.kdn_1 = true;
  }
  if (!writeInlineComments($this)) {
    writeLineBreak$default($this);
  }
  var breaks = true;
  var start = 0;
  var end = 0;
  while (end <= text.length) {
    var ch = _Char___init__impl__6a9atx(0);
    if (end < text.length) {
      ch = charSequenceGet(text, end);
    }
    if (breaks) {
      var tmp;
      // Inline function 'kotlin.code' call
      var this_0 = ch;
      if (Char__toInt_impl_vasixd(this_0) === 0) {
        tmp = true;
      } else {
        var tmp_0 = Companion_getInstance_2().rdl_1;
        // Inline function 'kotlin.code' call
        var this_1 = ch;
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        tmp = tmp_0.gdm(tmp$ret$1);
      }
      if (tmp) {
        // Inline function 'kotlin.text.substring' call
        var startIndex = start;
        var endIndex = end;
        // Inline function 'kotlin.js.asDynamic' call
        var data = text.substring(startIndex, endIndex);
        var indexedObject = toCharArray(data);
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var br = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (br === _Char___init__impl__6a9atx(10)) {
            writeLineBreak$default($this);
          } else {
            writeLineBreak($this, toString_0(br));
          }
        }
        // Inline function 'kotlin.code' call
        var this_2 = ch;
        if (!(Char__toInt_impl_vasixd(this_2) === 0)) {
          writeIndent($this);
        }
        start = end;
      }
    } else {
      var tmp_1;
      // Inline function 'kotlin.code' call
      var this_3 = ch;
      if (Char__toInt_impl_vasixd(this_3) === 0) {
        tmp_1 = true;
      } else {
        var tmp_2 = Companion_getInstance_2().rdl_1;
        // Inline function 'kotlin.code' call
        var this_4 = ch;
        var tmp$ret$6 = Char__toInt_impl_vasixd(this_4);
        tmp_1 = tmp_2.fdm(tmp$ret$6);
      }
      if (tmp_1) {
        $this.wdm_1.ddk(text, start, end - start | 0);
        // Inline function 'kotlin.code' call
        var this_5 = ch;
        if (Char__toInt_impl_vasixd(this_5) === 0) {
          writeLineBreak$default($this);
        }
        start = end;
      }
    }
    // Inline function 'kotlin.code' call
    var this_6 = ch;
    if (!(Char__toInt_impl_vasixd(this_6) === 0)) {
      var tmp_3 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_7 = ch;
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_7);
      breaks = tmp_3.fdm(tmp$ret$9);
    }
    end = end + 1 | 0;
  }
}
function writePlain($this, text, split) {
  if ($this.edn_1) {
    $this.kdn_1 = true;
  }
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    return Unit_instance;
  }
  if (!$this.idn_1) {
    $this.hdn_1 = $this.hdn_1 + 1 | 0;
    $this.wdm_1.d1l(' ');
  }
  $this.idn_1 = false;
  $this.jdn_1 = false;
  var spaces = false;
  var breaks = false;
  var start = 0;
  var end = 0;
  while (end <= text.length) {
    var ch = _Char___init__impl__6a9atx(0);
    if (end < text.length) {
      ch = charSequenceGet(text, end);
    }
    if (spaces) {
      if (!(ch === _Char___init__impl__6a9atx(32))) {
        if ((start + 1 | 0) === end && $this.hdn_1 > $this.pdn_1 && split) {
          writeIndent($this);
          $this.idn_1 = false;
          $this.jdn_1 = false;
        } else {
          var len = end - start | 0;
          $this.hdn_1 = $this.hdn_1 + len | 0;
          $this.wdm_1.ddk(text, start, len);
        }
        start = end;
      }
    } else if (breaks) {
      var tmp = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_0 = ch;
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_0);
      if (tmp.gdm(tmp$ret$1)) {
        if (charSequenceGet(text, start) === _Char___init__impl__6a9atx(10)) {
          writeLineBreak$default($this);
        }
        // Inline function 'kotlin.text.substring' call
        var startIndex = start;
        var endIndex = end;
        // Inline function 'kotlin.js.asDynamic' call
        var data = text.substring(startIndex, endIndex);
        var indexedObject = toCharArray(data);
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var br = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          writeLineBreak($this, br === _Char___init__impl__6a9atx(10) ? null : toString_0(br));
        }
        writeIndent($this);
        $this.idn_1 = false;
        $this.jdn_1 = false;
        start = end;
      }
    } else {
      var tmp_0 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_1 = ch;
      var tmp$ret$4 = Char__toInt_impl_vasixd(this_1);
      if (tmp_0.hdm(tmp$ret$4, '\x00 ')) {
        var len_0 = end - start | 0;
        $this.hdn_1 = $this.hdn_1 + len_0 | 0;
        $this.wdm_1.ddk(text, start, len_0);
        start = end;
      }
    }
    // Inline function 'kotlin.code' call
    var this_2 = ch;
    if (!(Char__toInt_impl_vasixd(this_2) === 0)) {
      spaces = ch === _Char___init__impl__6a9atx(32);
      var tmp_1 = Companion_getInstance_2().rdl_1;
      // Inline function 'kotlin.code' call
      var this_3 = ch;
      var tmp$ret$6 = Char__toInt_impl_vasixd(this_3);
      breaks = tmp_1.fdm(tmp$ret$6);
    }
    end = end + 1 | 0;
  }
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function init_it_krzeminski_snakeyaml_engine_kmp_events_CollectionEndEvent(_this__u8e3s4) {
}
var ID_Alias_instance;
var ID_Comment_instance;
var ID_DocumentEnd_instance;
var ID_DocumentStart_instance;
var ID_MappingEnd_instance;
var ID_MappingStart_instance;
var ID_Scalar_instance;
var ID_SequenceEnd_instance;
var ID_SequenceStart_instance;
var ID_StreamEnd_instance;
var ID_StreamStart_instance;
var ID_entriesInitialized;
function ID_initEntries() {
  if (ID_entriesInitialized)
    return Unit_instance;
  ID_entriesInitialized = true;
  ID_Alias_instance = new ID('Alias', 0);
  ID_Comment_instance = new ID('Comment', 1);
  ID_DocumentEnd_instance = new ID('DocumentEnd', 2);
  ID_DocumentStart_instance = new ID('DocumentStart', 3);
  ID_MappingEnd_instance = new ID('MappingEnd', 4);
  ID_MappingStart_instance = new ID('MappingStart', 5);
  ID_Scalar_instance = new ID('Scalar', 6);
  ID_SequenceEnd_instance = new ID('SequenceEnd', 7);
  ID_SequenceStart_instance = new ID('SequenceStart', 8);
  ID_StreamEnd_instance = new ID('StreamEnd', 9);
  ID_StreamStart_instance = new ID('StreamStart', 10);
}
function ID_Alias_getInstance() {
  ID_initEntries();
  return ID_Alias_instance;
}
function ID_Comment_getInstance() {
  ID_initEntries();
  return ID_Comment_instance;
}
function ID_DocumentEnd_getInstance() {
  ID_initEntries();
  return ID_DocumentEnd_instance;
}
function ID_DocumentStart_getInstance() {
  ID_initEntries();
  return ID_DocumentStart_instance;
}
function ID_MappingEnd_getInstance() {
  ID_initEntries();
  return ID_MappingEnd_instance;
}
function ID_MappingStart_getInstance() {
  ID_initEntries();
  return ID_MappingStart_instance;
}
function ID_Scalar_getInstance() {
  ID_initEntries();
  return ID_Scalar_instance;
}
function ID_SequenceEnd_getInstance() {
  ID_initEntries();
  return ID_SequenceEnd_instance;
}
function ID_SequenceStart_getInstance() {
  ID_initEntries();
  return ID_SequenceStart_instance;
}
function ID_StreamEnd_getInstance() {
  ID_initEntries();
  return ID_StreamEnd_instance;
}
function ID_StreamStart_getInstance() {
  ID_initEntries();
  return ID_StreamStart_instance;
}
function init_it_krzeminski_snakeyaml_engine_kmp_events_MappingEndEvent(_this__u8e3s4) {
}
function ScalarEvent$escapedValue$lambda(ch) {
  return Companion_getInstance_2().ddm(numberToChar(ch));
}
function init_it_krzeminski_snakeyaml_engine_kmp_events_SequenceEndEvent(_this__u8e3s4) {
}
function init_it_krzeminski_snakeyaml_engine_kmp_events_StreamEndEvent(_this__u8e3s4) {
}
function init_it_krzeminski_snakeyaml_engine_kmp_events_StreamStartEvent(_this__u8e3s4) {
}
function isLineBreak($this, c) {
  return Companion_getInstance_2().sdl_1.fdm(c);
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function buildReadableError($this, context, contextMark, problem, problemMark) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'it.krzeminski.snakeyaml.engine.kmp.exceptions.Companion.buildReadableError.<anonymous>' call
  if (!(context == null)) {
    // Inline function 'kotlin.text.appendLine' call
    // Inline function 'kotlin.text.appendLine' call
    this_0.gc(context).hc(_Char___init__impl__6a9atx(10));
  }
  if (!(contextMark == null)) {
    var problemIsPresent = !(problem == null) && !(problemMark == null);
    var tmp;
    var tmp_0;
    var tmp_1;
    if (!problemIsPresent) {
      tmp_1 = true;
    } else {
      tmp_1 = contextMark.nds_1 === (problemMark == null ? null : problemMark.nds_1);
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !(contextMark.pds_1 === (problemMark == null ? null : problemMark.pds_1));
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(contextMark.qds_1 === problemMark.qds_1);
    }
    if (tmp) {
      // Inline function 'kotlin.text.appendLine' call
      // Inline function 'kotlin.text.appendLine' call
      this_0.fc(contextMark).hc(_Char___init__impl__6a9atx(10));
    }
  }
  if (!(problem == null)) {
    // Inline function 'kotlin.text.appendLine' call
    // Inline function 'kotlin.text.appendLine' call
    this_0.gc(problem).hc(_Char___init__impl__6a9atx(10));
  }
  if (!(problemMark == null)) {
    // Inline function 'kotlin.text.appendLine' call
    // Inline function 'kotlin.text.appendLine' call
    this_0.fc(problemMark).hc(_Char___init__impl__6a9atx(10));
  }
  return this_0.toString();
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function init_it_krzeminski_snakeyaml_engine_kmp_exceptions_YamlEngineException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.edq_1);
}
function joinCodepointsToString(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'it.krzeminski.snakeyaml.engine.kmp.internal.utils.joinCodepointsToString.<anonymous>' call
  appendCodePoints(this_0, _this__u8e3s4);
  return this_0.toString();
}
function appendCodePoint(_this__u8e3s4, codePoint) {
  if (Character_getInstance().kdu(codePoint)) {
    _this__u8e3s4.hc(numberToChar(codePoint));
  } else {
    _this__u8e3s4.hc(Character_getInstance().idu(codePoint));
    _this__u8e3s4.hc(Character_getInstance().jdu(codePoint));
  }
  return _this__u8e3s4;
}
function appendCodePoints(_this__u8e3s4, codePoints) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = codePoints.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'it.krzeminski.snakeyaml.engine.kmp.internal.utils.appendCodePoints.<anonymous>' call
    appendCodePoint(_this__u8e3s4, element);
  }
  return _this__u8e3s4;
}
function codePointAt(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (charSequenceLength(_this__u8e3s4) - 1 | 0) : false))
    throw IndexOutOfBoundsException.ze('index ' + index + ' was not in range ' + get_indices(_this__u8e3s4).toString());
  var firstChar = charSequenceGet(_this__u8e3s4, index);
  if (isHighSurrogate(firstChar)) {
    var nextChar = getOrNull(_this__u8e3s4, index + 1 | 0);
    var tmp;
    var tmp_0 = nextChar;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = isLowSurrogate(nextChar);
    }
    if (tmp === true) {
      return Character_getInstance().mdq(firstChar, nextChar);
    }
  }
  // Inline function 'kotlin.code' call
  return Char__toInt_impl_vasixd(firstChar);
}
function toCodePoints(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  var capacity = charSequenceLength(_this__u8e3s4);
  checkBuilderCapacity(capacity);
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.w(capacity);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'it.krzeminski.snakeyaml.engine.kmp.internal.utils.toCodePoints.<anonymous>' call
  var i = 0;
  var c = 0;
  while (i < charSequenceLength(_this__u8e3s4)) {
    var cp = codePointAt(_this__u8e3s4, i);
    this_0.h(cp);
    i = i + Character_getInstance().ldq(cp) | 0;
    c = c + 1 | 0;
  }
  return this_0.m8();
}
var Character_instance;
function Character_getInstance() {
  if (Character_instance === VOID)
    new Character();
  return Character_instance;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function produce($this) {
  if ($this.edv_1 == null) {
    var tmp52_safe_receiver = $this.fdv_1;
    if (tmp52_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this.edv_1 = tmp52_safe_receiver.hdv();
    }
  }
}
function produceCommentEvent($this, token) {
  return CommentEvent.cdr(token.kdv_1, token.ldv_1, token.mdv_1, token.ndv_1);
}
function processDirectives($this) {
  var yamlSpecVersion = null;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var tagHandles = LinkedHashMap.wc();
  $l$loop: while ($this.bdv_1.odv([ID_Directive_getInstance()])) {
    var tmp = $this.bdv_1.d1();
    var directive = tmp instanceof DirectiveToken ? tmp : THROW_CCE();
    if (directive.rdv_1 == null)
      continue $l$loop;
    var tmp53_subject = directive.rdv_1;
    if (tmp53_subject instanceof TagDirective) {
      var _destruct__k2r9zo = directive.rdv_1;
      var handle = _destruct__k2r9zo.em();
      var prefix = _destruct__k2r9zo.fm();
      if (tagHandles.c3(handle)) {
        throw ParserException.odt('duplicate tag handle ' + handle, directive.mdv_1);
      }
      // Inline function 'kotlin.collections.set' call
      tagHandles.k3(handle, prefix);
    } else {
      if (tmp53_subject instanceof YamlDirective) {
        if (!(yamlSpecVersion == null)) {
          throw ParserException.odt('found duplicate YAML directive', directive.mdv_1);
        }
        var _destruct__k2r9zo_0 = directive.rdv_1;
        var major = _destruct__k2r9zo_0.em();
        var minor = _destruct__k2r9zo_0.fm();
        yamlSpecVersion = $this.adv_1.pdi_1.jdi(new SpecVersion(major, minor));
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  // Inline function 'kotlin.collections.mutableMapOf' call
  var detectedTagHandles = LinkedHashMap.wc();
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tagHandles.j1()) {
    detectedTagHandles.m3(tagHandles);
  }
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = Companion_getInstance_8().wdv_1.u1().b1();
  while (_iterator__ex2g4s.c1()) {
    var _destruct__k2r9zo_1 = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo_1.v1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo_1.w1();
    if (!tagHandles.c3(key)) {
      // Inline function 'kotlin.collections.set' call
      tagHandles.k3(key, value);
    }
  }
  $this.gdv_1 = tagHandles;
  return new VersionTagsTuple(yamlSpecVersion, detectedTagHandles);
}
function parseFlowNode($this) {
  return parseNode($this, false, false);
}
function parseBlockNodeOrIndentlessSequence($this) {
  return parseNode($this, true, true);
}
function parseNode($this, block, indentlessSequence) {
  var startMark = null;
  var endMark = null;
  var tagMark = null;
  if ($this.bdv_1.odv([ID_Alias_getInstance_0()])) {
    var tmp = $this.bdv_1.d1();
    var token = tmp instanceof AliasToken ? tmp : THROW_CCE();
    $this.fdv_1 = $this.cdv_1.sl();
    return AliasEvent.udq(token.odw_1, token.mdv_1, token.ndv_1);
  } else {
    var anchor;
    var tagTupleValue;
    if ($this.bdv_1.odv([ID_Anchor_getInstance()])) {
      var tmp_0 = $this.bdv_1.d1();
      var token_0 = tmp_0 instanceof AnchorToken ? tmp_0 : THROW_CCE();
      startMark = token_0.mdv_1;
      endMark = token_0.ndv_1;
      anchor = token_0.cdw_1;
      if ($this.bdv_1.odv([ID_Tag_getInstance()])) {
        var tmp_1 = $this.bdv_1.d1();
        var tagToken = tmp_1 instanceof TagToken ? tmp_1 : THROW_CCE();
        tagMark = tagToken.mdv_1;
        endMark = tagToken.ndv_1;
        tagTupleValue = tagToken.zdv_1;
      } else {
        tagTupleValue = null;
      }
    } else if ($this.bdv_1.odv([ID_Tag_getInstance()])) {
      var tmp_2 = $this.bdv_1.d1();
      var tagToken_0 = tmp_2 instanceof TagToken ? tmp_2 : THROW_CCE();
      startMark = tagToken_0.mdv_1;
      tagMark = startMark;
      endMark = tagToken_0.ndv_1;
      tagTupleValue = tagToken_0.zdv_1;
      if ($this.bdv_1.odv([ID_Anchor_getInstance()])) {
        var tmp_3 = $this.bdv_1.d1();
        var token_1 = tmp_3 instanceof AnchorToken ? tmp_3 : THROW_CCE();
        endMark = token_1.ndv_1;
        anchor = token_1.cdw_1;
      } else {
        anchor = null;
      }
    } else {
      tagTupleValue = null;
      anchor = null;
    }
    var tag;
    if (!(tagTupleValue == null)) {
      var handle = tagTupleValue.ddw_1;
      var tmp_4;
      if (!(handle == null)) {
        if (!$this.gdv_1.c3(handle)) {
          throw ParserException.odt('found undefined tag handle ' + handle, startMark, 'while parsing a node', tagMark);
        }
        tmp_4 = plus($this.gdv_1.e3(handle), tagTupleValue.edw_1);
      } else {
        tmp_4 = tagTupleValue.edw_1;
      }
      tag = tmp_4;
    } else {
      tag = null;
    }
    if (startMark == null) {
      startMark = $this.bdv_1.fdw().mdv_1;
      endMark = startMark;
    }
    var implicit = tag == null;
    var tmp_5;
    if (indentlessSequence && $this.bdv_1.odv([ID_BlockEntry_getInstance()])) {
      endMark = $this.bdv_1.fdw().ndv_1;
      $this.fdv_1 = new ParseIndentlessSequenceEntryKey($this);
      tmp_5 = SequenceStartEvent.dds(anchor, tag, implicit, FlowStyle_BLOCK_getInstance(), startMark, endMark);
    } else if ($this.bdv_1.odv([ID_Scalar_getInstance_0()])) {
      var tmp_6 = $this.bdv_1.d1();
      var token_2 = tmp_6 instanceof ScalarToken ? tmp_6 : THROW_CCE();
      endMark = token_2.ndv_1;
      var implicitValues = token_2.kdw_1 && tag == null ? new ImplicitTuple(true, false) : tag == null ? new ImplicitTuple(false, true) : new ImplicitTuple(false, false);
      $this.fdv_1 = $this.cdv_1.sl();
      tmp_5 = ScalarEvent.rdr(anchor, tag, implicitValues, token_2.jdw_1, token_2.ldw_1, startMark, endMark);
    } else if ($this.bdv_1.odv([ID_FlowSequenceStart_getInstance()])) {
      endMark = $this.bdv_1.fdw().ndv_1;
      $this.fdv_1 = new ParseFlowSequenceFirstEntry($this);
      tmp_5 = SequenceStartEvent.dds(anchor, tag, implicit, FlowStyle_FLOW_getInstance(), startMark, endMark);
    } else if ($this.bdv_1.odv([ID_FlowMappingStart_getInstance()])) {
      endMark = $this.bdv_1.fdw().ndv_1;
      $this.fdv_1 = new ParseFlowMappingFirstKey($this);
      tmp_5 = MappingStartEvent.qdr(anchor, tag, implicit, FlowStyle_FLOW_getInstance(), startMark, endMark);
    } else if (block && $this.bdv_1.odv([ID_BlockSequenceStart_getInstance()])) {
      endMark = $this.bdv_1.fdw().mdv_1;
      $this.fdv_1 = new ParseBlockSequenceFirstEntry($this);
      tmp_5 = SequenceStartEvent.dds(anchor, tag, implicit, FlowStyle_BLOCK_getInstance(), startMark, endMark);
    } else if (block && $this.bdv_1.odv([ID_BlockMappingStart_getInstance()])) {
      endMark = $this.bdv_1.fdw().mdv_1;
      $this.fdv_1 = new ParseBlockMappingFirstKey($this);
      tmp_5 = MappingStartEvent.qdr(anchor, tag, implicit, FlowStyle_BLOCK_getInstance(), startMark, endMark);
    } else if (!(anchor == null) || !(tag == null)) {
      $this.fdv_1 = $this.cdv_1.sl();
      var nonPlainImplicit = new ImplicitTuple(implicit, false);
      tmp_5 = ScalarEvent.rdr(anchor, tag, nonPlainImplicit, '', ScalarStyle_PLAIN_getInstance(), startMark, endMark);
    } else {
      var token_3 = $this.bdv_1.fdw();
      throw ParserException.odt("expected the node content, but found '" + token_3.gdw().toString() + "'", startMark, 'while parsing a ' + (block ? 'block' : 'flow') + ' node', token_3.mdv_1);
    }
    return tmp_5;
  }
}
function processEmptyScalar($this, mark) {
  return ScalarEvent.rdr(null, null, new ImplicitTuple(true, false), '', ScalarStyle_PLAIN_getInstance(), mark, mark);
}
function markPop($this) {
  return $this.ddv_1.sl();
}
function markPush($this, mark) {
  return $this.ddv_1.pl(mark);
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function BaseScalarResolver$_init_$lambda_ep9miw(_this__u8e3s4) {
  return Unit_instance;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
function JsonScalarResolver$_init_$lambda_2rw3ox(_this__u8e3s4) {
  _this__u8e3s4.ddy(Companion_getInstance_7().tdu_1, Companion_getInstance_9().edy_1, null);
  _this__u8e3s4.ddy(Companion_getInstance_7().sdu_1, Companion_getInstance_10().hdy_1, 'tf');
  _this__u8e3s4.ddy(Companion_getInstance_7().qdu_1, Companion_getInstance_10().jdy_1, '-0123456789');
  _this__u8e3s4.ddy(Companion_getInstance_7().rdu_1, Companion_getInstance_10().idy_1, '-0123456789.');
  _this__u8e3s4.ddy(Companion_getInstance_7().tdu_1, Companion_getInstance_10().kdy_1, 'n\x00');
  _this__u8e3s4.ddy(Companion_getInstance_7().ydu_1, Companion_getInstance_9().fdy_1, '$');
  return Unit_instance;
}
function addToken($this, token) {
  $this.udy_1 = token;
  $this.pdy_1.pl(token);
}
function addToken_0($this, index, token) {
  if (index === $this.pdy_1.hl_1) {
    $this.udy_1 = token;
  }
  $this.pdy_1.n7(index, token);
}
function addAllTokens($this, tokens) {
  $this.udy_1 = last_0(tokens);
  // Inline function 'kotlin.collections.plusAssign' call
  var this_0 = $this.pdy_1;
  addAll(this_0, tokens);
}
function isBlockContext($this) {
  return $this.tdy_1 === 0;
}
function isFlowContext($this) {
  return !isBlockContext($this);
}
function needMoreTokens($this) {
  if ($this.sdy_1)
    return false;
  if ($this.pdy_1.j1())
    return true;
  stalePossibleSimpleKeys($this);
  return nextPossibleSimpleKey($this) === $this.vdy_1;
}
function fetchMoreTokens($this) {
  if ($this.ody_1.gdz_1 > $this.ndy_1.ydi_1) {
    throw YamlEngineException.fdq('The incoming YAML document exceeds the limit: ' + $this.ndy_1.ydi_1 + ' code points.');
  }
  scanToNextToken($this);
  stalePossibleSimpleKeys($this);
  unwindIndent($this, $this.ody_1.idz_1);
  var c = $this.ody_1.adl();
  if (c === 0) {
    fetchStreamEnd($this);
    return Unit_instance;
  }
  var tmp61_subject = numberToChar(c);
  if (tmp61_subject === _Char___init__impl__6a9atx(37)) {
    if (checkDirective($this)) {
      fetchDirective($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(45)) {
    if (checkDocumentStart($this)) {
      fetchDocumentStart($this);
      return Unit_instance;
    } else if (checkBlockEntry($this)) {
      fetchBlockEntry($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(46)) {
    if (checkDocumentEnd($this)) {
      fetchDocumentEnd($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(91)) {
    fetchFlowSequenceStart($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(123)) {
    fetchFlowMappingStart($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(93)) {
    fetchFlowSequenceEnd($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(125)) {
    fetchFlowMappingEnd($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(44)) {
    fetchFlowEntry($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(63)) {
    if (checkKey($this)) {
      fetchKey($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(58)) {
    if (checkValue($this)) {
      fetchValue($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(42)) {
    fetchAlias($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(38)) {
    fetchAnchor($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(33)) {
    fetchTag($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(124)) {
    if (isBlockContext($this)) {
      fetchLiteral($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(62)) {
    if (isBlockContext($this)) {
      fetchFolded($this);
      return Unit_instance;
    }
  } else if (tmp61_subject === _Char___init__impl__6a9atx(39)) {
    fetchSingle($this);
    return Unit_instance;
  } else if (tmp61_subject === _Char___init__impl__6a9atx(34)) {
    fetchDouble($this);
    return Unit_instance;
  }
  if (checkPlain($this)) {
    fetchPlain($this);
    return Unit_instance;
  }
  var chRepresentation = Companion_getInstance_2().ddm(first_0(Character_getInstance().ndq(c)));
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(9);
  if (c === Char__toInt_impl_vasixd(this_0)) {
    chRepresentation = chRepresentation + '(TAB)';
  }
  var tmp62_problem = "found character '" + chRepresentation + "' that cannot start any token. (Do not use " + chRepresentation + ' for indentation)';
  var tmp63_problemMark = $this.ody_1.jdz();
  throw ScannerException.gdu(tmp62_problem, tmp63_problemMark, 'while scanning for the next token', null);
}
function nextPossibleSimpleKey($this) {
  var tmp64_safe_receiver = firstOrNull($this.rdy_1.n3());
  return tmp64_safe_receiver == null ? null : tmp64_safe_receiver.kdz_1;
}
function stalePossibleSimpleKeys($this) {
  // Inline function 'kotlin.collections.iterator' call
  var iterator = $this.rdy_1.u1().b1();
  while (iterator.c1()) {
    var key = iterator.d1().w1();
    if (!(key.ndz_1 === $this.ody_1.hdz_1) || ($this.ody_1.fdz_1 - key.mdz_1 | 0) > 1024) {
      if (key.ldz_1) {
        var tmp65_contextMark = key.pdz_1;
        var tmp66_problemMark = $this.ody_1.jdz();
        throw ScannerException.gdu("could not find expected ':'", tmp66_problemMark, 'while scanning a simple key', tmp65_contextMark);
      }
      iterator.t6();
    }
  }
}
function savePossibleSimpleKey($this) {
  var required = isBlockContext($this) && $this.wdy_1 === $this.ody_1.idz_1;
  if (!$this.xdy_1 && required) {
    throw YamlEngineException.fdq('A simple key is required only if it is the first token in the current line');
  }
  if ($this.xdy_1) {
    removePossibleSimpleKey($this);
    var tokenNumber = $this.vdy_1 + $this.pdy_1.hl_1 | 0;
    var key = new SimpleKey(tokenNumber, required, $this.ody_1.fdz_1, $this.ody_1.hdz_1, $this.ody_1.idz_1, $this.ody_1.jdz());
    // Inline function 'kotlin.collections.set' call
    var this_0 = $this.rdy_1;
    var key_0 = $this.tdy_1;
    this_0.k3(key_0, key);
  }
}
function removePossibleSimpleKey($this) {
  var key = $this.rdy_1.l3($this.tdy_1);
  if (!(key == null) && key.ldz_1) {
    var tmp67_contextMark = key.pdz_1;
    var tmp68_problemMark = $this.ody_1.jdz();
    throw ScannerException.gdu("could not find expected ':'", tmp68_problemMark, 'while scanning a simple key', tmp67_contextMark);
  }
}
function unwindIndent($this, col) {
  if (isFlowContext($this)) {
    return Unit_instance;
  }
  while ($this.wdy_1 > col) {
    var mark = $this.ody_1.jdz();
    $this.wdy_1 = $this.qdy_1.sl();
    addToken($this, new BlockEndToken(mark, mark));
  }
}
function addIndent($this, column) {
  if ($this.wdy_1 >= column)
    return false;
  $this.qdy_1.pl($this.wdy_1);
  $this.wdy_1 = column;
  return true;
}
function fetchStreamStart($this) {
  var mark = $this.ody_1.jdz();
  var token = new StreamStartToken(mark, mark);
  addToken($this, token);
}
function fetchStreamEnd($this) {
  unwindIndent($this, -1);
  removePossibleSimpleKey($this);
  $this.xdy_1 = false;
  $this.rdy_1.h3();
  var mark = $this.ody_1.jdz();
  var token = new StreamEndToken(mark, mark);
  addToken($this, token);
  $this.sdy_1 = true;
}
function fetchDirective($this) {
  unwindIndent($this, -1);
  removePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var tok = scanDirective($this);
  addAllTokens($this, tok);
}
function fetchDocumentStart($this) {
  return fetchDocumentIndicator($this, true);
}
function fetchDocumentEnd($this) {
  return fetchDocumentIndicator($this, false);
}
function fetchDocumentIndicator($this, isDocumentStart) {
  unwindIndent($this, -1);
  removePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var startMark = $this.ody_1.jdz();
  $this.ody_1.qdz(3);
  var endMark = $this.ody_1.jdz();
  var tmp;
  if (isDocumentStart) {
    tmp = new DocumentStartToken(startMark, endMark);
  } else {
    tmp = new DocumentEndToken(startMark, endMark);
  }
  var token = tmp;
  addToken($this, token);
}
function fetchFlowSequenceStart($this) {
  return fetchFlowCollectionStart($this, false);
}
function fetchFlowMappingStart($this) {
  return fetchFlowCollectionStart($this, true);
}
function fetchFlowCollectionStart($this, isMappingStart) {
  savePossibleSimpleKey($this);
  $this.tdy_1 = $this.tdy_1 + 1 | 0;
  $this.xdy_1 = true;
  var startMark = $this.ody_1.jdz();
  $this.ody_1.qdz(1);
  var endMark = $this.ody_1.jdz();
  var tmp;
  if (isMappingStart) {
    tmp = new FlowMappingStartToken(startMark, endMark);
  } else {
    tmp = new FlowSequenceStartToken(startMark, endMark);
  }
  var token = tmp;
  addToken($this, token);
}
function fetchFlowSequenceEnd($this) {
  return fetchFlowCollectionEnd($this, false);
}
function fetchFlowMappingEnd($this) {
  return fetchFlowCollectionEnd($this, true);
}
function fetchFlowCollectionEnd($this, isMappingEnd) {
  removePossibleSimpleKey($this);
  $this.tdy_1 = $this.tdy_1 - 1 | 0;
  $this.xdy_1 = false;
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var endMark = $this.ody_1.jdz();
  var tmp;
  if (isMappingEnd) {
    tmp = new FlowMappingEndToken(startMark, endMark);
  } else {
    tmp = new FlowSequenceEndToken(startMark, endMark);
  }
  var token = tmp;
  addToken($this, token);
}
function fetchFlowEntry($this) {
  $this.xdy_1 = true;
  removePossibleSimpleKey($this);
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var endMark = $this.ody_1.jdz();
  var token = new FlowEntryToken(startMark, endMark);
  addToken($this, token);
}
function fetchBlockEntry($this) {
  if (isBlockContext($this)) {
    if (!$this.xdy_1) {
      throw ScannerException.gdu('', null, 'sequence entries are not allowed here', $this.ody_1.jdz());
    }
    if (addIndent($this, $this.ody_1.idz_1)) {
      var mark = $this.ody_1.jdz();
      addToken($this, new BlockSequenceStartToken(mark, mark));
    }
  }
  $this.xdy_1 = true;
  removePossibleSimpleKey($this);
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var endMark = $this.ody_1.jdz();
  var token = new BlockEntryToken(startMark, endMark);
  addToken($this, token);
}
function fetchKey($this) {
  if (isBlockContext($this)) {
    if (!$this.xdy_1) {
      throw ScannerException.gdu('mapping keys are not allowed here', $this.ody_1.jdz());
    }
    if (addIndent($this, $this.ody_1.idz_1)) {
      var mark = $this.ody_1.jdz();
      addToken($this, new BlockMappingStartToken(mark, mark));
    }
  }
  $this.xdy_1 = isBlockContext($this);
  removePossibleSimpleKey($this);
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var endMark = $this.ody_1.jdz();
  var token = new KeyToken(startMark, endMark);
  addToken($this, token);
}
function fetchValue($this) {
  var key = $this.rdy_1.l3($this.tdy_1);
  if (!(key == null)) {
    addToken_0($this, key.kdz_1 - $this.vdy_1 | 0, new KeyToken(key.pdz_1, key.pdz_1));
    if (isBlockContext($this) && addIndent($this, key.odz_1)) {
      addToken_0($this, key.kdz_1 - $this.vdy_1 | 0, new BlockMappingStartToken(key.pdz_1, key.pdz_1));
    }
    $this.xdy_1 = false;
  } else {
    if (isBlockContext($this)) {
      if (!$this.xdy_1) {
        throw ScannerException.gdu('mapping values are not allowed here', $this.ody_1.jdz());
      }
    }
    if (isBlockContext($this) && addIndent($this, $this.ody_1.idz_1)) {
      var mark = $this.ody_1.jdz();
      addToken($this, new BlockMappingStartToken(mark, mark));
    }
    $this.xdy_1 = isBlockContext($this);
    removePossibleSimpleKey($this);
  }
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var endMark = $this.ody_1.jdz();
  var token = new ValueToken(startMark, endMark);
  addToken($this, token);
}
function fetchAlias($this) {
  savePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var tok = scanAnchor($this, false);
  addToken($this, tok);
}
function fetchAnchor($this) {
  savePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var tok = scanAnchor($this, true);
  addToken($this, tok);
}
function fetchTag($this) {
  savePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var token = scanTag($this);
  addToken($this, token);
}
function fetchLiteral($this) {
  return fetchBlockScalar($this, ScalarStyle_LITERAL_getInstance());
}
function fetchFolded($this) {
  return fetchBlockScalar($this, ScalarStyle_FOLDED_getInstance());
}
function fetchBlockScalar($this, style) {
  $this.xdy_1 = true;
  removePossibleSimpleKey($this);
  var tok = scanBlockScalar($this, style);
  addAllTokens($this, tok);
}
function fetchSingle($this) {
  return fetchFlowScalar($this, ScalarStyle_SINGLE_QUOTED_getInstance());
}
function fetchDouble($this) {
  return fetchFlowScalar($this, ScalarStyle_DOUBLE_QUOTED_getInstance());
}
function fetchFlowScalar($this, style) {
  savePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var tok = scanFlowScalar($this, ensureNotNull(style));
  addToken($this, tok);
}
function fetchPlain($this) {
  savePossibleSimpleKey($this);
  $this.xdy_1 = false;
  var tok = scanPlain($this);
  addToken($this, tok);
}
function checkDirective($this) {
  return $this.ody_1.idz_1 === 0;
}
function checkDocumentStart($this) {
  return checkDirective($this) && '---' === $this.ody_1.sdz(3) && Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(3));
}
function checkDocumentEnd($this) {
  return checkDirective($this) && '...' === $this.ody_1.sdz(3) && Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(3));
}
function checkBlockEntry($this) {
  return Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(1));
}
function checkKey($this) {
  return Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(1));
}
function checkValue($this) {
  return isFlowContext($this) || Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(1));
}
function checkPlain($this) {
  var c = $this.ody_1.adl();
  var notForbidden = Companion_getInstance_2().udl_1.idm(c, '-?:,[]{}#&*!|>\'"%@`');
  var tmp;
  if (notForbidden) {
    tmp = true;
  } else {
    var tmp_0;
    if (isBlockContext($this)) {
      tmp_0 = (Companion_getInstance_2().udl_1.gdm($this.ody_1.m2e(1)) && contains_0('-?:', numberToChar(c)));
    } else {
      tmp_0 = (Companion_getInstance_2().udl_1.idm($this.ody_1.m2e(1), ',]') && contains_0('-?', numberToChar(c)));
    }
    tmp = tmp_0;
  }
  return tmp;
}
function scanToNextToken($this) {
  var found = false;
  var inlineStartColumn = -1;
  while (!found) {
    var startMark = $this.ody_1.jdz();
    var columnBeforeComment = $this.ody_1.idz_1;
    var commentSeen = false;
    var ff = 0;
    $l$loop: while (true) {
      var tmp = $this.ody_1.m2e(ff);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(32);
      if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
        break $l$loop;
      }
      ff = ff + 1 | 0;
    }
    if (ff > 0) {
      $this.ody_1.qdz(ff);
    }
    var tmp_0 = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(35);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1)) {
      commentSeen = true;
      var type;
      var tmp_1;
      if (!(columnBeforeComment === 0)) {
        var tmp_2;
        if (!($this.udy_1 == null)) {
          var tmp69_safe_receiver = $this.udy_1;
          tmp_2 = equals(tmp69_safe_receiver == null ? null : tmp69_safe_receiver.gdw(), ID_BlockEntry_getInstance());
        } else {
          tmp_2 = false;
        }
        tmp_1 = !tmp_2;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        type = CommentType_IN_LINE_getInstance();
        inlineStartColumn = $this.ody_1.idz_1;
      } else {
        if (inlineStartColumn === $this.ody_1.idz_1) {
          type = CommentType_IN_LINE_getInstance();
        } else {
          inlineStartColumn = -1;
          type = CommentType_BLOCK_getInstance();
        }
      }
      var token = scanComment($this, type);
      if ($this.ndy_1.xdi_1) {
        addToken($this, token);
      }
    }
    var breaksOpt = scanLineBreak($this);
    if (!(breaksOpt == null)) {
      if ($this.ndy_1.xdi_1 && !commentSeen) {
        if (columnBeforeComment === 0) {
          addToken($this, new CommentToken(CommentType_BLANK_LINE_getInstance(), breaksOpt, startMark, $this.ody_1.jdz()));
        }
      }
      if (isBlockContext($this)) {
        $this.xdy_1 = true;
      }
    } else {
      found = true;
    }
  }
}
function scanComment($this, type) {
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var length = 0;
  while (Companion_getInstance_2().sdl_1.gdm($this.ody_1.m2e(length))) {
    length = length + 1 | 0;
  }
  var value = $this.ody_1.tdz(length);
  var endMark = $this.ody_1.jdz();
  return new CommentToken(type, value, startMark, endMark);
}
function scanDirective($this) {
  var startMark = $this.ody_1.jdz();
  var endMark;
  $this.ody_1.rdz();
  var name = scanDirectiveName($this, startMark);
  var value;
  switch (name) {
    case 'YAML':
      value = scanYamlDirectiveValue($this, startMark);
      endMark = $this.ody_1.jdz();
      break;
    case 'TAG':
      value = scanTagDirectiveValue($this, startMark);
      endMark = $this.ody_1.jdz();
      break;
    default:
      endMark = $this.ody_1.jdz();
      var ff = 0;
      while (Companion_getInstance_2().sdl_1.gdm($this.ody_1.m2e(ff))) {
        ff = ff + 1 | 0;
      }

      if (ff > 0) {
        $this.ody_1.qdz(ff);
      }

      value = null;
      break;
  }
  var commentToken = scanDirectiveIgnoredLine($this, startMark);
  var token = new DirectiveToken(value, startMark, endMark);
  return makeTokenList($this, [token, commentToken]);
}
function scanDirectiveName($this, startMark) {
  var length = 0;
  var c = $this.ody_1.m2e(length);
  while (Companion_getInstance_2().ydl_1.fdm(c)) {
    length = length + 1 | 0;
    c = $this.ody_1.m2e(length);
  }
  if (length === 0) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, 'expected alphabetic or numeric character, but found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  var value = $this.ody_1.tdz(length);
  c = $this.ody_1.adl();
  if (Companion_getInstance_2().tdl_1.gdm(c)) {
    var s_0 = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, 'expected alphabetic or numeric character, but found ' + s_0 + '(' + c + ')', $this.ody_1.jdz());
  }
  return value;
}
function scanYamlDirectiveValue($this, startMark) {
  $l$loop: while (true) {
    var tmp = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
      break $l$loop;
    }
    $this.ody_1.rdz();
  }
  var major = scanYamlDirectiveNumber($this, startMark);
  var c = $this.ody_1.adl();
  var tmp_0 = c;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(46);
  if (!(tmp_0 === Char__toInt_impl_vasixd(this_1))) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, "expected a digit or '.', but found " + s + '(' + c + ')', $this.ody_1.jdz());
  }
  $this.ody_1.rdz();
  var minor = scanYamlDirectiveNumber($this, startMark);
  c = $this.ody_1.adl();
  if (Companion_getInstance_2().tdl_1.gdm(c)) {
    var s_0 = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, "expected a digit or ' ', but found " + s_0 + '(' + c + ')', $this.ody_1.jdz());
  }
  return new YamlDirective(major, minor);
}
function scanYamlDirectiveNumber($this, startMark) {
  var c = $this.ody_1.adl();
  if (!isDigit(numberToChar(c))) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, 'expected a digit, but found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  var length = 0;
  while (isDigit(numberToChar($this.ody_1.m2e(length)))) {
    length = length + 1 | 0;
  }
  var number = $this.ody_1.tdz(length);
  if (length > 3) {
    throw ScannerException.gdu('while scanning a YAML directive', startMark, 'found a number which cannot represent a valid version: ' + number, $this.ody_1.jdz());
  }
  return toInt(number);
}
function scanTagDirectiveValue($this, startMark) {
  $l$loop: while (true) {
    var tmp = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
      break $l$loop;
    }
    $this.ody_1.rdz();
  }
  var handle = scanTagDirectiveHandle($this, startMark);
  $l$loop_0: while (true) {
    var tmp_0 = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(32);
    if (!(tmp_0 === Char__toInt_impl_vasixd(this_1))) {
      break $l$loop_0;
    }
    $this.ody_1.rdz();
  }
  var prefix = scanTagDirectivePrefix($this, startMark);
  return new TagDirective(handle, prefix);
}
function scanTagDirectiveHandle($this, startMark) {
  var value = scanTagHandle($this, 'directive', startMark);
  var c = $this.ody_1.adl();
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(32);
  if (!(c === Char__toInt_impl_vasixd(this_0))) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, "expected ' ', but found " + s + '(' + c + ')', $this.ody_1.jdz());
  }
  return value;
}
function scanTagDirectivePrefix($this, startMark) {
  var value = scanTagUri($this, 'directive', Companion_getInstance_2().wdl_1, startMark);
  var c = $this.ody_1.adl();
  if (Companion_getInstance_2().tdl_1.gdm(c)) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, "expected ' ', but found " + s + '(' + c + ')', $this.ody_1.jdz());
  }
  return value;
}
function scanDirectiveIgnoredLine($this, startMark) {
  $l$loop: while (true) {
    var tmp = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
      break $l$loop;
    }
    $this.ody_1.rdz();
  }
  var commentToken = null;
  var tmp_0 = $this.ody_1.adl();
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(35);
  if (tmp_0 === Char__toInt_impl_vasixd(this_1)) {
    var comment = scanComment($this, CommentType_IN_LINE_getInstance());
    if ($this.ndy_1.xdi_1) {
      commentToken = comment;
    }
  }
  var c = $this.ody_1.adl();
  if (scanLineBreak($this) == null && !(c === 0)) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a directive', startMark, 'expected a comment or a line break, but found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  return commentToken;
}
function scanAnchor($this, isAnchor) {
  var startMark = $this.ody_1.jdz();
  var indicator = $this.ody_1.adl();
  var tmp;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(42);
  if (indicator === Char__toInt_impl_vasixd(this_0)) {
    tmp = 'alias';
  } else {
    tmp = 'anchor';
  }
  var name = tmp;
  $this.ody_1.rdz();
  var length = 0;
  var c = $this.ody_1.m2e(length);
  while (Companion_getInstance_2().udl_1.idm(c, ',[]{}/.*&')) {
    length = length + 1 | 0;
    c = $this.ody_1.m2e(length);
  }
  if (length === 0) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning an ' + name, startMark, 'unexpected character found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  var value = $this.ody_1.tdz(length);
  c = $this.ody_1.adl();
  if (Companion_getInstance_2().udl_1.idm(c, '?:,]}%@`')) {
    var s_0 = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning an ' + name, startMark, 'unexpected character found ' + s_0 + '(' + c + ')', $this.ody_1.jdz());
  }
  var endMark = $this.ody_1.jdz();
  var tmp_0;
  if (isAnchor) {
    tmp_0 = new AnchorToken(new Anchor(value), startMark, endMark);
  } else {
    tmp_0 = new AliasToken(new Anchor(value), startMark, endMark);
  }
  return tmp_0;
}
function scanTag($this) {
  var startMark = $this.ody_1.jdz();
  var c = $this.ody_1.m2e(1);
  var handle;
  var suffix;
  var tmp = c;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(60);
  if (tmp === Char__toInt_impl_vasixd(this_0)) {
    $this.ody_1.qdz(2);
    suffix = scanTagUri($this, 'tag', Companion_getInstance_2().wdl_1, startMark);
    c = $this.ody_1.adl();
    var tmp_0 = c;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(62);
    if (!(tmp_0 === Char__toInt_impl_vasixd(this_1))) {
      var s = concatToString(Character_getInstance().ndq(c));
      throw ScannerException.gdu('while scanning a tag', startMark, "expected '>', but found '" + s + "' (" + c + ')', $this.ody_1.jdz());
    }
    handle = null;
    $this.ody_1.rdz();
  } else {
    if (Companion_getInstance_2().udl_1.fdm(c)) {
      suffix = '!';
      handle = null;
      $this.ody_1.rdz();
    } else {
      var length = 1;
      var useHandle = false;
      $l$loop: while (Companion_getInstance_2().tdl_1.gdm(c)) {
        var tmp_1 = c;
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(33);
        if (tmp_1 === Char__toInt_impl_vasixd(this_2)) {
          useHandle = true;
          break $l$loop;
        }
        length = length + 1 | 0;
        c = $this.ody_1.m2e(length);
      }
      if (useHandle) {
        handle = scanTagHandle($this, 'tag', startMark);
      } else {
        handle = '!';
        $this.ody_1.rdz();
      }
      suffix = scanTagUri($this, 'tag', Companion_getInstance_2().xdl_1, startMark);
    }
  }
  c = $this.ody_1.adl();
  if (Companion_getInstance_2().tdl_1.gdm(c)) {
    var s_0 = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a tag', startMark, "expected ' ', but found '" + s_0 + "' (" + c + ')', $this.ody_1.jdz());
  }
  var value = new TagTuple(handle, suffix);
  var endMark = $this.ody_1.jdz();
  return new TagToken(value, startMark, endMark);
}
function scanBlockScalar($this, style) {
  var stringBuilder = StringBuilder.f();
  var startMark = $this.ody_1.jdz();
  $this.ody_1.rdz();
  var chomping = scanBlockScalarIndicators($this, startMark);
  var commentToken = scanBlockScalarIgnoredLine($this, startMark);
  var minIndent = coerceAtLeast($this.wdy_1 + 1 | 0, 1);
  var breaks;
  var maxIndent;
  var blockIndent;
  var endMark;
  var chompingIncrement = chomping.udz();
  if (chompingIncrement == null) {
    var brme = scanBlockScalarIndentation($this);
    breaks = brme.vdz_1;
    maxIndent = brme.wdz_1;
    endMark = brme.xdz_1;
    blockIndent = coerceAtLeast(minIndent, maxIndent);
  } else {
    blockIndent = (minIndent + chompingIncrement | 0) - 1 | 0;
    var brme_0 = scanBlockScalarBreaks($this, blockIndent);
    breaks = brme_0.vdz_1;
    endMark = brme_0.xdz_1;
  }
  var lineBreak = null;
  if ($this.ody_1.idz_1 < blockIndent && !($this.wdy_1 === $this.ody_1.idz_1)) {
    throw ScannerException.gdu('while scanning a block scalar', startMark, ' the leading empty lines contain more spaces (' + blockIndent + ') than the first non-empty line.', $this.ody_1.jdz());
  }
  $l$loop: while ($this.ody_1.idz_1 === blockIndent && !($this.ody_1.adl() === 0)) {
    stringBuilder.gc(breaks);
    var leadingNonSpace = !contains_0(' \t', numberToChar($this.ody_1.adl()));
    var length = 0;
    while (Companion_getInstance_2().sdl_1.gdm($this.ody_1.m2e(length))) {
      length = length + 1 | 0;
    }
    stringBuilder.gc($this.ody_1.tdz(length));
    lineBreak = scanLineBreak($this);
    var brme_1 = scanBlockScalarBreaks($this, blockIndent);
    breaks = brme_1.vdz_1;
    endMark = brme_1.xdz_1;
    if ($this.ody_1.idz_1 === blockIndent && !($this.ody_1.adl() === 0)) {
      if (style.equals(ScalarStyle_FOLDED_getInstance()) && '\n' === lineBreak && leadingNonSpace && !contains_0(' \t', numberToChar($this.ody_1.adl()))) {
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = breaks;
        if (charSequenceLength(this_0) === 0) {
          stringBuilder.gc(' ');
        }
      } else {
        var tmp0_elvis_lhs = lineBreak;
        stringBuilder.gc(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
      }
    } else {
      break $l$loop;
    }
  }
  if (chomping.ydz()) {
    var tmp1_elvis_lhs = lineBreak;
    stringBuilder.gc(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
  }
  if (chomping.zdz()) {
    stringBuilder.gc(breaks);
  }
  var scalarToken = new ScalarToken(stringBuilder.toString(), false, startMark, endMark, style);
  return makeTokenList($this, [commentToken, scalarToken]);
}
function scanBlockScalarIndicators($this, startMark) {
  var indicator;
  var increment;
  var c = $this.ody_1.adl();
  var tmp;
  var tmp_0 = c;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(45);
  if (tmp_0 === Char__toInt_impl_vasixd(this_0)) {
    tmp = true;
  } else {
    var tmp_1 = c;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(43);
    tmp = tmp_1 === Char__toInt_impl_vasixd(this_1);
  }
  if (tmp) {
    indicator = c;
    $this.ody_1.rdz();
    c = $this.ody_1.adl();
    if (isDigit(numberToChar(c))) {
      var incr = toInt(concatToString(Character_getInstance().ndq(c)));
      if (incr === 0) {
        throw ScannerException.gdu('while scanning a block scalar', startMark, 'expected indentation indicator in the range 1-9, but found 0', $this.ody_1.jdz());
      }
      increment = incr;
      $this.ody_1.rdz();
    } else {
      increment = null;
    }
  } else {
    if (isDigit(numberToChar(c))) {
      var incr_0 = toInt(concatToString(Character_getInstance().ndq(c)));
      if (incr_0 === 0) {
        throw ScannerException.gdu('while scanning a block scalar', startMark, 'expected indentation indicator in the range 1-9, but found 0', $this.ody_1.jdz());
      }
      increment = incr_0;
      $this.ody_1.rdz();
      c = $this.ody_1.adl();
      var tmp_2;
      var tmp_3 = c;
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(45);
      if (tmp_3 === Char__toInt_impl_vasixd(this_2)) {
        tmp_2 = true;
      } else {
        var tmp_4 = c;
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(43);
        tmp_2 = tmp_4 === Char__toInt_impl_vasixd(this_3);
      }
      if (tmp_2) {
        indicator = c;
        $this.ody_1.rdz();
      } else {
        indicator = null;
      }
    } else {
      increment = null;
      indicator = null;
    }
  }
  c = $this.ody_1.adl();
  if (Companion_getInstance_2().tdl_1.gdm(c)) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a block scalar', startMark, 'expected chomping or indentation indicators, but found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  var tmp0_elvis_lhs = Chomping(indicator, increment);
  var tmp_5;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('Unexpected block chomping indicator: ' + indicator);
  } else {
    tmp_5 = tmp0_elvis_lhs;
  }
  return tmp_5;
}
function scanBlockScalarIgnoredLine($this, startMark) {
  $l$loop: while (true) {
    var tmp = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
      break $l$loop;
    }
    $this.ody_1.rdz();
  }
  var tmp_0;
  var tmp_1 = $this.ody_1.adl();
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(35);
  if (tmp_1 === Char__toInt_impl_vasixd(this_1)) {
    tmp_0 = scanComment($this, CommentType_IN_LINE_getInstance());
  } else {
    tmp_0 = null;
  }
  var commentToken = tmp_0;
  var c = $this.ody_1.adl();
  if (scanLineBreak($this) == null && !(c === 0)) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a block scalar', startMark, 'expected a comment or a line break, but found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  return commentToken;
}
function scanBlockScalarIndentation($this) {
  var chunks = StringBuilder.f();
  var maxIndent = 0;
  var endMark = $this.ody_1.jdz();
  while (Companion_getInstance_2().rdl_1.hdm($this.ody_1.adl(), ' \r')) {
    var tmp = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
      var tmp0_elvis_lhs = scanLineBreak($this);
      chunks.gc(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
      endMark = $this.ody_1.jdz();
    } else {
      $this.ody_1.rdz();
      if ($this.ody_1.idz_1 > maxIndent) {
        maxIndent = $this.ody_1.idz_1;
      }
    }
  }
  return new BreakIntentHolder(chunks.toString(), maxIndent, endMark);
}
function scanBlockScalarBreaks($this, indent) {
  var chunks = StringBuilder.f();
  var endMark = $this.ody_1.jdz();
  var col = $this.ody_1.idz_1;
  $l$loop: while (true) {
    var tmp;
    if (col < indent) {
      var tmp_0 = $this.ody_1.adl();
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(32);
      tmp = tmp_0 === Char__toInt_impl_vasixd(this_0);
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    $this.ody_1.rdz();
    col = col + 1 | 0;
  }
  $l$loop_0: while (true) {
    var tmp0_elvis_lhs = scanLineBreak($this);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break $l$loop_0;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var lineBreak = tmp_1;
    chunks.gc(lineBreak);
    endMark = $this.ody_1.jdz();
    col = $this.ody_1.idz_1;
    $l$loop_1: while (true) {
      var tmp_2;
      if (col < indent) {
        var tmp_3 = $this.ody_1.adl();
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(32);
        tmp_2 = tmp_3 === Char__toInt_impl_vasixd(this_1);
      } else {
        tmp_2 = false;
      }
      if (!tmp_2) {
        break $l$loop_1;
      }
      $this.ody_1.rdz();
      col = col + 1 | 0;
    }
  }
  return new BreakIntentHolder(chunks.toString(), -1, endMark);
}
function scanFlowScalar($this, style) {
  var doubleValue = style.equals(ScalarStyle_DOUBLE_QUOTED_getInstance());
  var startMark = $this.ody_1.jdz();
  var quote = $this.ody_1.adl();
  $this.ody_1.rdz();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'it.krzeminski.snakeyaml.engine.kmp.scanner.ScannerImpl.scanFlowScalar.<anonymous>' call
  this_0.gc(scanFlowScalarNonSpaces($this, doubleValue, startMark));
  while (!($this.ody_1.adl() === quote)) {
    this_0.gc(scanFlowScalarSpaces($this, startMark));
    this_0.gc(scanFlowScalarNonSpaces($this, doubleValue, startMark));
  }
  var chunks = this_0.toString();
  $this.ody_1.rdz();
  var endMark = $this.ody_1.jdz();
  return new ScalarToken(chunks, false, startMark, endMark, style);
}
function scanFlowScalarNonSpaces($this, doubleQuoted, startMark) {
  var chunks = StringBuilder.f();
  while (true) {
    var length = 0;
    while (Companion_getInstance_2().udl_1.idm($this.ody_1.m2e(length), '\'"\\')) {
      length = length + 1 | 0;
    }
    if (!(length === 0)) {
      chunks.gc($this.ody_1.tdz(length));
    }
    var c = $this.ody_1.adl();
    var tmp;
    var tmp_0;
    if (!doubleQuoted) {
      var tmp_1 = c;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(39);
      tmp_0 = tmp_1 === Char__toInt_impl_vasixd(this_0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_2 = $this.ody_1.m2e(1);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(39);
      tmp = tmp_2 === Char__toInt_impl_vasixd(this_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      chunks.gc("'");
      $this.ody_1.qdz(2);
    } else {
      var tmp_3;
      var tmp_4;
      if (doubleQuoted) {
        var tmp_5 = c;
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(39);
        tmp_4 = tmp_5 === Char__toInt_impl_vasixd(this_2);
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp_3 = true;
      } else {
        tmp_3 = (!doubleQuoted && contains_0('"\\', numberToChar(c)));
      }
      if (tmp_3) {
        appendCodePoint(chunks, c);
        $this.ody_1.rdz();
      } else {
        var tmp_6;
        if (doubleQuoted) {
          var tmp_7 = c;
          // Inline function 'kotlin.code' call
          var this_3 = _Char___init__impl__6a9atx(92);
          tmp_6 = tmp_7 === Char__toInt_impl_vasixd(this_3);
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          $this.ody_1.rdz();
          c = $this.ody_1.adl();
          var tmp_8;
          if (!Character_getInstance().ldu(c)) {
            // Inline function 'kotlin.collections.contains' call
            var this_4 = Companion_getInstance_2().adm_1;
            // Inline function 'kotlin.collections.containsKey' call
            var key = new Char(numberToChar(c));
            tmp_8 = (isInterface(this_4, KtMap) ? this_4 : THROW_CCE()).c3(key);
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            chunks.gc(Companion_getInstance_2().adm_1.e3(new Char(numberToChar(c))));
            $this.ody_1.rdz();
          } else {
            var tmp_9;
            if (!Character_getInstance().ldu(c)) {
              // Inline function 'kotlin.collections.contains' call
              var this_5 = Companion_getInstance_2().cdm_1;
              // Inline function 'kotlin.collections.containsKey' call
              var key_0 = new Char(numberToChar(c));
              tmp_9 = (isInterface(this_5, KtMap) ? this_5 : THROW_CCE()).c3(key_0);
            } else {
              tmp_9 = false;
            }
            if (tmp_9) {
              length = ensureNotNull(Companion_getInstance_2().cdm_1.e3(new Char(numberToChar(c))));
              $this.ody_1.rdz();
              var hex = $this.ody_1.sdz(length);
              if (Companion_getInstance_11().ee0_1.ri(hex)) {
                throw ScannerException.gdu('while scanning a double-quoted scalar', startMark, 'expected escape sequence of ' + length + ' hexadecimal numbers, but found: ' + hex, $this.ody_1.jdz());
              }
              try {
                var decimal = toInt_0(hex, 16);
                var unicode = Character_getInstance().ndq(decimal);
                chunks.vh(unicode);
                $this.ody_1.qdz(length);
              } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                  var e = $p;
                  throw ScannerException.gdu('while scanning a double-quoted scalar', startMark, 'found unknown escape character ' + hex, $this.ody_1.jdz());
                } else {
                  throw $p;
                }
              }
            } else {
              if (!(scanLineBreak($this) == null)) {
                chunks.gc(scanFlowScalarBreaks($this, startMark));
              } else {
                var s = concatToString(Character_getInstance().ndq(c));
                throw ScannerException.gdu('while scanning a double-quoted scalar', startMark, 'found unknown escape character ' + s + '(' + c + ')', $this.ody_1.jdz());
              }
            }
          }
        } else {
          return chunks.toString();
        }
      }
    }
  }
}
function scanFlowScalarSpaces($this, startMark) {
  var length = 0;
  while (contains_0(' \t', numberToChar($this.ody_1.m2e(length)))) {
    length = length + 1 | 0;
  }
  var whitespaces = $this.ody_1.tdz(length);
  if ($this.ody_1.adl() === 0) {
    throw ScannerException.gdu('found unexpected end of stream', $this.ody_1.jdz(), 'while scanning a quoted scalar', startMark);
  }
  var lineBreakOpt = scanLineBreak($this);
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'it.krzeminski.snakeyaml.engine.kmp.scanner.ScannerImpl.scanFlowScalarSpaces.<anonymous>' call
  if (!(lineBreakOpt == null)) {
    var breaks = scanFlowScalarBreaks($this, startMark);
    if (!('\n' === lineBreakOpt)) {
      this_0.gc(lineBreakOpt);
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(breaks) === 0) {
        this_0.gc(' ');
      }
    }
    this_0.gc(breaks);
  } else {
    this_0.gc(whitespaces);
  }
  return this_0.toString();
}
function scanFlowScalarBreaks($this, startMark) {
  var chunks = StringBuilder.f();
  $l$loop: while (true) {
    var prefix = $this.ody_1.sdz(3);
    if (('---' === prefix || '...' === prefix) && Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(3))) {
      throw ScannerException.gdu('while scanning a quoted scalar', startMark, 'found unexpected document separator', $this.ody_1.jdz());
    }
    while (contains_0(' \t', numberToChar($this.ody_1.adl()))) {
      $this.ody_1.rdz();
    }
    var tmp0_elvis_lhs = scanLineBreak($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lineBreakOpt = tmp;
    chunks.gc(lineBreakOpt);
  }
  return chunks.toString();
}
function scanPlain($this) {
  var chunks = StringBuilder.f();
  var startMark = $this.ody_1.jdz();
  var endMark = startMark;
  var plainIndent = $this.wdy_1 + 1 | 0;
  var spaces = '';
  $l$loop_2: while (true) {
    var c;
    var length = 0;
    var tmp = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(35);
    if (tmp === Char__toInt_impl_vasixd(this_0)) {
      break $l$loop_2;
    }
    $l$loop_0: while (true) {
      c = $this.ody_1.m2e(length);
      var tmp_0;
      var tmp_1;
      if (Companion_getInstance_2().udl_1.fdm(c)) {
        tmp_1 = true;
      } else {
        var tmp_2;
        var tmp_3 = c;
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(58);
        if (tmp_3 === Char__toInt_impl_vasixd(this_1)) {
          tmp_2 = Companion_getInstance_2().udl_1.hdm($this.ody_1.m2e(length + 1 | 0), isFlowContext($this) ? ',[]{}' : '');
        } else {
          tmp_2 = false;
        }
        tmp_1 = tmp_2;
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = (isFlowContext($this) && contains_0(',[]{}', numberToChar(c)));
      }
      if (tmp_0) {
        break $l$loop_0;
      }
      length = length + 1 | 0;
    }
    if (length === 0) {
      break $l$loop_2;
    }
    $this.xdy_1 = false;
    chunks.gc(spaces);
    chunks.gc($this.ody_1.tdz(length));
    endMark = $this.ody_1.jdz();
    spaces = scanPlainSpaces($this);
    var tmp_4;
    var tmp_5;
    // Inline function 'kotlin.text.isEmpty' call
    var this_2 = spaces;
    if (charSequenceLength(this_2) === 0) {
      tmp_5 = true;
    } else {
      var tmp_6 = $this.ody_1.adl();
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(35);
      tmp_5 = tmp_6 === Char__toInt_impl_vasixd(this_3);
    }
    if (tmp_5) {
      tmp_4 = true;
    } else {
      tmp_4 = (isBlockContext($this) && $this.ody_1.idz_1 < plainIndent);
    }
    if (tmp_4) {
      break $l$loop_2;
    }
  }
  return new ScalarToken(chunks.toString(), true, startMark, endMark);
}
function atEndOfPlain($this) {
  var wsLength = 0;
  var wsColumn = $this.ody_1.idz_1;
  $l$loop: while (true) {
    var c = $this.ody_1.m2e(wsLength);
    if (c === 0 || !Companion_getInstance_2().udl_1.fdm(c)) {
      break $l$loop;
    } else {
      wsLength = wsLength + 1 | 0;
      var tmp;
      var tmp_0;
      if (!Companion_getInstance_2().rdl_1.fdm(c)) {
        var tmp_1;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(13);
        if (!(c === Char__toInt_impl_vasixd(this_0))) {
          tmp_1 = true;
        } else {
          var tmp_2 = $this.ody_1.m2e(wsLength + 1 | 0);
          // Inline function 'kotlin.code' call
          var this_1 = _Char___init__impl__6a9atx(10);
          tmp_1 = !(tmp_2 === Char__toInt_impl_vasixd(this_1));
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = !(c === 65279);
      } else {
        tmp = false;
      }
      if (tmp) {
        wsColumn = wsColumn + 1 | 0;
      } else {
        wsColumn = 0;
      }
    }
  }
  var tmp_3;
  var tmp_4;
  var tmp_5 = $this.ody_1.m2e(wsLength);
  // Inline function 'kotlin.code' call
  var this_2 = _Char___init__impl__6a9atx(35);
  if (tmp_5 === Char__toInt_impl_vasixd(this_2)) {
    tmp_4 = true;
  } else {
    tmp_4 = $this.ody_1.m2e(wsLength + 1 | 0) === 0;
  }
  if (tmp_4) {
    tmp_3 = true;
  } else {
    tmp_3 = (isBlockContext($this) && wsColumn < $this.wdy_1);
  }
  if (tmp_3) {
    return true;
  }
  if (isBlockContext($this)) {
    var extra = 1;
    $l$loop_0: while (true) {
      var c_0 = $this.ody_1.m2e(wsLength + extra | 0);
      if (c_0 === 0 || Companion_getInstance_2().udl_1.fdm(c_0)) {
        break $l$loop_0;
      } else {
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(58);
        if (c_0 === Char__toInt_impl_vasixd(this_3)) {
          var nextC = $this.ody_1.m2e((wsLength + extra | 0) + 1 | 0);
          if (Companion_getInstance_2().udl_1.fdm(nextC)) {
            return true;
          }
        }
      }
      extra = extra + 1 | 0;
    }
  }
  return false;
}
function scanPlainSpaces($this) {
  var length = 0;
  while (contains_0(' \t', numberToChar($this.ody_1.m2e(length)))) {
    length = length + 1 | 0;
  }
  var whitespaces = $this.ody_1.tdz(length);
  var tmp0_elvis_lhs = scanLineBreak($this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return whitespaces;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var lineBreak = tmp;
  $this.xdy_1 = true;
  var prefix = $this.ody_1.sdz(3);
  if ('---' === prefix || ('...' === prefix && Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(3)))) {
    return '';
  } else if ($this.ndy_1.xdi_1 && atEndOfPlain($this)) {
    return '';
  } else {
    var breaks = StringBuilder.f();
    $l$loop: while (true) {
      if (contains_0(' \t', numberToChar($this.ody_1.adl()))) {
        $this.ody_1.rdz();
      } else {
        var lbOpt = scanLineBreak($this);
        if (!(lbOpt == null)) {
          breaks.gc(lbOpt);
          prefix = $this.ody_1.sdz(3);
          if ('---' === prefix || ('...' === prefix && Companion_getInstance_2().udl_1.fdm($this.ody_1.m2e(3)))) {
            return '';
          }
        } else {
          break $l$loop;
        }
      }
    }
    var tmp_0;
    if (!('\n' === lineBreak)) {
      tmp_0 = lineBreak + breaks.toString();
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(breaks) === 0) {
        tmp_0 = ' ';
      } else {
        tmp_0 = breaks.toString();
      }
    }
    return tmp_0;
  }
}
function scanTagHandle($this, name, startMark) {
  var c = $this.ody_1.adl();
  var tmp = c;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(33);
  if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a ' + name, startMark, "expected '!', but found " + s + '(' + c + ')', $this.ody_1.jdz());
  }
  var length = 1;
  c = $this.ody_1.m2e(length);
  var tmp_0 = c;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(32);
  if (!(tmp_0 === Char__toInt_impl_vasixd(this_1))) {
    while (Companion_getInstance_2().ydl_1.fdm(c)) {
      length = length + 1 | 0;
      c = $this.ody_1.m2e(length);
    }
    var tmp_1 = c;
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(33);
    if (!(tmp_1 === Char__toInt_impl_vasixd(this_2))) {
      $this.ody_1.qdz(length);
      var s_0 = concatToString(Character_getInstance().ndq(c));
      throw ScannerException.gdu('while scanning a ' + name, startMark, "expected '!', but found " + s_0 + '(' + c + ')', $this.ody_1.jdz());
    }
    length = length + 1 | 0;
  }
  return $this.ody_1.tdz(length);
}
function scanTagUri($this, name, range, startMark) {
  var chunks = StringBuilder.f();
  var length = 0;
  var c = $this.ody_1.m2e(length);
  while (range.fdm(c)) {
    var tmp = c;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(37);
    if (tmp === Char__toInt_impl_vasixd(this_0)) {
      chunks.gc($this.ody_1.tdz(length));
      length = 0;
      chunks.gc(scanUriEscapes($this, name, startMark));
    } else {
      length = length + 1 | 0;
    }
    c = $this.ody_1.m2e(length);
  }
  if (!(length === 0)) {
    chunks.gc($this.ody_1.tdz(length));
  }
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(chunks) === 0) {
    var s = concatToString(Character_getInstance().ndq(c));
    throw ScannerException.gdu('while scanning a ' + name, startMark, 'expected URI, but found ' + s + '(' + c + ')', $this.ody_1.jdz());
  }
  return chunks.toString();
}
function scanUriEscapes($this, name, startMark) {
  var length = 1;
  $l$loop: while (true) {
    var tmp = $this.ody_1.m2e(imul(length, 3));
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(37);
    if (!(tmp === Char__toInt_impl_vasixd(this_0))) {
      break $l$loop;
    }
    length = length + 1 | 0;
  }
  var beginningMark = $this.ody_1.jdz();
  var buff = new Buffer();
  $l$loop_0: while (true) {
    var tmp_0 = $this.ody_1.adl();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(37);
    if (!(tmp_0 === Char__toInt_impl_vasixd(this_1))) {
      break $l$loop_0;
    }
    $this.ody_1.rdz();
    try {
      var code = toInt_0($this.ody_1.sdz(2), 16);
      buff.yde(code);
    } catch ($p) {
      if ($p instanceof NumberFormatException) {
        var nfe = $p;
        var c1 = $this.ody_1.adl();
        var s1 = concatToString(Character_getInstance().ndq(c1));
        var c2 = $this.ody_1.m2e(1);
        var s2 = concatToString(Character_getInstance().ndq(c2));
        throw ScannerException.gdu('while scanning a ' + name, startMark, 'expected URI escape sequence of 2 hexadecimal numbers, but found ' + s1 + '(' + c1 + ') and ' + s2 + '(' + c2 + ')', $this.ody_1.jdz());
      } else {
        throw $p;
      }
    }
    $this.ody_1.qdz(2);
  }
  buff.gd();
  try {
    return UriEncoder_instance.odm(buff);
  } catch ($p) {
    if ($p instanceof CharacterCodingException) {
      var e = $p;
      throw ScannerException.gdu('while scanning a ' + name, startMark, 'expected URI in UTF-8: ' + e.message, beginningMark);
    } else {
      throw $p;
    }
  }
}
function scanLineBreak($this) {
  var c = $this.ody_1.adl();
  var tmp;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(13);
  if (c === Char__toInt_impl_vasixd(this_0)) {
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(10);
    tmp_0 = c === Char__toInt_impl_vasixd(this_1);
  }
  if (tmp_0) {
    tmp = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(133);
    tmp = c === Char__toInt_impl_vasixd(this_2);
  }
  if (tmp) {
    var tmp_1;
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(13);
    if (c === Char__toInt_impl_vasixd(this_3)) {
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(10);
      tmp_1 = Char__toInt_impl_vasixd(this_4) === $this.ody_1.m2e(1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      $this.ody_1.qdz(2);
    } else {
      $this.ody_1.rdz();
    }
    return '\n';
  }
  return null;
}
function makeTokenList($this, tokens) {
  var notNullTokens = filterNotNull(tokens);
  var tmp;
  if (!$this.ndy_1.xdi_1) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.z();
    var tmp0_iterator = notNullTokens.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'it.krzeminski.snakeyaml.engine.kmp.scanner.ScannerImpl.makeTokenList.<anonymous>' call
      if (!(element instanceof CommentToken)) {
        destination.h(element);
      }
    }
    tmp = destination;
  } else {
    tmp = notNullTokens;
  }
  return tmp;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function _Clip___init__impl__llmhrl(increment) {
  return increment;
}
function _Clip___get_increment__impl__6zmssn($this) {
  return $this;
}
function _Clip___get_addExistingFinalLineBreak__impl__v4gbjp($this) {
  return true;
}
function _Clip___get_retainTrailingEmptyLines__impl__5r5ek5($this) {
  return false;
}
function Clip__toString_impl_8zbb0x($this) {
  return 'Clip(increment=' + $this + ')';
}
function Clip__hashCode_impl_crulry($this) {
  return $this == null ? 0 : $this;
}
function Clip__equals_impl_7672fy($this, other) {
  if (!(other instanceof Clip))
    return false;
  if (!($this == (other instanceof Clip ? other.fe0_1 : THROW_CCE())))
    return false;
  return true;
}
function _Strip___init__impl__1l0fz5(increment) {
  return increment;
}
function _Strip___get_increment__impl__ultjnb($this) {
  return $this;
}
function _Strip___get_addExistingFinalLineBreak__impl__hh5hph($this) {
  return false;
}
function _Strip___get_retainTrailingEmptyLines__impl__5bav0l($this) {
  return false;
}
function Strip__toString_impl_e44ikp($this) {
  return 'Strip(increment=' + $this + ')';
}
function Strip__hashCode_impl_7n1e86($this) {
  return $this == null ? 0 : $this;
}
function Strip__equals_impl_vbxlyi($this, other) {
  if (!(other instanceof Strip))
    return false;
  if (!($this == (other instanceof Strip ? other.ge0_1 : THROW_CCE())))
    return false;
  return true;
}
function _Keep___init__impl__7pj66c(increment) {
  return increment;
}
function _Keep___get_increment__impl__g32ff2($this) {
  return $this;
}
function _Keep___get_addExistingFinalLineBreak__impl__eevoo0($this) {
  return true;
}
function _Keep___get_retainTrailingEmptyLines__impl__7i8cq2($this) {
  return true;
}
function Keep__toString_impl_5t9sg4($this) {
  return 'Keep(increment=' + $this + ')';
}
function Keep__hashCode_impl_rkfp8z($this) {
  return $this == null ? 0 : $this;
}
function Keep__equals_impl_3j9b7t($this, other) {
  if (!(other instanceof Keep))
    return false;
  if (!($this == (other instanceof Keep ? other.he0_1 : THROW_CCE())))
    return false;
  return true;
}
function Chomping(indicatorCodePoint, increment) {
  var tmp;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(43);
  if (indicatorCodePoint === Char__toInt_impl_vasixd(this_0)) {
    tmp = new Keep(_Keep___init__impl__7pj66c(increment));
  } else {
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(45);
    if (indicatorCodePoint === Char__toInt_impl_vasixd(this_1)) {
      tmp = new Strip(_Strip___init__impl__1l0fz5(increment));
    } else {
      if (indicatorCodePoint == null) {
        tmp = new Clip(_Clip___init__impl__llmhrl(increment));
      } else {
        tmp = null;
      }
    }
  }
  return tmp;
}
function copyOfRangeSafe(_this__u8e3s4, $this, fromIndex, toIndex) {
  var tmp = 0;
  var tmp_0 = toIndex - fromIndex | 0;
  var tmp_1 = new Int32Array(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    var tmp0_elvis_lhs = getOrNull_0(_this__u8e3s4, fromIndex + tmp_2 | 0);
    tmp_1[tmp_2] = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function ensureEnoughData($this, size) {
  if (!$this.edz_1 && ($this.ddz_1 + size | 0) >= $this.cdz_1) {
    update($this);
  }
  return ($this.ddz_1 + size | 0) < $this.cdz_1;
}
function ensureEnoughData$default($this, size, $super) {
  size = size === VOID ? 0 : size;
  return ensureEnoughData($this, size);
}
function update($this) {
  try {
    var buffer = $this.ydy_1.lde();
    var read = buffer.length;
    if (read > 0) {
      var cpIndex = $this.cdz_1 - $this.ddz_1 | 0;
      $this.bdz_1 = copyOfRangeSafe($this.bdz_1, Companion_instance_12, $this.ddz_1, $this.cdz_1 + read | 0);
      var nonPrintable = null;
      var i = 0;
      while (i < read) {
        var codePoint = codePointAt(buffer, i);
        $this.bdz_1[cpIndex] = codePoint;
        if (Companion_instance_12.odq(codePoint)) {
          i = i + Character_getInstance().ldq(codePoint) | 0;
        } else {
          nonPrintable = codePoint;
          i = read;
        }
        cpIndex = cpIndex + 1 | 0;
      }
      $this.cdz_1 = cpIndex;
      $this.ddz_1 = 0;
      if (!(nonPrintable == null)) {
        throw ReaderException.wdt($this.zdy_1, cpIndex - 1 | 0, nonPrintable, 'special characters are not allowed');
      }
    } else {
      $this.edz_1 = true;
    }
  } catch ($p) {
    if ($p instanceof IOException) {
      var ioe = $p;
      throw YamlEngineException.hdu(ioe);
    } else {
      throw $p;
    }
  }
}
function moveIndices($this, length) {
  $this.fdz_1 = $this.fdz_1 + length | 0;
  $this.gdz_1 = $this.gdz_1 + length | 0;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
function StreamReader$prefix$lambda(it) {
  return concatToString(Character_getInstance().ndq(it));
}
function defaultSchemaTagConstructors(scalarResolver) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap.wc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'it.krzeminski.snakeyaml.engine.kmp.schema.defaultSchemaTagConstructors.<anonymous>' call
  this_0.k3(Companion_getInstance_7().tdu_1, new ConstructYamlNull());
  this_0.k3(Companion_getInstance_7().sdu_1, new ConstructYamlJsonBool());
  this_0.k3(Companion_getInstance_7().qdu_1, new ConstructYamlJsonInt());
  this_0.k3(Companion_getInstance_7().rdu_1, new ConstructYamlJsonFloat());
  this_0.k3(Companion_getInstance_7().pdu_1, new ConstructYamlBinary());
  this_0.m3(targetSchemaTagConstructors(scalarResolver));
  return this_0.m8();
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var ID_Alias_instance_0;
var ID_Anchor_instance;
var ID_BlockEnd_instance;
var ID_BlockEntry_instance;
var ID_BlockMappingStart_instance;
var ID_BlockSequenceStart_instance;
var ID_Directive_instance;
var ID_DocumentEnd_instance_0;
var ID_DocumentStart_instance_0;
var ID_FlowEntry_instance;
var ID_FlowMappingEnd_instance;
var ID_FlowMappingStart_instance;
var ID_FlowSequenceEnd_instance;
var ID_FlowSequenceStart_instance;
var ID_Key_instance;
var ID_Scalar_instance_0;
var ID_StreamEnd_instance_0;
var ID_StreamStart_instance_0;
var ID_Tag_instance;
var ID_Comment_instance_0;
var ID_Value_instance;
var ID_entriesInitialized_0;
function ID_initEntries_0() {
  if (ID_entriesInitialized_0)
    return Unit_instance;
  ID_entriesInitialized_0 = true;
  ID_Alias_instance_0 = new ID_0('Alias', 0, '<alias>');
  ID_Anchor_instance = new ID_0('Anchor', 1, '<anchor>');
  ID_BlockEnd_instance = new ID_0('BlockEnd', 2, '<block end>');
  ID_BlockEntry_instance = new ID_0('BlockEntry', 3, '-');
  ID_BlockMappingStart_instance = new ID_0('BlockMappingStart', 4, '<block mapping start>');
  ID_BlockSequenceStart_instance = new ID_0('BlockSequenceStart', 5, '<block sequence start>');
  ID_Directive_instance = new ID_0('Directive', 6, '<directive>');
  ID_DocumentEnd_instance_0 = new ID_0('DocumentEnd', 7, '<document end>');
  ID_DocumentStart_instance_0 = new ID_0('DocumentStart', 8, '<document start>');
  ID_FlowEntry_instance = new ID_0('FlowEntry', 9, ',');
  ID_FlowMappingEnd_instance = new ID_0('FlowMappingEnd', 10, '}');
  ID_FlowMappingStart_instance = new ID_0('FlowMappingStart', 11, '{');
  ID_FlowSequenceEnd_instance = new ID_0('FlowSequenceEnd', 12, ']');
  ID_FlowSequenceStart_instance = new ID_0('FlowSequenceStart', 13, '[');
  ID_Key_instance = new ID_0('Key', 14, '?');
  ID_Scalar_instance_0 = new ID_0('Scalar', 15, '<scalar>');
  ID_StreamEnd_instance_0 = new ID_0('StreamEnd', 16, '<stream end>');
  ID_StreamStart_instance_0 = new ID_0('StreamStart', 17, '<stream start>');
  ID_Tag_instance = new ID_0('Tag', 18, '<tag>');
  ID_Comment_instance_0 = new ID_0('Comment', 19, '#');
  ID_Value_instance = new ID_0('Value', 20, ':');
}
function ID_Alias_getInstance_0() {
  ID_initEntries_0();
  return ID_Alias_instance_0;
}
function ID_Anchor_getInstance() {
  ID_initEntries_0();
  return ID_Anchor_instance;
}
function ID_BlockEnd_getInstance() {
  ID_initEntries_0();
  return ID_BlockEnd_instance;
}
function ID_BlockEntry_getInstance() {
  ID_initEntries_0();
  return ID_BlockEntry_instance;
}
function ID_BlockMappingStart_getInstance() {
  ID_initEntries_0();
  return ID_BlockMappingStart_instance;
}
function ID_BlockSequenceStart_getInstance() {
  ID_initEntries_0();
  return ID_BlockSequenceStart_instance;
}
function ID_Directive_getInstance() {
  ID_initEntries_0();
  return ID_Directive_instance;
}
function ID_DocumentEnd_getInstance_0() {
  ID_initEntries_0();
  return ID_DocumentEnd_instance_0;
}
function ID_DocumentStart_getInstance_0() {
  ID_initEntries_0();
  return ID_DocumentStart_instance_0;
}
function ID_FlowEntry_getInstance() {
  ID_initEntries_0();
  return ID_FlowEntry_instance;
}
function ID_FlowMappingEnd_getInstance() {
  ID_initEntries_0();
  return ID_FlowMappingEnd_instance;
}
function ID_FlowMappingStart_getInstance() {
  ID_initEntries_0();
  return ID_FlowMappingStart_instance;
}
function ID_FlowSequenceEnd_getInstance() {
  ID_initEntries_0();
  return ID_FlowSequenceEnd_instance;
}
function ID_FlowSequenceStart_getInstance() {
  ID_initEntries_0();
  return ID_FlowSequenceStart_instance;
}
function ID_Key_getInstance() {
  ID_initEntries_0();
  return ID_Key_instance;
}
function ID_Scalar_getInstance_0() {
  ID_initEntries_0();
  return ID_Scalar_instance_0;
}
function ID_StreamEnd_getInstance_0() {
  ID_initEntries_0();
  return ID_StreamEnd_instance_0;
}
function ID_StreamStart_getInstance_0() {
  ID_initEntries_0();
  return ID_StreamStart_instance_0;
}
function ID_Tag_getInstance() {
  ID_initEntries_0();
  return ID_Tag_instance;
}
function ID_Comment_getInstance_0() {
  ID_initEntries_0();
  return ID_Comment_instance_0;
}
function ID_Value_getInstance() {
  ID_initEntries_0();
  return ID_Value_instance;
}
function targetSchemaTagConstructors(scalarResolver) {
  return emptyMap();
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(DumpSettings, 'DumpSettings');
initMetadataForClass(DumpSettingsBuilder, 'DumpSettingsBuilder');
initMetadataForInterface(CollectionProvider, 'CollectionProvider');
initMetadataForInterface(SpecVersionMutator, 'SpecVersionMutator');
initMetadataForCompanion(Companion_0);
initMetadataForClass(LoadSettings, 'LoadSettings');
initMetadataForClass(sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0, 'sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0', VOID, VOID, [CollectionProvider, FunctionAdapter]);
initMetadataForClass(sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0_0, 'sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0', VOID, VOID, [CollectionProvider, FunctionAdapter]);
initMetadataForClass(sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0_1, 'sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_CollectionProvider$0', VOID, VOID, [CollectionProvider, FunctionAdapter]);
initMetadataForClass(sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_SpecVersionMutator$0, 'sam$it_krzeminski_snakeyaml_engine_kmp_api_LoadSettings_SpecVersionMutator$0', VOID, VOID, [SpecVersionMutator, FunctionAdapter]);
initMetadataForClass(LoadSettingsBuilder, 'LoadSettingsBuilder');
initMetadataForInterface(StreamDataWriter, 'StreamDataWriter');
initMetadataForClass(CommentEventsCollector, 'CommentEventsCollector');
initMetadataForClass(EventQueue, 'EventQueue');
initMetadataForClass(CommentLine, 'CommentLine');
initMetadataForClass(CommentType, 'CommentType');
initMetadataForCompanion(Companion_1);
initMetadataForClass(Anchor, 'Anchor');
initMetadataForCompanion(Companion_2);
initMetadataForClass(CharConstants, 'CharConstants');
initMetadataForClass(FlowStyle, 'FlowStyle');
initMetadataForClass(NonPrintableStyle, 'NonPrintableStyle');
initMetadataForClass(ScalarStyle, 'ScalarStyle');
initMetadataForClass(SpecVersion, 'SpecVersion');
initMetadataForObject(UriEncoder, 'UriEncoder');
initMetadataForCompanion(Companion_3);
initMetadataForClass(ConstructScalar, 'ConstructScalar');
initMetadataForClass(ConstructYamlNull, 'ConstructYamlNull', ConstructYamlNull);
initMetadataForClass(ConstructYamlBinary, 'ConstructYamlBinary', ConstructYamlBinary);
initMetadataForClass(ConstructYamlJsonBool, 'ConstructYamlJsonBool', ConstructYamlJsonBool);
initMetadataForClass(ConstructYamlJsonFloat, 'ConstructYamlJsonFloat', ConstructYamlJsonFloat);
initMetadataForClass(ConstructYamlJsonInt, 'ConstructYamlJsonInt', ConstructYamlJsonInt);
initMetadataForClass(ExpectStreamStart, 'ExpectStreamStart');
initMetadataForClass(ExpectNothing, 'ExpectNothing');
initMetadataForClass(ExpectFirstDocumentStart, 'ExpectFirstDocumentStart');
initMetadataForClass(ExpectDocumentStart, 'ExpectDocumentStart');
initMetadataForClass(ExpectDocumentEnd, 'ExpectDocumentEnd');
initMetadataForClass(ExpectDocumentRoot, 'ExpectDocumentRoot');
initMetadataForClass(ExpectFirstFlowSequenceItem, 'ExpectFirstFlowSequenceItem');
initMetadataForClass(ExpectFlowSequenceItem, 'ExpectFlowSequenceItem');
initMetadataForClass(ExpectFirstFlowMappingKey, 'ExpectFirstFlowMappingKey');
initMetadataForClass(ExpectFlowMappingKey, 'ExpectFlowMappingKey');
initMetadataForClass(ExpectFlowMappingSimpleValue, 'ExpectFlowMappingSimpleValue');
initMetadataForClass(ExpectFlowMappingValue, 'ExpectFlowMappingValue');
initMetadataForClass(ExpectFirstBlockSequenceItem, 'ExpectFirstBlockSequenceItem');
initMetadataForClass(ExpectBlockSequenceItem, 'ExpectBlockSequenceItem');
initMetadataForClass(ExpectFirstBlockMappingKey, 'ExpectFirstBlockMappingKey');
initMetadataForClass(ExpectBlockMappingKey, 'ExpectBlockMappingKey');
initMetadataForClass(ExpectBlockMappingSimpleValue, 'ExpectBlockMappingSimpleValue');
initMetadataForClass(ExpectBlockMappingValue, 'ExpectBlockMappingValue');
initMetadataForCompanion(Companion_4);
initMetadataForClass(Emitter, 'Emitter');
initMetadataForClass(ScalarAnalysis, 'ScalarAnalysis');
initMetadataForClass(Event, 'Event');
initMetadataForClass(NodeEvent, 'NodeEvent');
initMetadataForClass(AliasEvent, 'AliasEvent');
initMetadataForClass(CollectionEndEvent, 'CollectionEndEvent');
initMetadataForClass(CollectionStartEvent, 'CollectionStartEvent');
initMetadataForClass(CommentEvent, 'CommentEvent');
initMetadataForClass(DocumentEndEvent, 'DocumentEndEvent');
initMetadataForClass(DocumentStartEvent, 'DocumentStartEvent');
initMetadataForClass(ID, 'ID');
initMetadataForClass(ImplicitTuple, 'ImplicitTuple');
initMetadataForClass(MappingEndEvent, 'MappingEndEvent', MappingEndEvent.jdr);
initMetadataForClass(MappingStartEvent, 'MappingStartEvent');
initMetadataForClass(ScalarEvent, 'ScalarEvent');
initMetadataForClass(SequenceEndEvent, 'SequenceEndEvent', SequenceEndEvent.wdr);
initMetadataForClass(SequenceStartEvent, 'SequenceStartEvent');
initMetadataForClass(StreamEndEvent, 'StreamEndEvent', StreamEndEvent.hds);
initMetadataForClass(StreamStartEvent, 'StreamStartEvent', StreamStartEvent.lds);
initMetadataForClass(YamlEngineException, 'YamlEngineException');
initMetadataForClass(EmitterException, 'EmitterException');
initMetadataForCompanion(Companion_5);
initMetadataForClass(Mark, 'Mark');
initMetadataForCompanion(Companion_6);
initMetadataForClass(MarkedYamlEngineException, 'MarkedYamlEngineException');
initMetadataForClass(ParserException, 'ParserException');
initMetadataForClass(ReaderException, 'ReaderException');
initMetadataForClass(ScannerException, 'ScannerException');
initMetadataForClass(YamlVersionException, 'YamlVersionException');
initMetadataForObject(Character, 'Character');
initMetadataForCompanion(Companion_7);
initMetadataForClass(Tag, 'Tag');
initMetadataForClass(ParseStreamStart, 'ParseStreamStart');
initMetadataForClass(ParseImplicitDocumentStart, 'ParseImplicitDocumentStart');
initMetadataForClass(ParseDocumentStart, 'ParseDocumentStart');
initMetadataForClass(ParseDocumentEnd, 'ParseDocumentEnd');
initMetadataForClass(ParseDocumentContent, 'ParseDocumentContent');
initMetadataForClass(ParseBlockNode, 'ParseBlockNode');
initMetadataForClass(ParseBlockSequenceFirstEntry, 'ParseBlockSequenceFirstEntry');
initMetadataForClass(ParseBlockSequenceEntryKey, 'ParseBlockSequenceEntryKey');
initMetadataForClass(ParseBlockSequenceEntryValue, 'ParseBlockSequenceEntryValue');
initMetadataForClass(ParseIndentlessSequenceEntryKey, 'ParseIndentlessSequenceEntryKey');
initMetadataForClass(ParseIndentlessSequenceEntryValue, 'ParseIndentlessSequenceEntryValue');
initMetadataForClass(ParseBlockMappingFirstKey, 'ParseBlockMappingFirstKey');
initMetadataForClass(ParseBlockMappingKey, 'ParseBlockMappingKey');
initMetadataForClass(ParseBlockMappingValue, 'ParseBlockMappingValue');
initMetadataForClass(ParseBlockMappingValueComment, 'ParseBlockMappingValueComment');
initMetadataForClass(ParseBlockMappingValueCommentList, 'ParseBlockMappingValueCommentList');
initMetadataForClass(ParseFlowSequenceFirstEntry, 'ParseFlowSequenceFirstEntry');
initMetadataForClass(ParseFlowSequenceEntry, 'ParseFlowSequenceEntry');
initMetadataForClass(ParseFlowEndComment, 'ParseFlowEndComment');
initMetadataForClass(ParseFlowSequenceEntryMappingKey, 'ParseFlowSequenceEntryMappingKey');
initMetadataForClass(ParseFlowSequenceEntryMappingValue, 'ParseFlowSequenceEntryMappingValue');
initMetadataForClass(ParseFlowSequenceEntryMappingEnd, 'ParseFlowSequenceEntryMappingEnd');
initMetadataForClass(ParseFlowMappingFirstKey, 'ParseFlowMappingFirstKey');
initMetadataForClass(ParseFlowMappingKey, 'ParseFlowMappingKey');
initMetadataForClass(ParseFlowMappingValue, 'ParseFlowMappingValue');
initMetadataForClass(ParseFlowMappingEmptyValue, 'ParseFlowMappingEmptyValue');
initMetadataForCompanion(Companion_8);
initMetadataForClass(ParserImpl, 'ParserImpl');
initMetadataForClass(VersionTagsTuple, 'VersionTagsTuple');
initMetadataForClass(ImplicitResolversBuilder, 'ImplicitResolversBuilder', ImplicitResolversBuilder);
initMetadataForCompanion(Companion_9);
initMetadataForClass(BaseScalarResolver, 'BaseScalarResolver');
initMetadataForCompanion(Companion_10);
initMetadataForClass(JsonScalarResolver, 'JsonScalarResolver', JsonScalarResolver);
initMetadataForClass(ResolverTuple, 'ResolverTuple');
initMetadataForCompanion(Companion_11);
initMetadataForClass(ScannerImpl, 'ScannerImpl');
initMetadataForClass(Clip, 'Clip');
initMetadataForClass(Strip, 'Strip');
initMetadataForClass(Keep, 'Keep');
initMetadataForClass(BreakIntentHolder, 'BreakIntentHolder');
initMetadataForClass(SimpleKey, 'SimpleKey');
initMetadataForCompanion(Companion_12);
initMetadataForClass(StreamReader, 'StreamReader');
initMetadataForClass(JsonSchema, 'JsonSchema', JsonSchema);
initMetadataForClass(NumberAnchorGenerator, 'NumberAnchorGenerator', NumberAnchorGenerator);
initMetadataForClass(Token, 'Token');
initMetadataForClass(AliasToken, 'AliasToken');
initMetadataForClass(AnchorToken, 'AnchorToken');
initMetadataForClass(BlockEndToken, 'BlockEndToken');
initMetadataForClass(BlockEntryToken, 'BlockEntryToken');
initMetadataForClass(BlockMappingStartToken, 'BlockMappingStartToken');
initMetadataForClass(BlockSequenceStartToken, 'BlockSequenceStartToken');
initMetadataForClass(CommentToken, 'CommentToken');
initMetadataForClass(YamlDirective, 'YamlDirective');
initMetadataForClass(TagDirective, 'TagDirective');
initMetadataForCompanion(Companion_13);
initMetadataForClass(DirectiveToken, 'DirectiveToken');
initMetadataForClass(DocumentEndToken, 'DocumentEndToken');
initMetadataForClass(DocumentStartToken, 'DocumentStartToken');
initMetadataForClass(FlowEntryToken, 'FlowEntryToken');
initMetadataForClass(FlowMappingEndToken, 'FlowMappingEndToken');
initMetadataForClass(FlowMappingStartToken, 'FlowMappingStartToken');
initMetadataForClass(FlowSequenceEndToken, 'FlowSequenceEndToken');
initMetadataForClass(FlowSequenceStartToken, 'FlowSequenceStartToken');
initMetadataForClass(KeyToken, 'KeyToken');
initMetadataForClass(ScalarToken, 'ScalarToken');
initMetadataForClass(StreamEndToken, 'StreamEndToken');
initMetadataForClass(StreamStartToken, 'StreamStartToken');
initMetadataForClass(TagToken, 'TagToken');
initMetadataForClass(TagTuple, 'TagTuple');
initMetadataForClass(ID_0, 'ID');
initMetadataForClass(ValueToken, 'ValueToken');
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
UriEncoder_instance = new UriEncoder();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
//endregion
//region block: exports
export {
  CommentType_BLOCK_getInstance as CommentType_BLOCK_getInstance1y622ny5jaxzl,
  FlowStyle_BLOCK_getInstance as FlowStyle_BLOCK_getInstance2cmcgl68iyrit,
  FlowStyle_FLOW_getInstance as FlowStyle_FLOW_getInstance2z6lpgfr3ei4u,
  ScalarStyle_DOUBLE_QUOTED_getInstance as ScalarStyle_DOUBLE_QUOTED_getInstance2xzzd54rqi0xo,
  ScalarStyle_LITERAL_getInstance as ScalarStyle_LITERAL_getInstance2e18nzmfjlkw0,
  ScalarStyle_PLAIN_getInstance as ScalarStyle_PLAIN_getInstance1qxa2fn26s70,
  ScalarStyle_SINGLE_QUOTED_getInstance as ScalarStyle_SINGLE_QUOTED_getInstance3q0lylgqm93qn,
  ID_DocumentEnd_getInstance as ID_DocumentEnd_getInstance1lnckvi2jzakq,
  ID_DocumentStart_getInstance as ID_DocumentStart_getInstanceukn405q5ykqt,
  ID_MappingEnd_getInstance as ID_MappingEnd_getInstance3oeh8or6dnpbq,
  ID_Scalar_getInstance as ID_Scalar_getInstanceh2aagh7mrmog,
  ID_SequenceEnd_getInstance as ID_SequenceEnd_getInstanceb13eoodp77ng,
  ID_StreamEnd_getInstance as ID_StreamEnd_getInstance3qhqjqxk61lxm,
  ID_StreamStart_getInstance as ID_StreamStart_getInstance2p0sinvtx3c21,
  Companion_instance as Companion_instance3eslhq1ib5vcs,
  Companion_instance_0 as Companion_instance31eh1xd51bs0b,
  StreamDataWriter as StreamDataWriter22wnutt6wwhrc,
  Emitter as Emitter2x4oouz03mc86,
  AliasEvent as AliasEvent18arfb3x5sd0q,
  CommentEvent as CommentEvent3en0kmzv7bnjy,
  DocumentEndEvent as DocumentEndEvent3ar4xivn3l8hu,
  DocumentStartEvent as DocumentStartEvent3czq54u492q97,
  ImplicitTuple as ImplicitTuple2t3yly3nn5jjs,
  MappingEndEvent as MappingEndEvent9dqshhk3o3ws,
  MappingStartEvent as MappingStartEvent1lr1mcqmcpbry,
  NodeEvent as NodeEvent1xqamwd0s6axm,
  ScalarEvent as ScalarEvent1tfmd4lt1nu9c,
  SequenceEndEvent as SequenceEndEvent2iybmagh9ma3o,
  SequenceStartEvent as SequenceStartEvent27qj1ypmim9wn,
  StreamEndEvent as StreamEndEvent3qera3kv81k33,
  StreamStartEvent as StreamStartEventyoou3t7h4s0x,
  MarkedYamlEngineException as MarkedYamlEngineExceptionra3nsv6mim88,
  ParserImpl as ParserImpl2xms7a4twiiy,
  StreamReader as StreamReader2jtln3s95380r,
};
//endregion
